(function() {
  'use strict';

  angular
    .module('embarazoAdolecente', ['restangular', 'ui.router', 'toastr','ngDialog']);

})();

(function() {
  'use strict';

  angular
      .module('embarazoAdolecente')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Stylus',
        'url': 'http://learnboost.github.io/stylus/',
        'description': 'Stylus is a revolutionary new language, providing an efficient, dynamic, and expressive way to generate CSS. Supporting both an indented syntax and regular CSS style.',
        'logo': 'stylus.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('videoSection', video);

    /** @ngInject */
    function video() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/video/video.tpl',
        scope: {
            color: '=',            
            texto: '=',
            autor: '=',
            video: '=',
            thumbnail: '=',
            onlyvideo: '='
        },
        controller: videoController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function videoController($rootScope,$scope,$timeout,$window) {
        var vm = this;  
        vm.showTexto = true;
        if(vm.onlyvideo != undefined){
            vm.showTexto = false;
        }        
        vm.videoPlay = false;   
        var tag = document.createElement('script'); 
        tag.src = "//www.youtube.com/iframe_api"; 
        var firstScriptTag = document.getElementsByTagName('script')[0];  
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);        
        var player;

        $window.onYouTubeIframeAPIReady = function() {            
            player = new YT.Player('player', {
                height: '244',
                width: '434',
                videoId: vm.video,  // youtube video id
                playerVars: {
                    'autoplay': 0,
                    'rel': 0,
                    'showinfo': 0,
                    'controls':0,
                    'modestbranding':1,
                },
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
        }

        var p = document.getElementById ("player");
        $(p).hide();

        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
                $('.start-video').fadeIn('normal');
            }
        }

        $(document).on('click', '.start-video', function () {
            $(this).hide();
            $("#player").show();
            $("#thumbnail_container").hide();
            player.playVideo();
        });

        $(document).on('click', '#thumbnail .mask', function () {    
            console.log($(this).closest('.video'));
            $(this).closest('.video').find(".start-video").hide();
            $("#player").show();
            $("#thumbnail_container").hide();
            player.playVideo();
        });
      }   
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('scatterEvaluacion', scatterEvaluacion);

  /** @ngInject */
  function scatterEvaluacion() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/scatterEvaluacion/scatterEvaluacion.tpl',
      scope: {
          evaluaciones: '=',
          programas: '=',
          data: '=',
          json: '=',
      },
      controller: scatterEvaluacionController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function scatterEvaluacionController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.datos_scatter = [];
      vm.evaluacion = vm.evaluaciones[0];
      vm.programaSelected = "";
      vm.pageWidth = $(window).width();
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = '';
      //vm.state2 = 'Nivel nacional';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.dataState = [];
      vm.mapScale = 1.60;
      if(vm.pageWidth <= 480){        
        mapRatio = .63;
        vm.mapScale = 1.90;

      }
      vm.totales = function(item){
        if(vm.evaluacion != null){
          return item.key === vm.evaluacion.cve;
        }else{
          return "";
        }
      }
      vm.subtotal = function(item){
        return item.programa != 'Subtotal';
      }
      vm.verEvaluacion = function(eva){
        vm.evaluacion = eva;        
      }

      vm.tip = d3.tip().attr('class', 'd3-tip scatter-tip').html(function(d) {
        return "<h3>"+d.name+"</h3><h4>"+d.value+"</h4>";
      });

      /*Obtener nombres de estados*/
      vm.states = $.map(vm.programas, function(element,index) {return index});
      vm.drawScatter = function(){        
        if(vm.datos_scatter.length > 0){
          var dt = [];
          $.each(vm.datos_scatter[0].values[0],function(index,value){
            if(["clave","programa","IDEAL"].indexOf(index) == -1){
              dt.push({title:index,value:parseFloat(value)});
            }
          });
          var w = $("#scatter").width(), h = 350,margin = {top:20,right:50,bottom:20,left:50,};
          var container = d3.select("#scatter");
          container.selectAll("svg").remove();
          var svg = container.append("svg").attr({"width":w,"height":h,"id":"svg-scatter"}).call(vm.tip),
            yScale = d3.scale.linear(),
            xScale = d3.scale.ordinal(),
            xScale_estados = d3.scale.ordinal(),
            xAxis = d3.svg.axis(),
              data = dt,
              axisWidth = (w-margin.left-margin.right)/data.length,
              axisW_estados = (w-margin.left-margin.right)/vm.states.length;

          xScale.domain(data.map(function(d) {return d.title}))
            .range(data.map(function(d,i){return i * axisWidth;}));

          xScale_estados.domain(vm.states.map(function(d) {return d}))
            .range(data.map(function(d,i){return i * axisW_estados;}));

          yScale.domain([0,10])
              .range([h-50,50]);

          var yAxis = d3.svg.axis().scale(yScale)
            .orient("left").ticks(11);

          xAxis.scale(xScale_estados);
          svg.append("g")
            .attr("transform","translate(75,10)")
            .selectAll("circle")
            .data(data)
            .enter().append("circle")
            .attr("r",6)
            .attr("cx", function(d){ return xScale(d.title); })
            .attr("cy", function(d){return yScale(d.value);}) // this should change to yAxis(d.a) when you make a y axis
            .style("fill", function(d){                
                return vm.getColor(d.value);
              })
            .classed('active',function(d){              
              return d.title == 'G1';
            })
            /*.on("mouseover",function(d){
              var p = vm.list_programas.filter(function(t){
                return t.cve == d.title;
              })[0]
              p.value = d.value;
              vm.tip.show(p);
            })
            .on("mouseleave",function(d){
              vm.tip.hide();
            })*/
            .on("click",function(d){
              svg.selectAll("circle").classed("active",false);
              d3.select(this).classed("active",true);
              var p = vm.list_programas.filter(function(t){
                return t.cve == d.title;
              })[0]
              p.value = d.value;
              vm.tip.show(p);
              $timeout(function(){                
                vm.programaSelected = p;                
              });
              var target = $("#detail");              
              if( target.length ) {                
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 500);
              }
              //$("html, body").animate({ scrollTop: $(document).height() }, 1000);
            })

          // gridlines in x axis function
          /*function make_x_gridlines() {   
            return d3.svg.axis().scale(xScale)
              .orient("bottom").ticks(5);
          }*/

          svg.append("g")
            .attr("transform","translate(155,"+(h-30)+")")
            .attr("class", "x axis")
            .call(xAxis)

          svg.append("g")
            .attr("transform","translate(60,10)")
            .attr("class", "y axis")
            .call(yAxis);

          // add the X gridlines
          /*svg.append("g")     
              .attr("class", "grid")
              .attr("transform", "translate(75," + w + ")")
              .call(make_x_gridlines()
                  .tickSize(-w)
                  .tickFormat("")
              )

          d3.selectAll(".grid g.tick line")
            .style("opacity", function(d){
              console.log(d);
            //d for the tick line is the value
            //of that tick 
            //(a number between 0 and 1, in this case)
               if ( ["G3","M3","P4","Q2","V2"].indexOf(d) != -1 ) //if it's an even multiple of 10%
                   return 1;
               else
                   return 0;
            });*/

          var ticks = d3.selectAll(".y.axis .tick text");

          ticks.attr("fill", function(d,i){
            return vm.getColor(d);
          });

          svg.append("line")
            .attr("stroke","#000")
            .attr("transform","translate(50,0)")
            .attr({"x1":xScale("G1"),y1:(h-30),"x2":xScale("V2")+40,y2:(h-30)})

          svg.append("text")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate("+ 20 +","+(h/2)+")rotate(-90)")  // text is drawn off the screen top left, move down and out and rotate
            .style({fill:"#D8CCD4","font-size":"14px"})
            .text("EVALUACIÓN DE PROGRAMAS");
        }

      }

      vm.getColor = function(d){
        var c = "#73C59F";
        if(d < 8){
          c = "#FFD56D";
        }
        if(d < 6){
          c = "#E00F0F";
        }
        return c;              
      }
      
      vm.getVal = function(cve){
        var val = 0;
        $.each(vm.data,function(index,value){
          if(value.key == cve){
            val = value.values[value.values.length-1][vm.programaSelected.cve];
          }
        });
        return val;
      }

      function crearMapaEstados(){
        d3.select('#map svg').remove();
        var width = parseInt(d3.select('#map').style('width'))
          , width = width - margin.left - margin.right
          , height = width * mapRatio;

        /*var colores = d3.scale.linear()
          .range(["#D7CDD5","#400130"])
          .domain([0,d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); })])*/

        /*var arr = vm.data.map(function(d) { return +d.values[d.values.length-1].porcentaje; });
        if(arr.length == 0){
          arr = [6.1170212766, 6.2317750146, 6.9762274655, 7.4900193564, 7.850588505, 8.0751166882, 8.5588738348, 9.0809164914, 9.3798508598, 10.1769301923];
        }else{
          arr = ss.jenks(arr, 9);
          var max = d3.max(arr, function(d) { return d; });
          arr.push(max+1);
        }*/
        var arr = ss.jenks([6.1170212766,6.9762274655,7.9803637212,8.5588738348,9.3798508598,10.1769301923,11.1769301923,0,3.7195644194,6.8417928169,10.2660300136,15.7024793388,25.9259259259,26.9259259259],7)
        var colores = d3.scale.threshold()
          .domain(arr)
          .range(d3.range(11).map(function(i) { return "q" + i; }));

        //console.log(d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); }));

        projection = d3.geo.conicConformal()
            .rotate([102, 0])
            .center([0, 24])
            .parallels([17.5, 29.5])
            .scale(width*vm.mapScale)
            .translate([width / 2, height / 2]);

        path = d3.geo.path()
            .projection(projection);
        d3.select("#map svg").remove();
        svg = d3.select("#map").append("svg")
            .attr("width", width)
            .attr("height", height);

        d3.json("assets/data/mx_tj.json", function(error, mx) {
          if (error) throw error;

          var g = svg.append("g")
              .attr("class", "estados");

          g.selectAll("path")
              .data(topojson.feature(mx, mx.objects.states).features)
            .enter().append("path")
              .attr("d", path)
              .attr('class', function(d){
                if([30,23,11,21,17].indexOf(d.properties.state_code)!=-1){
                  return 'estado ' +colores(parseFloat(vm.dataMap[d.properties.state_code-1].values[vm.dataMap[d.properties.state_code-1].values.length-1].porcentaje));
                }else{
                  return "estado null";
                }
              })
              .on("click",cargarProgramas)
              /*.attr("fill",function(d){
                return colores(parseFloat(vm.data[d.properties.state_code-1].values[vm.data[d.properties.state_code-1].values.length-1].porcentaje));
              })*/
            .append("title")
              .text(function(d) { return d.properties.name; })

          /*svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state !== b.properties.state; }))
              .attr("class", "state-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });

          svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state === b.properties.state && a !== b; }))
              .attr("class", "municipality-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });*/
        });

        d3.select(self.frameElement).style("height", height + "px");
      }

      function cargarProgramas(d){
        var state_code = d.properties.state_code;
        if([30,23,11,21,17].indexOf(state_code)!=-1){
          d3.selectAll(".estados .estado").classed("active",function(d){
            return d.properties.state_code == state_code;
          })
          $timeout(function(){
            vm.state = d.properties.state_name;//+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
            vm.programaSelected = "";
          });
        }

      }

      vm.clearFields = function(){
        console.log(vm.programas[vm.state])
        vm.programaSelected = vm.programas[vm.state][0];
        vm.programaSelected.value = vm.datos_scatter[0].values[0][vm.programaSelected.cve];
      }

      vm.mostrarDetalle = function(){        
        if(vm.datos_scatter[0] != undefined){          
          vm.programaSelected.value = vm.datos_scatter[0].values[0][vm.programaSelected.cve];
        }
      }

      
      $scope.$watch("vm.data",function(data){
        vm.datos_scatter = data.filter(function(d) {
          return d.key == "total_programa";
        });
        vm.list_programas = $.map(vm.programas, function(element,index) {return $.map(element, function(e,i){return e; })});
        if(vm.pageWidth > 480){
          vm.drawScatter();
        }
        if(vm.datos_scatter.length > 0){
          $timeout(function(){            
            vm.state = "Guanajuato";
            var p = vm.list_programas.filter(function(t){
              return t.cve == 'G1';
            })[0]
            p.value = vm.datos_scatter[0].values[0]['G1'];              
            vm.programaSelected = p;                         
                       
          })


          
        }
      },true);
      
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('piechart', piechart);

    /** @ngInject */
    function piechart() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/piechart/piechart.tpl',
        scope: {
            data: '=',            
        },
        controller: piechartController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function piechartController($rootScope,$scope,$timeout) {
        var vm = this;        
        // Create the chart
        Highcharts.chart('piechart', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                backgroundColor:'rgba(255, 255, 255, 0.0)',
                style: {
                  fontFamily: 'Open Sans'
                }
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 0
            },
            legend: {
                enabled: true,
                align:'right',
                verticalAlign: 'middle',
                borderColor:'gray',
                borderWidth:'1',
                layout: 'vertical',
                padding: 20,
                itemMarginTop:10,
                itemMarginBottom: 10,
                itemStyle: {
                    lineHeight: '14px'
                }
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: 'Brands',
                colorByPoint: true,
                data: vm.data
            }]
        });
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('narrativa', narrativa)
    
    /** @ngInject */
    function narrativa() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/narrativa/narrativaComponent.html',
        scope: {
            color: '=',
            state : '=',
            resumen : '=',
            video : '=',
            portada : '=',
            inverse : '=',
            link:'='
        },
        controller: narrativaController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function narrativaController($rootScope,$scope,$timeout,ngDialog) {
        var vm = this;                
        vm.showVideo = function(v){
          $scope.video = "https://www.youtube.com/embed/"+v+"?controls=0";
          ngDialog.open({ 
            template: 'app/components/narrativa/videoTmpl.html', 
            className: 'ngdialog-theme-default video-dialog',
            scope : $scope,
            controller : ['$scope','$sce', function($scope,$sce) {
              // controller logic              
              $scope.video = $sce.trustAsResourceUrl($scope.video);              
            }]
          });
        }
      }
    }

   
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaServiciosMedicos', mapaServiciosMedicos);

  /** @ngInject */
  function mapaServiciosMedicos() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaserviciosmedicos/accesoServiciosMedicos.tpl',
      scope: {          
          servicios : '=',
          tipos : '=',
      },
      controller: mapaServiciosMedicosController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaServiciosMedicosController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = 'Nacional';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.por_sin_hijos = '';
      vm.por_con_hijos = '';
      vm.tiposServicio = [];
      vm.serviciosPercentage = [];
      vm.itemWidth = 250;
      vm.mapScale = 1.60;
      vm.stateSelected = "República Mexicana";
      vm.state_codeSelected = 0;
      vm.yearSelected = 
      vm.colors = {
        "IMSS":"#770DB4",
        "ISSSTE":"#FF802D",
        "ISSSTE estatal":"#3DA5D9",
        "Seguro Popular":"#FA4288",
        "Pemex, Defensa o Marina":"#ED6A5A",
        "Institución privada":"#4A4A4A",
        "Otra institución":"#73C59F",
      }
      if($(window).width()<=480){
        vm.itemWidth = 150;
        mapRatio = .63;
        vm.mapScale = 1.90;
      }

      vm.tip = d3.tip().attr('class', 'd3-tip').html(function(d) {
        return "<h3>"+d.label+"</h3><h2>"+d.value.toFixed(0)+"%</h2>";
      });      

      vm.mostrarPorcentajes = function(d){        
        var state_code = d.state_code;
        /*d3.selectAll(".estados .estado").classed("active",function(d){
          return d.properties.state_code == state_code;
        });*/
        $timeout(function(){
          //vm.state = d.properties.state_name+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
          vm.stateSelected = d.state_name;
          vm.state_codeSelected = d.state_code;
        });
        vm.por_con_hijos = vm.serviciosPercentageYear.values[state_code].porcentaje_con_hijos_acceso;
        vm.por_sin_hijos = vm.serviciosPercentageYear.values[state_code].porcentaje_sin_hijos_acceso;
        vm.series = [];
        $.each(vm.tiposServicioYear.values[state_code].values,function(i,v){
            vm.series.push({name:v.tipo,data: [parseFloat(v.con_hijos),parseFloat(v.sin_hijos)],color:vm.colors[v.tipo]});
        });
        vm.series.sort(function(a,b){
          return a.data[0] - b.data[0];
        })
        $('#chartInstituciones').highcharts({
            chart: {
                type: 'bar'
            },
            title: {
                text: 'Porcentaje de acceso a servicios médicos de mujeres adolescentes'
            },
            xAxis: {
                categories: ['Con hijas e hijos','Sin hijas e hijos']
            },
            yAxis: {
                min: 0,
                max:100,
                title: {
                    text: ''
                }
            },
            legend: {
                reversed: true,
                itemWidth: vm.itemWidth,
                margin:40
            },
            credits: {
              enabled: false
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            exporting: {
              enabled: false
            },
            series: vm.series
        });
      }      

      $scope.$watch("vm.tipos",function(data){
        vm.tiposServicio = d3.nest()
            .key(function(d) { return d.year; })
            .key(function(d) { return d.state_code; })
            .entries(angular.copy(data));

        vm.series = [];
        if(vm.tiposServicio.length > 0){
          vm.tiposServicioYear = vm.tiposServicio[0];
          $.each(vm.tiposServicioYear.values[0].values,function(i,v){
            vm.series.push({name:v.tipo,data: [parseFloat(v.con_hijos),parseFloat(v.sin_hijos)],color:vm.colors[v.tipo]});
          });
          vm.series.sort(function(a,b){
            return a.data[0] - b.data[0];
          });
          $('#chartInstituciones').highcharts({
              chart: {
                  type: 'bar',
                  style: {
                    fontFamily: 'Open Sans'
                  }
              },
              title: {
                  text: 'Porcentaje de acceso a servicios médicos de mujeres adolescentes',
              },
              xAxis: {
                  categories: ['Con hijas e hijos','Sin hijas e hijos']
              },
              yAxis: {
                  min: 0,
                  max:100,
                  title: {
                      text: ''
                  }
              },
              tooltip: {
                formatter: function() {
                  if($(window).width() <= 480){
                    return '<b>'+this.x+'</b><br><b>'+this.y +'</b>';
                  }else{
                    return '<b>'+this.x +':</b><br/>'+this.series.name +' <b>'+ this.y+'</b>';

                  }
                },
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 1
              },
              legend: {
                  reversed: true,
                  itemWidth: vm.itemWidth
              },
              credits: {
                enabled: false
              },
              plotOptions: {
                  series: {
                      stacking: 'normal'
                  }
              },
              exporting: {
                enabled: false
              },
              series: vm.series
          });
        }
      },true);


      $scope.$watch("vm.servicios",function(data){         
        if(data.length > 0){          
          vm.serviciosPercentage = d3.nest()
            .key(function(d) { return d.year; })            
            .entries(angular.copy(data));
          vm.serviciosPercentageYear = vm.serviciosPercentage[0];
          vm.por_sin_hijos = vm.serviciosPercentageYear.values[0].porcentaje_con_hijos_acceso;
          vm.por_con_hijos = vm.serviciosPercentageYear.values[0].porcentaje_sin_hijos_acceso;
        }
      },true);

      vm.updateData = function(i){
        $timeout(function(){                  
          vm.serviciosPercentageYear = vm.serviciosPercentage[i];  
          vm.tiposServicioYear = vm.tiposServicio[i];
          vm.mostrarPorcentajes({state_code:vm.state_codeSelected,state_name:vm.stateSelected});
        })
      }




    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaPresupuestoGasto', mapaPresupuestoGasto);

  /** @ngInject */
  function mapaPresupuestoGasto() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaPresupuestoGasto/mapaPresupuestoGasto.tpl',
      scope: {
          json: '=',
          presupuesto: '=',
          gasto: '='
      },
      controller: mapaPresupuestoGastoController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaPresupuestoGastoController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = '';
      //vm.state2 = 'Nivel nacional';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.dataState = [];
      vm.stateSelected = 'México';
      var color_scale = d3.scale.category10();      
      vm.mapScale = 1.60;
      if($(window).width() < 480){
        mapRatio = .63;
        vm.mapScale = 1.90;
      }      

      vm.mostrarBarchart = function(d){        
        var state_code = d.state_code;   
        $timeout(function(){
          vm.stateSelected = d.state_name;//+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
          //vm.state2 = d.properties.state_name;
        });
        vm.dataState = vm.presupuesto.filter(function(v){
          return v.key == state_code;
        })[0];        
        vm.dataState2 = vm.gasto.filter(function(v){
          return v.key == state_code;
        })[0];
        crearBarchart();
        
      }

      function crearBarchart(){
        if(vm.dataState.values){
          var series = [];
          var series2 = [];
          angular.forEach(vm.dataState.values[0].values[0], function(v,k){
            if(["clave","estado","programa"].indexOf(k) == -1){
              series.push({name:k,data:[],color:color_scale(k)});
            }
          });
          var cat = vm.dataState.values.map(function(d){ return d.key});
          $.each(vm.dataState.values,function(index,value){
            $.each(value.values,function(i,v){
              angular.forEach(series,function(a,b){
                a.data.push(parseFloat(v[a.name]))
              })
              //series[0].data.push(parseFloat(v[2010]));
              //series[1].data.push(parseFloat(v[2015]));
            });
          });
          $('#c-presupuesto').highcharts({
            chart: {
                type: 'column',
                style: {
                  fontFamily: 'Open Sans'
                }
            },
            title: {
                text: 'Presupuesto para prevención'
            },
            xAxis: {
                categories: cat,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'PESOS MEXICANOS'
                },
                labels: {
                  format: '${value}'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b> ${point.y:,.1f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 0
            },
            plotOptions: {
                column: {
                    pointPadding: 0,
                    borderWidth: 0
                }
            },
            credits: {
              enabled: false
            },

            exporting: {
              enabled: false
            },
            series: series
          });

          angular.forEach(vm.dataState2.values[0].values[0], function(v,k){
            if(["clave","estado","programa"].indexOf(k) == -1){
              series2.push({name:k,data:[],color:color_scale(k)});
            }
          });
          var cat2 = vm.dataState2.values.map(function(d){ return d.key});
          $.each(vm.dataState2.values,function(index,value){
            $.each(value.values,function(i,v){
              angular.forEach(series2,function(a,b){
                a.data.push(parseFloat(v[a.name]))
              })
              //series[0].data.push(parseFloat(v[2010]));
              //series[1].data.push(parseFloat(v[2015]));
            });
          });

          $('#c-gasto').highcharts({
            chart: {
                type: 'column',
                style: {
                  fontFamily: 'Open Sans'
                }
            },
            title: {
                text: 'Gasto en prevención por adolescente'
            },
            xAxis: {
                categories: cat2,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'PESOS MEXICANOS'
                },
                labels: {
                  format: '${value}'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b> ${point.y:.1f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 0
            },
            plotOptions: {
                column: {
                    pointPadding: 0,
                    borderWidth: 0
                }
            },
            credits: {
              enabled: false
            },

            exporting: {
              enabled: false
            },
            series: series2
          });
        }
      }

      /*d3.select(window).on('resize', resize);

      function resize() {
          // adjust things when the window size changes
          width = parseInt(d3.select('#map').style('width'));
          width = width - margin.left - margin.right;
          height = width * mapRatio;

          // update projection
          projection
              .translate([width / 2, height / 2])
              .scale(width*1.6);

          // resize the map container
          svg
              .style('width', width + 'px')
              .style('height', height + 'px');

          // resize the map
          svg.selectAll('.estado').attr('d', path);
      }*/

      vm.validate = [];

      $scope.$watch("vm.presupuesto",function(data){     
        if(data.length > 0){
          $(".treemaps-container .dropdown-menu li").css({"display":"none"});  
          angular.forEach(data,function(v,i){                      
            if(vm.validate.indexOf(v.key) == -1){
              $(".treemaps-container .dropdown-menu li#edo_"+v.key).css({"display":"block"});  
            }
          })
          if(vm.gasto.length > 0){
            $timeout(function(){
              $(".treemaps-container .dropdown-menu li[style='display: block;']").first().trigger("click");   
            });  
          }                    
        }                   
      },true);      
      $scope.$watch("vm.gasto",function(data){     
        if(data.length > 0){          
          if(vm.presupuesto.length > 0){
            $timeout(function(){
              $(".treemaps-container .dropdown-menu li[style='display: block;']").first().trigger("click");   
            });  
          }                    
        }                   
      },true);      
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaPresupuesto', mapaPresupuesto);

  /** @ngInject */
  function mapaPresupuesto() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaPresupuesto/mapaPresupuesto.tpl',
      scope: {
          json: '=',
          presupuesto: '=',
      },
      controller: mapaPresupuestoController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaPresupuestoController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = '';
      //vm.state2 = 'Nivel nacional';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.dataState = [];
      var color_scale = d3.scale.category10();
      vm.tip = d3.tip().attr('class', 'd3-tip').html(function(d) {
        return "<h3>"+d.actividad+"</h3><h4>"+d.adolescentes+"</h4><h2>"+d.value.toFixed(2)+"%</h2>";
      });

      vm.mapScale = 1.60;
      if($(window).width() < 480){
        mapRatio = .63;
        vm.mapScale = 1.90;
      }

      function crearMapaEstados(){
        d3.select('#map svg').remove();
        var width = parseInt(d3.select('#map').style('width'))
          , width = width - margin.left - margin.right
          , height = width * mapRatio;

        /*var colores = d3.scale.linear()
          .range(["#D7CDD5","#400130"])
          .domain([0,d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); })])*/

        /*var arr = vm.data.map(function(d) { return +d.values[d.values.length-1].porcentaje; });
        if(arr.length == 0){
          arr = [6.1170212766, 6.2317750146, 6.9762274655, 7.4900193564, 7.850588505, 8.0751166882, 8.5588738348, 9.0809164914, 9.3798508598, 10.1769301923];
        }else{
          arr = ss.jenks(arr, 9);
          var max = d3.max(arr, function(d) { return d; });
          arr.push(max+1);
        }*/
        var arr = ss.jenks([6.1170212766,6.9762274655,7.9803637212,8.5588738348,9.3798508598,10.1769301923,11.1769301923,0,3.7195644194,6.8417928169,10.2660300136,15.7024793388,25.9259259259,26.9259259259],7)
        var colores = d3.scale.threshold()
          .domain(arr)
          .range(d3.range(11).map(function(i) { return "q" + i; }));

        //console.log(d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); }));

        projection = d3.geo.conicConformal()
            .rotate([102, 0])
            .center([0, 24])
            .parallels([17.5, 29.5])
            .scale(width*vm.mapScale)
            .translate([width / 2, height / 2]);

        path = d3.geo.path()
            .projection(projection);
        d3.select("#map svg").remove();
        svg = d3.select("#map").append("svg")
            .attr("width", width)
            .attr("height", height);

        d3.json("assets/data/mx_tj.json", function(error, mx) {
          if (error) throw error;

          var g = svg.append("g")
              .attr("class", "estados");

          g.selectAll("path")
              .data(topojson.feature(mx, mx.objects.states).features)
            .enter().append("path")
              .attr("d", path)
              .attr('class', function(d){
                if([30,23,11,21,17].indexOf(d.properties.state_code)!=-1){
                  return 'estado ' +colores(parseFloat(vm.data[d.properties.state_code-1].values[vm.data[d.properties.state_code-1].values.length-1].porcentaje));
                }else{
                  return "estado null";
                }
              })
              .on("click",mostrarBarchart)
              /*.attr("fill",function(d){
                return colores(parseFloat(vm.data[d.properties.state_code-1].values[vm.data[d.properties.state_code-1].values.length-1].porcentaje));
              })*/
            .append("title")
              .text(function(d) { return d.properties.name; })

          /*svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state !== b.properties.state; }))
              .attr("class", "state-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });

          svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state === b.properties.state && a !== b; }))
              .attr("class", "municipality-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });*/
        });

        d3.select(self.frameElement).style("height", height + "px");
      }

      function mostrarBarchart(d){
        var state_code = d.properties.state_code;
        if([30,23,11,21,17].indexOf(state_code)!=-1){
          d3.selectAll(".estados .estado").classed("active",function(d){
            return d.properties.state_code == state_code;
          })
          $timeout(function(){
            vm.state = d.properties.state_name;//+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
            //vm.state2 = d.properties.state_name;
          });
          vm.dataState = vm.presupuesto.filter(function(v){
            return v.key == state_code;
          })[0];
          crearBarchart();
        }
      }

      function crearBarchart(){
        if(vm.dataState.values){
          var series = [];
          angular.forEach(vm.dataState.values[0].values[0], function(v,k){
            if(["clave","estado","programa"].indexOf(k) == -1){
              series.push({name:k,data:[],color:color_scale(k)});
            }
          });
          var cat = vm.dataState.values.map(function(d){ return d.key});
          $.each(vm.dataState.values,function(index,value){
            $.each(value.values,function(i,v){
              angular.forEach(series,function(a,b){
                a.data.push(parseFloat(v[a.name]))
              })
              //series[0].data.push(parseFloat(v[2010]));
              //series[1].data.push(parseFloat(v[2015]));
            });
          });
          $('.barchart-container').highcharts({
            chart: {
                type: 'column'
            },
            title: {
                text: ' '
            },
            xAxis: {
                categories: cat,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'PESOS MEXICANOS'
                },
                labels: {
                  format: '${value}'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b> ${point.y:.1f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0,
                    borderWidth: 0
                }
            },
            credits: {
              enabled: false
            },

            exporting: {
              enabled: false
            },
            series: series
          });
        }
      }

      d3.select(window).on('resize', resize);

      function resize() {
          // adjust things when the window size changes
          width = parseInt(d3.select('#map').style('width'));
          width = width - margin.left - margin.right;
          height = width * mapRatio;

          // update projection
          projection
              .translate([width / 2, height / 2])
              .scale(width*1.6);

          // resize the map container
          svg
              .style('width', width + 'px')
              .style('height', height + 'px');

          // resize the map
          svg.selectAll('.estado').attr('d', path);
      }

      $scope.$watch("vm.json",function(data){
        vm.data = d3.nest()
            .key(function(d) { return d.cve_ent; })
            .entries(data);
        if(vm.data.length > 0){
          crearMapaEstados();
          crearBarchart();
        }
      },true);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaMunicipios', mapaMunicipios);

  /** @ngInject */
  function mapaMunicipios() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaMunicipios/municipios.tpl',
      scope: {
          json: '=',
      },
      controller: mapaMunicipiosController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaMunicipiosController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.nacional = '8.04';
      vm.stateName = 'Aguascalientes';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.pageWidth = $(window).width();
      vm.estados = [];
      vm.municipios = [];
      vm.stateSelected = 0;
      vm.mapScale = 1.60;
      vm.municipioSelect = "Selecciona un municipio";      
      if(vm.pageWidth < 480){
        mapRatio = .63;
        vm.mapScale = 1.90;
      }
      /*Trigger click*/
      var e = document.createEvent('UIEvents');
      e.initUIEvent('click', true, true, window, 1);

      function crearMapaEstados(){
        d3.select('#map svg').remove();
        var width = parseInt(d3.select('#map').style('width'))
          , width = width - margin.left - margin.right
          , height = width * mapRatio;

        /*var colores = d3.scale.linear()
          .range(["#D7CDD5","#400130"])
          .domain([0,d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); })])*/

        /*var arr = vm.data.map(function(d) { return +d.values[d.values.length-1].porcentaje; });
        if(arr.length == 0){
          arr = [6.1170212766, 6.2317750146, 6.9762274655, 7.4900193564, 7.850588505, 8.0751166882, 8.5588738348, 9.0809164914, 9.3798508598, 10.1769301923];
        }else{
          arr = ss.jenks(arr, 5);
          var max = d3.max(arr, function(d) { return d; });
          arr.push(max+1);
        }*/
        var arr = ss.jenks([6.1170212766,6.9762274655,7.9803637212,8.5588738348,9.3798508598,10.1769301923,11.1769301923,0,3.7195644194,6.8417928169,10.2660300136,15.7024793388,25.9259259259,26.9259259259],7)
        vm.colores = d3.scale.threshold()
          .domain(arr)
          .range(d3.range(9).map(function(i) { return "q" + i; }));


        //console.log(d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); }));

        projection = d3.geo.conicConformal()
            .rotate([102, 0])
            .center([0, 24])
            .parallels([17.5, 29.5])
            .scale(width*vm.mapScale)
            .translate([width / 2, height / 2]);

        path = d3.geo.path()
            .projection(projection);
        d3.select("#map svg").remove();
        svg = d3.select("#map").append("svg")
            .attr("width", width)
            .attr("height", height);

        d3.json("assets/data/mx_tj.json", function(error, mx) {
          if (error) throw error;

          var g = svg.append("g")
              .attr("class", "estados");

          g.selectAll("path")
              .data(topojson.feature(mx, mx.objects.states).features)
            .enter().append("path")
              .attr("d", path)
              .attr('class', function(d){
                return 'estado ' +vm.colores(parseFloat(vm.data[d.properties.state_code].values[vm.data[d.properties.state_code].values.length-1].porcentaje));
              })
              .attr("id",function(d){
                return "e_"+d.properties.state_code;
              })
              .on("click", function(d){                
                vm.mostrarMunicipios(d)
                vm.stateSelectedMob = d;
              })
              /*.attr("fill",function(d){
                return colores(parseFloat(vm.data[d.properties.state_code].values[vm.data[d.properties.state_code].values.length-1].porcentaje));
              })*/
            .append("title")
              .text(function(d) { return d.properties.name; })

          /*svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state !== b.properties.state; }))
              .attr("class", "state-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });

          svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state === b.properties.state && a !== b; }))
              .attr("class", "municipality-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });*/
          if(vm.pageWidth <=480){
            vm.municipios = d3.nest()
              .key(function(d){return d.properties.state_code})
              .entries(topojson.feature(mx, mx.objects.municipalities).features);
            var a = d3.nest()
              .key(function(d){return d.properties.state_code})
              .entries(topojson.feature(mx, mx.objects.states).features);            
            angular.forEach(a,function(v,i){
              vm.estados.push(v.values[0]);
            })            
            vm.stateSelectedMob = vm.estados[0];
          }
        });

        d3.select(self.frameElement).style("height", height + "px");
      }

      vm.mostrarDatos = function(){
        if(vm.municipioSelect != null){
          d3.select("#m"+vm.municipioSelect.state_code+vm.municipioSelect.mun_code).node().dispatchEvent(e);
        }
      }

      function crearMapaMunicipios(){
        d3.selectAll('#municipios svg').remove();
        width = parseInt(d3.select('#municipios').style('width'));
        width = width - margin.left - margin.right;
        var mapRatio = .5;
        height = width * mapRatio;

        var projection = d3.geo.conicConformal()
            .rotate([102, 0])
            .center([0, 24])
            .parallels([17.5, 29.5])
            .scale(width*1.60)
            .translate([width / 2, height / 2]);

        path_mun = d3.geo.path()
            .projection(projection);

        /*var coloresMun = d3.scale.linear()
          .range(["#D7CDD5","#400130"])
          .domain([0,d3.max(vm.data, function(d) { return d3.max(d.values, function(c) { return parseFloat(c.porcentaje); }); })])*/

        /*var arr = [];
        $.each(vm.data,function(index,value){
          arr.push(d3.min(value.values, function(c) { return parseFloat(c.porcentaje); }))
          arr.push(d3.max(value.values, function(c) { return parseFloat(c.porcentaje); }))
        });
        if(arr.length == 0){
          arr = [6.1170212766, 6.2317750146, 6.9762274655, 7.4900193564, 7.850588505, 8.0751166882, 8.5588738348, 9.0809164914, 9.3798508598, 10.1769301923];
        }else{
          arr = ss.jenks(arr, 5);
          var max = d3.max(arr, function(d) { return d; });
          arr.push(max+1);
        }
        console.log(arr);*/
        var arr = ss.jenks([6.1170212766,6.9762274655,7.9803637212,8.5588738348,9.3798508598,10.1769301923,11.1769301923,0,3.7195644194,6.8417928169,10.2660300136,15.7024793388,25.9259259259,26.9259259259],7)
        var coloresMun = d3.scale.threshold()
          .domain(arr)
          .range(d3.range(9).map(function(i) { return "q" + i; }));

        var drag = d3.behavior.drag()
            .origin(function(d) { return this; })
            .on("drag", dragged);

        var svg = d3.select("#municipios").append("svg")
            .attr("width", width)
            .attr("height", height)

        d3.json("assets/data/mx_tj.json", function(error, mx) {
          /*jQuery.each(topojson.feature(mx, mx.objects.municipalities).features,function(index,value){
            console.log(value.properties);
            $(".table").append("<li>"+value.properties.state_code+","+value.properties.mun_code+","+value.properties.mun_name+"</li>")
          });*/
          if (error) throw error;

          g = svg.append("g")
              .attr("class", "municipalities")
              .call(drag);

          g.selectAll("path")
              .data(topojson.feature(mx, mx.objects.municipalities).features)
            .enter().append("path")
              .attr("d", path_mun)
              .attr("id",function(d){
                return "m"+d.properties.state_code+d.properties.mun_code;
              })
              .attr("class",function(d){
                var obj = vm.data[d.properties.state_code].values.filter(function(o){
                  return parseInt(o.cve_mun) == d.properties.mun_code;
                });
                if(obj.length > 0){
                  return 'municipio oculto '+coloresMun(parseFloat(obj[0].porcentaje));
                }else{
                  return 'municipio oculto';
                }
              })
              .on("click",function(d){                
                var mun_code = d.properties.mun_code;
                d3.selectAll(".municipalities .municipio").classed("active",function(d){
                  return d.properties.mun_code == mun_code;
                })
                var obj = vm.data[d.properties.state_code].values.filter(function(o){
                  return parseInt(o.cve_mun) == d.properties.mun_code;
                });
                $timeout(function(){
                  vm.municipioSelect = d;
                  if(obj.length > 0){
                    vm.municipio = obj[0].municipio;
                    vm.porcentaje = parseFloat(obj[0].porcentaje).toFixed(2)+"%";
                  }else{
                    vm.municipio = "";
                    vm.porcentaje = "";
                  }
                });
              })
            .append("title")
              .text(function(d) { return d.properties.name; });

          if(vm.state_selected != undefined){
            d3.select("#e_"+vm.state_selected).node().dispatchEvent(e);
          }
        });

        d3.select(self.frameElement).style("height", height + "px");
      }

      function clicked(d) {
        //var zoom = [27,7,7,10,7,30,8,7,80,7,     14,8,15,8,15,10,45,11,9,7,   14,18,10,9,8,5,11,7,35,7,12,9];
        var zoom = [20,3,3,4,3,20,4,2,24,3,     8,6,8,3,9,5,20,5,3,5,   4,10,3,3,3,2,8,2,20,2,4,3];
        var centroid = path_mun.centroid(d);
        x = centroid[0];
        y = centroid[1];
        centered = d;
        k = zoom[d.properties.state_code-1];
        t=k;
        g.transition()
            .duration(750)
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")scale(" + k + ")translate(" + -x + "," + -y + ")")
            .style("stroke-width", 1.5 / k + "px");
      }

      d3.select(window).on('resize', resize);

      function resize() {
          $timeout(function(){
            vm.stateName = 'Nacional';
            vm.stateValue = '8.03%';
            vm.municipio = '';
            vm.porcentaje = '';
            crearMapaEstados();
            crearMapaMunicipios();
          });
      }
      vm.mostrarMunicipios = function(d){        
        var state_code = d.properties.state_code;
        vm.state_selected = state_code;        
        //console.log(vm.data[state_code].values[vm.data[state_code].values.length -1].porcentaje);
        d3.selectAll(".estados .estado").classed("active",function(d){
          return d.properties.state_code == state_code;
        })
        if(g != undefined){
          g.selectAll("path")
          .classed("oculto",function(d){
            return d.properties.state_code != state_code;
          });  
          clicked(d);
        }                
        $timeout(function(){
          vm.stateSelected = state_code;
          vm.stateName = d.properties.state_name;
          vm.stateValue = parseFloat(vm.data[state_code].values[vm.data[state_code].values.length -1].porcentaje).toFixed(2)+"%";
          vm.municipio = "";
          vm.porcentaje = "";
          d3.selectAll(".municipalities .municipio").classed("active",false);
        });
      }

      vm.mostrarMunicipiosMob = function(){
        var d = vm.stateSelectedMob;        
        var state_code = d.properties.state_code;
        vm.state_selected = state_code;        
        //console.log(vm.data[state_code].values[vm.data[state_code].values.length -1].porcentaje);
        d3.selectAll(".estados .estado").classed("active",function(d){
          return d.properties.state_code == state_code;
        })
        if(g != undefined){
          g.selectAll("path")
          .classed("oculto",function(d){
            return d.properties.state_code != state_code;
          });  
          clicked(d);
        }                
        $timeout(function(){
          vm.stateSelected = state_code;
          vm.stateName = d.properties.state_name;
          vm.stateValue = parseFloat(vm.data[state_code].values[vm.data[state_code].values.length -1].porcentaje).toFixed(2)+"%";
          vm.municipio = "";
          vm.porcentaje = "";
          d3.selectAll(".municipalities .municipio").classed("active",false);
        });
      }

      vm.zoomIn = function(){
        t=t+3;
        g.transition()
            .duration(750)
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")scale(" + t + ")translate(" + -x + "," + -y + ")");

      }

      vm.zoomOut = function(){
        if(t>k){
          t=t-3;
          g.transition()
              .duration(750)
              .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")scale(" + t + ")translate(" + -x + "," + -y + ")");
        }
      }

      function dragged(d) {
        x = x + (d3.event.dx)*-.1;
        y = y + (d3.event.dy)*-.1;

        g.transition()
          .duration(500)
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")scale(" + t + ")translate(" + -x + "," + -y + ")");

      }

      vm.updateData = function(i){
        vm.data = vm.datos[i].values;
        vm.nacional = vm.datos[i].values[0].values[0].porcentaje;        
        vm.stateName = "";
        vm.stateValue = "";
        crearMapaEstados();
        crearMapaMunicipios();
      }

      $scope.$watch("vm.json",function(data){
        vm.datos = d3.nest()
            .key(function(d){ return d.year; })
            .key(function(d) { return d.cve_ent; })
            .entries(data);
        if(vm.datos.length > 0){
          //vm.nacional vm.data          
          vm.data = vm.datos[0].values;
          vm.nacional = vm.data[0].values[0].porcentaje;
          crearMapaEstados();
          crearMapaMunicipios();
          vm.mostrarMunicipios({properties:{state_code:1}});
        }
      },true);



    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaGastos', mapaGastos);

  /** @ngInject */
  function mapaGastos() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaGastos/mapaGastos.tpl',
      scope: {
          json: '=',
          gasto: '=',
      },
      controller: mapaGastosController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaGastosController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = '';
      //vm.state2 = 'Nivel nacional';
      vm.municipio = '';
      vm.porcentaje = '';
      vm.dataState = [];

      vm.tip = d3.tip().attr('class', 'd3-tip').html(function(d) {
        return "<h3>"+d.actividad+"</h3><h4>"+d.adolescentes+"</h4><h2>"+d.value.toFixed(2)+"%</h2>";
      });

      vm.mapScale = 1.60;
      if($(window).width() < 480){
        mapRatio = .63;
        vm.mapScale = 1.90;
      }

      function crearMapaEstados(){
        d3.select('#map svg').remove();
        var width = parseInt(d3.select('#map').style('width'))
          , width = width - margin.left - margin.right
          , height = width * mapRatio;

        /*var colores = d3.scale.linear()
          .range(["#D7CDD5","#400130"])
          .domain([0,d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); })])*/

        /*var arr = vm.data.map(function(d) { return +d.values[d.values.length-1].porcentaje; });
        if(arr.length == 0){
          arr = [6.1170212766, 6.2317750146, 6.9762274655, 7.4900193564, 7.850588505, 8.0751166882, 8.5588738348, 9.0809164914, 9.3798508598, 10.1769301923];
        }else{
          arr = ss.jenks(arr, 9);
          var max = d3.max(arr, function(d) { return d; });
          arr.push(max+1);
        }*/
        var arr = ss.jenks([6.1170212766,6.9762274655,7.9803637212,8.5588738348,9.3798508598,10.1769301923,11.1769301923,0,3.7195644194,6.8417928169,10.2660300136,15.7024793388,25.9259259259,26.9259259259],7)
        var colores = d3.scale.threshold()
          .domain(arr)
          .range(d3.range(11).map(function(i) { return "q" + i; }));

        //console.log(d3.max(vm.data, function(d) { return parseFloat(d.values[d.values.length-1].porcentaje); }));

        projection = d3.geo.conicConformal()
            .rotate([102, 0])
            .center([0, 24])
            .parallels([17.5, 29.5])
            .scale(width*vm.mapScale)
            .translate([width / 2, height / 2]);

        path = d3.geo.path()
            .projection(projection);
        d3.select("#map svg").remove();
        svg = d3.select("#map").append("svg")
            .attr("width", width)
            .attr("height", height);

        d3.json("assets/data/mx_tj.json", function(error, mx) {
          if (error) throw error;

          var g = svg.append("g")
              .attr("class", "estados");

          g.selectAll("path")
              .data(topojson.feature(mx, mx.objects.states).features)
            .enter().append("path")
              .attr("d", path)
              .attr('class', function(d){
                if([30,23,11,21,17].indexOf(d.properties.state_code)!=-1){
                  return 'estado ' +colores(parseFloat(vm.data[d.properties.state_code-1].values[vm.data[d.properties.state_code-1].values.length-1].porcentaje));
                }else{
                  return "estado null";
                }
              })
              .on("click",mostrarBarchart)
              /*.attr("fill",function(d){
                return colores(parseFloat(vm.data[d.properties.state_code-1].values[vm.data[d.properties.state_code-1].values.length-1].porcentaje));
              })*/
            .append("title")
              .text(function(d) { return d.properties.name; })

          /*svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state !== b.properties.state; }))
              .attr("class", "state-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });

          svg.append("path")
              .datum(topojson.mesh(mx, mx.objects.municipalities, function(a, b) { return a.properties.state === b.properties.state && a !== b; }))
              .attr("class", "municipality-boundary")
              .attr("d", path)
              .on("click",function(d){
                console.log(d)
              });*/
        });

        d3.select(self.frameElement).style("height", height + "px");
      }

      function mostrarBarchart(d){
        var state_code = d.properties.state_code;
        if([30,23,11,21,17].indexOf(state_code)!=-1){
          d3.selectAll(".estados .estado").classed("active",function(d){
            return d.properties.state_code == state_code;
          })
          $timeout(function(){
            vm.state = d.properties.state_name;//+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
            //vm.state2 = d.properties.state_name;
          });
          vm.dataState = vm.gasto.filter(function(v){
            return v.key == state_code;
          })[0];
          crearBarchart();
        }
      }

      function crearBarchart(){
        if(vm.dataState.values){
          var cat = vm.dataState.values.map(function(d){ return d.key});
          var series = [{
                name: '2010',
                data: [],
                color: "#FF8000",

            }, {
                name: '2015',
                data: [],
                color: "#00B2B2",

          }]
          $.each(vm.dataState.values,function(index,value){
            $.each(value.values,function(i,v){
              series[0].data.push(parseFloat(v[2010]));
              series[1].data.push(parseFloat(v[2015]));
            });
          });
          $('.barchart-container').highcharts({
            chart: {
                type: 'column'
            },
            title: {
                text: ' '
            },
            xAxis: {
                categories: cat,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'PESOS MEXICANOS'
                },
                labels: {
                  format: '${value}'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b> ${point.y:.1f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0,
                    borderWidth: 0
                }
            },
            credits: {
              enabled: false
            },

            exporting: {
              enabled: false
            },
            series: series
          });
        }
      }

      d3.select(window).on('resize', resize);

      function resize() {
          // adjust things when the window size changes
          width = parseInt(d3.select('#map').style('width'));
          width = width - margin.left - margin.right;
          height = width * mapRatio;

          // update projection
          projection
              .translate([width / 2, height / 2])
              .scale(width*1.6);

          // resize the map container
          svg
              .style('width', width + 'px')
              .style('height', height + 'px');

          // resize the map
          svg.selectAll('.estado').attr('d', path);
      }

      $scope.$watch("vm.json",function(data){
        vm.data = d3.nest()
            .key(function(d) { return d.cve_ent; })
            .entries(data);
        if(vm.data.length > 0){
          crearMapaEstados();
          crearBarchart();
        }
      },true);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('mapaActividades', mapaActividades);

  /** @ngInject */
  function mapaActividades() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mapaActividades/mapaActividades.tpl',
      scope: {          
          actividades: '=',
      },
      controller: mapaActividadesController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function mapaActividadesController($rootScope,$scope,$timeout) {
      var vm = this;
      vm.data = [];
      var g,centered,projection,svg,path,path_mun,width,height,margin = {top: 10, left: 10, bottom: 10, right: 10}, mapRatio = .5
      var k = 5; //Zoom municipios
      var x, y,t,m0,o0;
      var center; //municipio seleccionado
      vm.state = 'Nacional 8.03%';
      vm.stateSelected = "República Mexicana";
      vm.state_codeSelected = 0;
      vm.municipio = '';
      vm.porcentaje = '';
      vm.dataState = [];
      vm.mapScale = 1.60;
      if($(window).width() < 480){
        mapRatio = .63;
        vm.mapScale = 1.90;
      }
      vm.tip = d3.tip().attr('class', 'd3-tip').html(function(d) {
        return "<h3>"+d.actividad+"</h3><h2>"+d.value.toFixed(2)+"%</h2>";
      });

      vm.mostrarTreemaps = function(d){      
        $timeout(function(){
          var state_code = d.state_code;
          /*d3.selectAll(".estados .estado").classed("active",function(d){
            return d.properties.state_code == state_code;
          })*/        
          vm.dataState = vm.actividadesYear.values.filter(function(d){
            return d.key == state_code;
          });          
          vm.stateSelected = d.state_name; //+" "+parseFloat(vm.data[state_code-1].values[vm.data[state_code-1].values.length -1].porcentaje).toFixed(2)+"%";
          vm.state_codeSelected = d.state_code;
        
          if(vm.dataState.length > 0){
            vm.dataState = d3.nest()
                .key(function(d) { return d.consin; })
                .entries(vm.dataState[0].values);

            crearTreemap(vm.dataState[0].values,"con_hijos");
            crearTreemap(vm.dataState[1].values,"sin_hijos");
          }
        });
      }

      function crearTreemap(datos,contenedor){
        var w = $("."+contenedor+" .treemap").width();
        var h = 250;
        d3.select("."+contenedor+" .treemap svg").remove();

        var tree = {
          "name":"flare",
          "children" : datos,
        }
        var data = tree;

        var min_value,max_value;

        data["children"].sort(function(a,b){return a["porcentaje"] - b["porcentaje"]});
        min_value = data["children"][0]["porcentaje"];
        max_value = data["children"][data["children"].length-1]["porcentaje"];

        var color = d3.scale.ordinal()
          .domain(["Económicamente activa","Estudiante","Quehaceres del hogar","No especificado","Jubilada o pensionada","Limitación física o mental permanente para trabajar","Otro tipo de actividad no económica"])
          .range(["#F93881","#FF6500","#5EC5C8","#FFA119","#7000B0","#28666E","#ED6A5A"]),
        root,
        node;

        var treemap = d3.layout.treemap()
            .round(true)
            .size([w, h])
            .sticky(true)
            .sort(function(a,b) { return a["porcentaje"] - b["porcentaje"]; })
            .value(function(d) {
              return d.porcentaje;
            });

        var svg = d3.select("."+contenedor+" .treemap").append("svg")
          .attr("width",w)
          .attr("height",h)
          .append("svg:g")
            .attr("transform", "translate(.5,.5)")
          .call(vm.tip)

        node = root = data;

        var nodes = treemap.nodes(root)
          .filter(function(d) { return !d.children; });

        var cell = svg.selectAll("g")
            .data(nodes)
          .enter().append("svg:g")
            .attr("class", "cell")
            .attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; })


        cell.append("svg:rect")
            .attr("width", function(d) {
              if(d.dx-5 >= 0){
                return d.dx-5;
              }else{
                return 0;
              }
            })
            .attr("height", function(d) {
              if(d.dy-5 >= 0){
                return d.dy-5;
              }else{
                return 0;
              }
            })
            .style("fill", function(d) {
              console.log(d.actividad, color(d.actividad));
              return color(d.actividad);
            })
            .on('mouseover', function(d){
              d3.select(this).style("opacity",.8);
              vm.tip.show(d);
            })
            .on('mouseout', function(d){
              d3.select(this).style("opacity",1);
              vm.tip.hide(d);
            })


      }      

      $scope.$watch("vm.actividades",function(data){
        $timeout(function(){  
          vm.actividadesData = d3.nest()
            .key(function(d) { return d.year; })
            .key(function(d) { return d.cve_ent; })
            .entries(angular.copy(data));
          if(vm.actividadesData.length > 0){
            vm.actividadesYear = vm.actividadesData[0];            
            vm.dataState = vm.actividadesYear.values.filter(function(d){
              return d.key == 0;
            });
            if(vm.dataState.length > 0){
              vm.dataState = d3.nest()
                  .key(function(d) { return d.consin; })
                  .entries(vm.dataState[0].values);

              crearTreemap(vm.dataState[0].values,"con_hijos");
              crearTreemap(vm.dataState[1].values,"sin_hijos");              
            }
          }
        })
      },true);

      vm.updateData = function(i){
        $timeout(function(){                  
          vm.actividadesYear = vm.actividadesData[i];          
          vm.mostrarTreemaps({state_code:vm.state_codeSelected,state_name:vm.stateSelected});
        })
      }
            
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('download', download);

    /** @ngInject */
    function download() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/download/download.tpl',
        scope: {
            color: '=',            
            link: '='
        },
        controller: downloadController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function downloadController($rootScope,$scope,$timeout) {
        var vm = this;        
        
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('downloadButton', downloadButton);

    /** @ngInject */
    function downloadButton() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/download/downloadButton.tpl',
        scope: {
          json:'=',
          title:'=',
        },
        controller: downloadButtonController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function downloadButtonController($rootScope,$scope,$timeout) {
        var vm = this;        

        vm.download = function(){
          console.log("Descargando");             
          //var json = $.parseJSON(scope.json);

          var csv = vm.JSON2CSV(vm.json);
          var downloadLink = document.createElement("a");
          var blob = new Blob(["\ufeff", csv]);
          var url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = "data.csv";

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
        vm.JSON2CSV = function(objArray) {
          var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
          var str = '';
          var line = '';
          
            var head = array[0];
            if ($("#quote").is(':checked')) {
                for (var index in array[0]) {
                    var value = index + "";
                    line += '"' + value.replace(/"/g, '""') + '",';
                }
            } else {
                for (var index in array[0]) {
                    line += index + ',';
                }
            }

            line = line.slice(0, -1);
            str += line + '\r\n';
          
          for (var i = 0; i < array.length; i++) {
              var line = '';

              if ($("#quote").is(':checked')) {
                  for (var index in array[i]) {
                      var value = array[i][index] + "";
                      line += '"' + value.replace(/"/g, '""') + '",';
                  }
              } else {
                  for (var index in array[i]) {
                      line += array[i][index] + ',';
                  }
              }

              line = line.slice(0, -1);
              str += line + '\r\n';
          }
          return str;
        } 
        
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('dropdownNav', dropdownNav);

    /** @ngInject */
    function dropdownNav() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/dropdown-nav/dropdown-nav.tpl',
        scope: {
          current: '=',                        
          color: '=',
        },
        controller: dropdownNavController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function dropdownNavController($rootScope,$scope,$timeout) {
        var vm = this;                
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('lastRepeat', function() {
      return function(scope, element, attrs) {
        angular.element(element).css('color','blue');
        if (scope.$last){
          if($(window).width() < 480){
            console.log($(".options"));
            $(".options").animate({
              scrollLeft: 65
            }, 2000);
          }     
        }
      };
    })
    .directive('continuarLeyendo', continuarLeyendo);

  /** @ngInject */
  function continuarLeyendo() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/continuar-leyendo/continuar-leyendo.tpl',
      scope: {
        opciones: '=',          
      },
      controller: continuarLeyendoController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function continuarLeyendoController($rootScope,$scope,$timeout) {
      var vm = this;   
      vm.index = 1;
      vm.hover = function(i){
        vm.index = i;
      }        
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('multibarchart', multibarchart);

    /** @ngInject */
    function multibarchart() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/barchart/barchart.tpl',
        scope: {
            series: '=',      
            categories: '='      
        },
        controller: barchartController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function barchartController($rootScope,$scope,$timeout) {
        var vm = this;        
        // Create the chart
        var labels = $(window).width() > 480;       
        console.log(labels); 
        Highcharts.chart('barchart', {
            chart: {
                type: 'column',
                style: {
                  fontFamily: 'Open Sans'
                }
            },
            title: {
                text: ''
            },
            legend: {
                enabled: true,                
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: vm.categories,
                labels: {
                    enabled: labels,
                    step: 1,
                    formatter: function () {
                            return this.value.replace(/ /g, '<br />');
                        }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                }
            },
            tooltip: {
                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                shared: true,
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 0
            },
            plotOptions: {
                column: {
                    stacking: 'value'
                }
            },
            series: vm.series
        });
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .directive('barchart', barchart);

    /** @ngInject */
    function barchart() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/barchart/barchart.tpl',
        scope: {
            data: '=',            
        },
        controller: barchartController,
        controllerAs: "vm",
        bindToController: true,
      };

      return directive;

      /** @ngInject */
      function barchartController($rootScope,$scope,$timeout) {
        var vm = this;        
        // Create the chart
        var labels = $(window).width() > 480;
        var tooltip = $(window).width() < 480;        
        Highcharts.chart('barchart', {
            chart: {
                type: 'column',
                style: {
                  fontFamily: 'Open Sans'
                }
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                type: 'category',
                labels:
                {
                    enabled: labels
                }
            },
            yAxis: {
                title: {
                    text: ''
                }

            },
            legend: {
                enabled: false,
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    }
                }
            },

            tooltip: {
                enabled:tooltip,
                headerFormat: '',
                pointFormat: '<span style="color:{point.color}"><strong>{point.name}: </strong> {point.y:.2f}%</span>',
                backgroundColor: '#FFF',                
                borderRadius: 0,
                borderWidth: 0
            },

            series: [{
                name: 'Brands',
                colorByPoint: true,
                data: vm.data
            }],            
        });
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('presupuestoPrevencionController', presupuestoPrevencionController);

  /** @ngInject */
  function presupuestoPrevencionController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.json = [];
    vm.presupuesto = [];


    d3.csv("https://docs.google.com/spreadsheet/pub?key=1FL9r4aV1brnV-6eMUfFhj4Z6Q9mXi2XPPigTxbAm0Zg&output=csv",
      function(data){                                    
        $timeout(function(){
          vm.json = data;
        });
      }
    );

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1_Xhv5lbFUHSDGqjSI3hTDY9L9u7K9hNterwsp9Olnx0&output=csv",
      function(data){                                        
        $timeout(function(){
          vm.presupuesto = d3.nest()
            .key(function(d){ return d.clave})
            .key(function(d){ return d.programa})
            .entries(data);
        });
      }
    );

    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });
    d3.csv("assets/data/presupuesto.csv",function(data){
      $timeout(function(){
        vm.presupuesto = d3.nest()
          .key(function(d){ return d.clave})
          .key(function(d){ return d.programa})
          .entries(data);
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('presupuestoGastoPrevencionController', presupuestoGastoPrevencionController);

  /** @ngInject */
  function presupuestoGastoPrevencionController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.presupuestoDownload = [];
    vm.gastoDownload = [];
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      //{label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]
    vm.json = [];
    vm.presupuesto = [];
    vm.gasto = [];
    vm.loading = true;
    d3.csv("https://docs.google.com/spreadsheet/pub?key=1FL9r4aV1brnV-6eMUfFhj4Z6Q9mXi2XPPigTxbAm0Zg&output=csv",
      function(data){            
        $timeout(function(){
          vm.json = data;
        });
      }
    );
    d3.csv("https://docs.google.com/spreadsheet/pub?key=1_Xhv5lbFUHSDGqjSI3hTDY9L9u7K9hNterwsp9Olnx0&output=csv",
      function(data){                
        $timeout(function(){
          vm.presupuestoDownload = angular.copy(data);
          vm.presupuesto = d3.nest()
            .key(function(d){ return d.clave})
            .key(function(d){ return d.programa})
            .entries(data);
        });
      }
    );

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1BKCFVhXnTgRNSsD2nHk2pt7h121SCWI357EjSwNpIPg&output=csv",
      function(data){                    
        $timeout(function(){
          vm.gastoDownload = angular.copy(data);
          vm.gasto = d3.nest()
            .key(function(d){ return d.clave})
            .key(function(d){ return d.programa})
            .entries(data);
          vm.loading = false;
        });
      }
    );

    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });
    d3.csv("assets/data/presupuesto.csv",function(data){
      $timeout(function(){
        vm.presupuesto = d3.nest()
          .key(function(d){ return d.clave})
          .key(function(d){ return d.programa})
          .entries(data);
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('narrativasController', narrativasController);

  /** @ngInject */
  function narrativasController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;   
    vm.more = false;     
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      //{label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]
    vm.states = {
      "Aguascalientes" : {
        "hallazgos":[
          "Inexistencia de servicios de traducción en Unidades de Salud del Primer Nivel de Atención, así como de sensibilización, Capacitación e infraestructura con perspectiva intercultural",
          "Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas."
        ],
        "recomendaciones":[
          "Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.",
          "Asegurar capacitaciones para el conocimiento de la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte fundamental de la atención para las mujeres que son víctimas de violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Aguascalientes."
        ],
        "resumen": "La distribución de métodos anticonceptivos en el Estado de Aguascalientes, se reportó de en dos apartados de entrega, por un lado los que se entregaron dentro de las unidades de planificación familiar y los que se entregaron fuera de estas unidades (folio 32478).",
        "video":'',
        "portada":'aguascalientes',
        "color": [251,101,0],
        "link":'aguascalientes'
      },
      "Chiapas" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "La Secretaría de Salud de Chiapas señala que es el Centro Nacional de Equidad de Gpenero y Salud Reproductiva (CNEGSyR) quien efectúa la compra del total de métodos anticonceptivos.",
        "video":'JR6P4oFGn8o',
        "portada":'chiapas',
        "color": [94,197,200],
        "link":'chiapas'
      },
      "Guanajuato" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Se encontró un abasto de métodos anticonceptivos en las siguientes gamas: Oral, Inyectable mensual, Implante subdérmico, DIU, Preservativo masculino, Parche dérmico, pastillas anticonceptivas de emergencia. En las respuestas obtenidas no se reportaron condones femeninos para el estado.",
        "video":'zJ0mptSEsbY',
        "portada":'guanajuato',
        "color": [255,161,25],
        "link":'guanajuato'
      },
      "Guerrero" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "Solo 8.6 por ciento de los municipios de todo el estado de Guerrero reportan distribución de métodos anticonceptivos.",
        "video":'JxyDzhpfKbk',
        "portada":'guerrero',
        "color": [112,0,176],
        "link":'guerrero'
      },
      "Morelos" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Al preguntar sobre el abasto de métodos anticonceptivos en el estado de Morelos recibimos información contradictoria entre las respuestas de acceso a la información pública (folio 00332616, 00332516 y 00333016) y el l folio 00332516, respecto del número de condones femeninos y masculinos desagregado por centro de salud.",
        "video":'dk5z_aI-utk',
        "portada":'morelos',
        "color": [40,102,110],
        "link":'morelos'
      },
      "Oaxaca" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el Estado se reportó la siguiente distribución de métodos anticonceptivos (por las 6 jurisdicciones sanitarias: Valles centrales, Istmo, Tuxtepec Costa, Mixteca, Sierra)",
        "video":'g42YGwftY_k',
        "portada":'oaxaca',
        "color": [249,56,129],
        "link":'oaxaca'
      },
      "Puebla" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "La Secretaría de Salud del estado de Puebla no proporcionó información sobre el número ni la forma en que se distribuyeron los métodos anticonceptivos en la entidad, solo los montos de compra de tres tipos de métodos: parches anticonceptivos ($67,317.12), implantes subdérmicos ($19,600.99 ) y dispositivos intrauterinos o DIU ($141,643.68).",
        "video":'slAahWUl3s4',
        "portada":'puebla',
        "color": [153,0,51],
        "link":'puebla'
      },
      "Quintana Roo" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "A través de solicitudes de acceso a la información pública, se  reportaron  para  2015 un  total  de  0  condones  masculinos,  0  condones femeninos, 8,957  implantes  hormonales  subdérmicos,  2,000  DIU, 357  pastillas  anticonceptivas, 4,190  parches  anticonceptivos  y  6,242  Anticoncepción  Hormonal  inyectable,  adquiridos.  Según la misma solicitud, para abril de 2016 no se adquirieron métodos anticonceptivos por parte de Secretaría de Salud",
        "video":'RpS0J_CBoTg',
        "portada":'quintana-roo',
        "color": [237,106,90],
        "link":'quintana-roo'
      },
      "Veracruz" : {
        "hallazgos":[
          "Talleres impartidos respecto a la corresponsabilidad masculina en la planificación familiar centrado en la Vasectomía sin Bisturí"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para el estado de Veracruz no se reportaron métodos anticonceptivos durante 2015 (enero 2015 a febrero de 2016) (folios con número 00212516, 00212716, 00212816, 00213016, 0213116).",
        "video":'4kCrV-8w7q8',
        "portada":'veracruz',
        "color": [115,197,159],
        "link":'veracruz'
      },
      "Yucatán" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se cuenta con información a sobre campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el estado se reportó la siguiente distribución de métodos anticonceptivos (Folio 15564)",
        "video":'egMMIbqZvI8',
        "portada":'yucatan',
        "color": [61,165,217],
        "link":'yucatan'
      },
    }
    vm.index = 1;
    vm.addIndex = function(){
      vm.index ++;
      console.log("Entra");
    }
    vm.redIndex = function(){
      vm.index --;
    }
    vm.getInverse = function(i){
      if($(window).width() > 480){
        return [2,3,6,7].indexOf(i) != -1
      }else{
        return [1,3,5,7,9].indexOf(i) != -1
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
  	d3.select(".d3-tip").remove();
    var vm = this;   
    vm.getClass = function(i){
    	if($(window).width() > 480){
    		return {'par' : i%2 == 0 && i < 4,'impar' : i%2 != 0 && i > 3};
    	}else{
    		return {'par' : [1,2,5,6].indexOf(i) != -1};
    	}
    } 
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('hallazgosController', hallazgosController);

  /** @ngInject */
  function hallazgosController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.show = true;
    angular.element(window).bind("scroll", function() {
      $timeout(function(){
        vm.show = false;
      })
    });
    vm.updateBtn = function(){
      vm.show = !vm.show;
    }
    vm.stateSelected = "Aguascalientes";
    vm.states = {
      "Aguascalientes" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "La distribución de métodos anticonceptivos en el Estado de Aguascalientes, se reportó de en dos apartados de entrega, por un lado los que se entregaron dentro de las unidades de planificación familiar y los que se entregaron fuera de estas unidades (folio 32478).",
        "video":'',
        "portada":'',
        "color": [251,101,0]
      },
      "Chiapas" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "La Secretaría de Salud de Chiapas señala que es el Centro Nacional de Equidad de Gpenero y Salud Reproductiva (CNEGSyR) quien efectúa la compra del total de métodos anticonceptivos.",
        "video":'',
        "portada":'guanajuato',
        "color": [94,197,200]
      },
      "Guanajuato" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Se encontró un abasto de métodos anticonceptivos en las siguientes gamas: Oral, Inyectable mensual, Implante subdérmico, DIU, Preservativo masculino, Parche dérmico, pastillas anticonceptivas de emergencia. En las respuestas obtenidas no se reportaron condones femeninos para el estado.",
        "video":'',
        "portada":'guanajuato',
        "color": [255,161,25]
      },
      "Guerrero" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "Solo 8.6 por ciento de los municipios de todo el estado de Guerrero reportan distribución de métodos anticonceptivos.",
        "video":'',
        "portada":'guanajuato',
        "color": [112,0,176]
      },
      "Morelos" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Al preguntar sobre el abasto de métodos anticonceptivos en el estado de Morelos recibimos información contradictoria entre las respuestas de acceso a la información pública (folio 00332616, 00332516 y 00333016) y el l folio 00332516, respecto del número de condones femeninos y masculinos desagregado por centro de salud.",
        "video":'',
        "portada":'guanajuato',
        "color": [40,102,110]
      },
      "Oaxaca" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el Estado se reportó la siguiente distribución de métodos anticonceptivos (por las 6 jurisdicciones sanitarias: Valles centrales, Istmo, Tuxtepec Costa, Mixteca, Sierra)",
        "video":'',
        "portada":'guanajuato',
        "color": [249,56,129]
      },
      "Puebla" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "La Secretaría de Salud del estado de Puebla no proporcionó información sobre el número ni la forma en que se distribuyeron los métodos anticonceptivos en la entidad, solo los montos de compra de tres tipos de métodos: parches anticonceptivos ($67,317.12), implantes subdérmicos ($19,600.99 ) y dispositivos intrauterinos o DIU ($141,643.68).",
        "video":'',
        "portada":'guanajuato',
        "color": [153,0,51]
      },
      "Quintana Roo" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "A través de solicitudes de acceso a la información pública, se  reportaron  para  2015 un  total  de  0  condones  masculinos,  0  condones femeninos, 8,957  implantes  hormonales  subdérmicos,  2,000  DIU, 357  pastillas  anticonceptivas, 4,190  parches  anticonceptivos  y  6,242  Anticoncepción  Hormonal  inyectable,  adquiridos.  Según la misma solicitud, para abril de 2016 no se adquirieron métodos anticonceptivos por parte de Secretaría de Salud",
        "video":'',
        "portada":'guanajuato',
        "color": [237,106,90]
      },
      "Veracruz" : {
        "hallazgos":[
          "Talleres impartidos respecto a la corresponsabilidad masculina en la planificación familiar centrado en la Vasectomía sin Bisturí"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para el estado de Veracruz no se reportaron métodos anticonceptivos durante 2015 (enero 2015 a febrero de 2016) (folios con número 00212516, 00212716, 00212816, 00213016, 0213116).",
        "video":'',
        "portada":'guanajuato',
        "color": [115,197,159]
      },
      "Yucatán" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se cuenta con información a sobre campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el estado se reportó la siguiente distribución de métodos anticonceptivos (Folio 15564)",
        "video":'',
        "portada":'guanajuato',
        "color": [61,165,217]
      },
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('gastoController', gastoController);

  /** @ngInject */
  function gastoController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.json = [];
    vm.gasto = [];

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1FL9r4aV1brnV-6eMUfFhj4Z6Q9mXi2XPPigTxbAm0Zg&output=csv",
      function(data){                                    
        $timeout(function(){
          vm.json = data;
        });
      }
    );

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1BKCFVhXnTgRNSsD2nHk2pt7h121SCWI357EjSwNpIPg&output=csv",
      function(data){                                        
        $timeout(function(){
          vm.gasto = d3.nest()
            .key(function(d){ return d.clave})
            .key(function(d){ return d.programa})
            .entries(data);
        });
      }
    );


    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });

    d3.csv("assets/data/gasto.csv",function(data){
      $timeout(function(){
        vm.gasto = d3.nest()
          .key(function(d){ return d.clave})
          .key(function(d){ return d.programa})
          .entries(data);
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('evaluacionController', evaluacionController);

  /** @ngInject */
  function evaluacionController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.dataDownload = [];
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      //{label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]
    vm.evaluaciones = [
      {"name":"Justificación de la creación y el diseño del programa","cve":"jcd"},
      {"name":"Contribución a los objetivos nacionales y a los sectoriales","cve":"con"},
      {"name":"Población potencial y objetivo","cve":"ppo"},
      {"name":"Matriz de indicadores y resultados","cve":"mir"},
    ];

    vm.programas_por_edo = {
      "Guanajuato":[
        {cve:"G1",name:"PREVERP / PAIDEA-DIF",description:"Programa de Prevención de Riesgos Psicosociales en la Adolescencia – Sistema de Desarrollo Integral de la Familia Veracruz.", state:"Guanajuato"},
        {cve:"G2",name:"PAIPEA-IMG",description:"Programa de Atención Integral para la Prevención del Embarazo Adolescente - Instituto de la Mujer Guanajuatense.", state:"Guanajuato"},
        {cve:"G3",name:"PSSA-SSEG",description:"Programa de Salud Sexual para Adolescentes - Secretaría de Salud de Guanajuato", state:"Guanajuato"},
      ],
      "Morelos":[
        {cve:"M1",name:"PPIDF-DIF",description:"Programa para la Protección y el Desarrollo Integral de la Infancia - Sistema de Desarrollo Integral de la Familia Morelos", state:"Morelos"},
        {cve:"M2",name:"PSS/CS-IMJ",description:"Programa Sabroso y Seguro/ Consciente y Seguro - Instituto Morelense de la Juventud", state:"Morelos"},
        {cve:"M3",name:"PFTPG-IMJ",description:"Programa de Fortalecimiento a la Transversalidad de la Perspectiva de Género - Instituto Morelense de la Juventud", state:"Morelos"},
      ],
      "Puebla":[
        {cve:"P1",name:"PAIPEA-DIF",description:"Plan de Acción Interinstitucional para la Prevención del Embarazo en Adolescentes en el Estado de Puebla 2014  - Sistema de Desarrollo Integral de la Familia Puebla", state:"Puebla"},
        {cve:"P2",name:"PRP/EA-DIF",description:"Prevención de Riesgos Psicosociales/Embarazo Adolescente – Sistema de Desarrollo Integral de la Familia Puebla", state:"Puebla"},
        {cve:"P3",name:"SIRBE-IPJ",description:"Programa estatal SIRBE (Simulación Real de Bebés) – Instituto Poblano de la Juventud", state:"Puebla"},
        {cve:"P4",name:"PES-SSEP/SEPP",description:"Programa Escuela y Salud, determinante de sexualidad responsable y protegida – Secretaría de Salud del Estado de Puebla  y Secretaría de Educación Pública de Puebla", state:"Puebla"},
      ],
      "Quintana Roo":[
        {cve:"Q1",name:"PPDIF-DIF",description:"Programa para la Protección y el Desarrollo Integral de la Infancia - Sistema de Desarrollo Integral de la Familia Quintana Roo", state:"Quintana Roo"},
        {cve:"Q2",name:"PSSRA-SSEQ",description:"Programa de Salud Sexual y Reproductiva para Adolescentes – Secretaría de Salud del Estado de Quintana Roo", state:"Quintana Roo"},
      ],
      "Veracruz":[
        {cve:"V1",name:"PVA-DIF",description:"Programa Plan de Vida para Adolescentes – Sistema de Desarrollo Integral de la Familia Veracruz", state:"Veracruz"},
        {cve:"V2",name:"ASSRA-SSEV",description:"Programa de Atención a la Salud Sexual y Reproductiva de las y los Adolescentes - Secretaría de Salud del Estado de Veracruz", state:"Veracruz"},
      ]
    }

    vm.data = [];
    vm.loading = true;
    d3.csv("https://docs.google.com/spreadsheet/pub?key=1uTze66tEvdDjiwh_3Dj5163OFEkcXGwTgZTgPQWF1A4&output=csv",
      function(data){                        
        vm.dataDownload = angular.copy(data);
        $timeout(function(){
          vm.data = d3.nest()
            .key(function(d) { return d.clave; })
            .entries(data);
          vm.loading = false;
        });
      }
    );

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1FL9r4aV1brnV-6eMUfFhj4Z6Q9mXi2XPPigTxbAm0Zg&output=csv",
      function(data){                            
        $timeout(function(){
          vm.json = data;

        });
      }
    );


    /*d3.csv("assets/data/evaluaciones.csv",function(data){
      $timeout(function(){
        vm.data = d3.nest()
          .key(function(d) { return d.clave; })
          .entries(data);
      });
    });
    vm.json = [];
    d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('enapeaController', enapeaController);

  /** @ngInject */
  function enapeaController($timeout,$filter) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.downloadData2015 = [];
    vm.downloadData2016 = [];
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      //{label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]
    vm.colors = {
      "Dependencia":{
        "CONAPO (Consejo Nacional de la Población)":"#E00F7B",
        "SSA (Secretaría de salud)":"#3DA5D9",
        "SHCP/INMUJERES (Instituto Nacional de las Mujeres)":"#5EC5C8",
      },
      "Concepto":{
        "Relacionado directamente":"#73C59F",
        "Indirectamente":"#FF802D",
        "No relacionado":"#990033"
      },
      "Calidad de la información enviada por la dependencia para respaldar su gasto":{
        "Adecuada":"#34BA72",
        "Aceptable":"#FACD3B",
        "Inadecuada":"#FF3D46"
      }
    }
    vm.leyendas = {"Dependencia":vm.colors["Dependencia"],"Concepto":vm.colors["Concepto"]};
    vm.data = [];

    vm.tip = d3.tip().attr('class', 'd3-tip enapea-tip').html(function(d) {        
        if(d.parent != undefined){
          if(["CONAPO","SSA","SHCP/INMUJERES"].indexOf(d.name) != -1){
            return "<p id='close_tip'><svg width='11px' height='11px' viewBox='0 0 11 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Single_2' transform='translate(-465.000000, -761.000000)' stroke='#4A4A4A' fill-rule='nonzero' fill='#4A4A4A'><g id='Group-6' transform='translate(190.000000, 464.000000)'><g id='Group-16-Copy' transform='translate(47.000000, 274.000000)'><path d='M234.29595,28.5000938 L237.835088,24.960808 C238.054971,24.7411036 238.054971,24.3846234 237.835088,24.164919 C237.615205,23.945027 237.259115,23.945027 237.039232,24.164919 L233.500094,27.7042048 L229.960768,24.164919 C229.740885,23.945027 229.384795,23.945027 229.164912,24.164919 C228.945029,24.3846234 228.945029,24.7411036 229.164912,24.960808 L232.704238,28.5000938 L229.164912,32.0393796 C228.945029,32.259084 228.945029,32.6155642 229.164912,32.8352686 C229.274854,32.945027 229.418941,33 229.56284,33 C229.706739,33 229.850827,32.945027 229.960768,32.835081 L233.500094,29.2957952 L237.039232,32.835081 C237.149173,32.945027 237.293261,33 237.43716,33 C237.581059,33 237.725146,32.945027 237.835088,32.835081 C238.054971,32.6153766 238.054971,32.2588964 237.835088,32.039192 L234.29595,28.5000938 Z' id='Shape'></path></g></g></g></g></svg></p><h2>Dependencia:</h2><p><label>"+d.name+"</label><br/>$"+$filter("number")(d.value,2)+"</p>";
          }else{
            var links = {
              "CONAPO" : {"2015":"https://www.dropbox.com/sh/d6zyzqwxqgi2q2f/AAA5whOIvachfyA8ULNq3IpUa?dl=0","2016":"https://www.dropbox.com/sh/bd3vodf2ceprfpm/AACqOIon8FBCbjWee_yjYgBxa?dl=0"},
              "SSA":{"2015":"https://www.dropbox.com/sh/6x916q5ed69qyer/AACaoBJKbTuKmrSdt-VID7l_a?dl=0","2016":"https://www.dropbox.com/sh/dfp5cdo091x6zac/AAAjb_OPvUvrklmcWGSULi0Da?dl=0"},
              "SHCP/INMUJERES":{"2015":"https://www.dropbox.com/sh/kgk051fwklv6zl0/AACsh2W2-GWhMKaGdczPdinca?dl=0","2016":"https://www.dropbox.com/sh/kgk051fwklv6zl0/AACsh2W2-GWhMKaGdczPdinca?dl=0"},
            }

            var href= links[d.parent.name][d.parent.parent.name];
            return "<p id='close_tip'><svg width='11px' height='11px' viewBox='0 0 11 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Single_2' transform='translate(-465.000000, -761.000000)' stroke='#4A4A4A' fill-rule='nonzero' fill='#4A4A4A'><g id='Group-6' transform='translate(190.000000, 464.000000)'><g id='Group-16-Copy' transform='translate(47.000000, 274.000000)'><path d='M234.29595,28.5000938 L237.835088,24.960808 C238.054971,24.7411036 238.054971,24.3846234 237.835088,24.164919 C237.615205,23.945027 237.259115,23.945027 237.039232,24.164919 L233.500094,27.7042048 L229.960768,24.164919 C229.740885,23.945027 229.384795,23.945027 229.164912,24.164919 C228.945029,24.3846234 228.945029,24.7411036 229.164912,24.960808 L232.704238,28.5000938 L229.164912,32.0393796 C228.945029,32.259084 228.945029,32.6155642 229.164912,32.8352686 C229.274854,32.945027 229.418941,33 229.56284,33 C229.706739,33 229.850827,32.945027 229.960768,32.835081 L233.500094,29.2957952 L237.039232,32.835081 C237.149173,32.945027 237.293261,33 237.43716,33 C237.581059,33 237.725146,32.945027 237.835088,32.835081 C238.054971,32.6153766 238.054971,32.2588964 237.835088,32.039192 L234.29595,28.5000938 Z' id='Shape'></path></g></g></g></g></svg></p><h2>Dependencia:</h2><p><label>"+d.parent.name+":</label> $"+$filter("number")(d.parent.value,2)+"</p><h2>Concepto:</h2><p><label>"+d.name+":</label> $"+$filter("number")(d.value,2)+"</p><p style='color:"+vm.colors.Concepto[d.concepto]+";'>"+d.concepto+"</p><h2>Calidad de la información:</h2><p style='color:"+vm.colors["Calidad de la información enviada por la dependencia para respaldar su gasto"][d.calidad]+";'>"+d.calidad+"</p><a href='https://www.dropbox.com/sh/eyntz9aean3zap8/AADK6Iwv4EpwyQo8L4lNfI8ua?dl=0' target='_blank'>Consulta probatorios aquí</a>";
          }
        }else{
          return "<p id='close_tip'><svg width='11px' height='11px' viewBox='0 0 11 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Single_2' transform='translate(-465.000000, -761.000000)' stroke='#4A4A4A' fill-rule='nonzero' fill='#4A4A4A'><g id='Group-6' transform='translate(190.000000, 464.000000)'><g id='Group-16-Copy' transform='translate(47.000000, 274.000000)'><path d='M234.29595,28.5000938 L237.835088,24.960808 C238.054971,24.7411036 238.054971,24.3846234 237.835088,24.164919 C237.615205,23.945027 237.259115,23.945027 237.039232,24.164919 L233.500094,27.7042048 L229.960768,24.164919 C229.740885,23.945027 229.384795,23.945027 229.164912,24.164919 C228.945029,24.3846234 228.945029,24.7411036 229.164912,24.960808 L232.704238,28.5000938 L229.164912,32.0393796 C228.945029,32.259084 228.945029,32.6155642 229.164912,32.8352686 C229.274854,32.945027 229.418941,33 229.56284,33 C229.706739,33 229.850827,32.945027 229.960768,32.835081 L233.500094,29.2957952 L237.039232,32.835081 C237.149173,32.945027 237.293261,33 237.43716,33 C237.581059,33 237.725146,32.945027 237.835088,32.835081 C238.054971,32.6153766 238.054971,32.2588964 237.835088,32.039192 L234.29595,28.5000938 Z' id='Shape'></path></g></g></g></g></svg></p><h2>Dependencia:</h2><p><label>"+d.name+":</label> $"+$filter("number")(d.value,2)+"</p>";
        }

      });
    vm.tip.direction('s')

    vm.makeBarchart = function(){
      var mobile = false;
      if($(window).width() <= 480){
        mobile = true;
      }
      var categories= ['2015','2016'];

      var dollars = [23473585.3,12606305];

      var colors = ['#F93881','#A864CF'];

      var rest = 350;
      var transf = 150;
      var marg = 10;
      if(mobile){
        rest = 56;
        transf = 50;
        marg = -80;
      }
      var xscale = d3.scale.linear()
              .domain([0,23000000])
              .range([0,$("#barchart").width()-rest]);

      var yscale = d3.scale.linear()
              .domain([0,categories.length])
              .range([0,150]);

      var canvas = d3.select('#barchart')
              .append('svg')
              .attr({'width':$("#barchart").width(),'height':175});


      var yAxis = d3.svg.axis();
        yAxis
          .orient('left')
          .scale(yscale)
          .tickFormat(function(d,i){ return categories[i]; })
          .ticks(2)

      var y_xis = canvas.append('g')
                .attr("transform", "translate("+transf+",0)")
                .attr('id','yaxis')
                .call(yAxis)


      var chart = canvas.append('g')
                .attr("transform", "translate("+transf+",0)")
                .attr('id','bars')
                .selectAll('rect')
                .data(dollars)
                .enter()
                .append('rect')
                .attr('height',45)
                .attr({'x':0,'y':function(d,i){ return yscale(i)+16; }})
                .style('fill', function(d,i){
                  return colors[i];
                })
                .attr('width',function(d){ return xscale(d); });


      /*var transit = d3.select("svg").selectAll("rect")
                  .data(dollars)
                  .transition()
                  .duration(1000)
                  .attr("width", function(d) {return xscale(d); });*/

      var st = {'fill':'#6C1360','font-size':'18px', 'font-weight':'600'};
      if(mobile){
        st = {'fill':'#FFFFFF','font-size':'10px', 'font-weight':'600'}
      }

      var transitext = d3.select('#bars')
                .selectAll('text')
                .data(dollars)
                .enter()
                .append('text')
                .attr({'x':function(d) {return xscale(d)+marg; },'y':function(d,i){ return yscale(i)+45; }})
                .text(function(d){ return "$"+$filter("number")(d,2); }).style(st);

        y_xis.selectAll("text")  // select all the text elements for the xaxis
          .attr("transform", function(d) {
             return "translate(0," + (this.getBBox().height+16) + ")";
         });
    }

    vm.makeBarchart();

    /*d3.csv("assets/data/evaluaciones.csv",function(data){
      $timeout(function(){
        vm.data = d3.nest()
          .key(function(d) { return d.clave; })
          .entries(data);
      });
    });
    vm.json = [];
    d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });*/

    //Init code
    // Dimensions of sunburst.
    var width = $("#chart").width();
    var height = $("#chart").width();
    var radius = Math.min(width, height) / 2;

    // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
    var b = {
      w: 75, h: 30, s: 3, t: 10
    };

    // Mapping of step names to colors.
    var colors = {
      "CONAPO":"#E00F7B",
      "SSA":"#3DA5D9",
      "SHCP/INMUJERES":"#5EC5C8"
    }

    // Total size of all segments; we set this later, after loading the data.
    var totalSize = 0;

    var vis = d3.select("#chart").append("svg:svg")
        .attr("width", width)
        .attr("height", height)
        .append("svg:g")
        .attr("id", "container")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
        .call(vm.tip);

    var vis2 = d3.select("#chart2").append("svg:svg")
        .attr("width", width)
        .attr("height", height)
        .append("svg:g")
        .attr("id", "container2")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
        .call(vm.tip);

    var partition = d3.layout.partition()
        .size([2 * Math.PI, radius * radius])
        .value(function(d) { return d.size; });

    var arc = d3.svg.arc()
        .startAngle(function(d) { return d.x; })
        .endAngle(function(d) { return d.x + d.dx; })
        .innerRadius(function(d) { return Math.sqrt(d.y); })
        .outerRadius(function(d) { return Math.sqrt(d.y + d.dy); });

    // Use d3.text and d3.csv.parseRows so that we do not need to have a header
    // row, and can receive the csv as an array of arrays.

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1oYNesBrkfd-6senBEm6Q2ahiUp5USn9bDuS9NwYE2jw&output=csv",
      function(data){                                
        $timeout(function(){
          vm.downloadData2015 = data;
          //var csv = d3.csv.parseRows(data);
          var json = buildHierarchy(data,"2015");
          createVisualization(json,vis,2015);
        });
      }
    );

    d3.csv("https://docs.google.com/spreadsheet/pub?key=1Mhk2HX5TVZJPVPK2NvRNMNbO2-LOY-AoiHfr35OIB3g&output=csv",
      function(data){                                    
        $timeout(function(){
          //var csv = d3.csv.parseRows(data);
          vm.downloadData2016 = data;
          var json = buildHierarchy(data,"2016");
          createVisualization(json,vis2,2016);
        });
      }
    );

    /*d3.text("./assets/data/enapea-2015.csv", function(text) {
      var csv = d3.csv.parseRows(text);
      var json = buildHierarchy(csv,"2015");
      createVisualization(json,vis,2015);
    });

    d3.text("https://docs.google.com/spreadsheets/d/1Mhk2HX5TVZJPVPK2NvRNMNbO2-LOY-AoiHfr35OIB3g/pubhtml", function(text) {
      var csv = d3.csv.parseRows(text);
      var json = buildHierarchy(csv,"2016");
      createVisualization(json,vis2,2016);
    });*/

    // Main function to draw and set up the visualization, once we have the data.
    function createVisualization(json, vis, year) {

      // Basic setup of page elements.
      initializeBreadcrumbTrail();

      // Bounding circle underneath the sunburst, to make it easier to detect
      // when the mouse leaves the parent g.
      vis.append("svg:circle")
          .attr("r", radius)
          .style("opacity", 0);

      // For efficiency, filter nodes to keep only those large enough to see.
      var nodes = partition.nodes(json)
          .filter(function(d) {
          return (d.dx > 0.005); // 0.005 radians = 0.29 degrees
          });

      var path = vis.data([json]).selectAll("path")
          .data(nodes)
          .enter().append("svg:path")
          .attr("display", function(d) { return d.depth ? null : "none"; })
          .attr("d", arc)
          .attr("fill-rule", "evenodd")
          .style("fill", function(d) {
            if(d.concepto){
              return vm.colors.Concepto[d.concepto];
            }else if(d.calidad){
              return vm.colors["Calidad de la información enviada por la dependencia para respaldar su gasto"][d.calidad];
            }else {
              return colors[d.name];
            }

          })
          .style("opacity", 1)
          .on("mouseover", mouseover);

      // Add the mouseleave handler to the bounding circle.
      //d3.select("#container").on("mouseleave", mouseleave);
      //d3.select("#container2").on("mouseleave", mouseleave);

      // Get total size of the tree = value of root node from partition.
      totalSize = path.node().__data__.value;
      if(year == 2015){
        $("#explanation label").html("$"+$filter("number")(totalSize,2));
      }else{
        $("#explanation2 label").html("$"+$filter("number")(totalSize,2));
      }
     };

    // Fade all but the current sequence, and show it in the breadcrumb trail.
    function mouseover(d) {
      vm.tip.show(d);
      $("#close_tip").on("click",mouseleave);
      var percentage = (100 * d.value / totalSize).toPrecision(3);
      var percentageString = percentage + "%";
      if (percentage < 0.1) {
        percentageString = "< 0.1%";
      }

      /*d3.select("#percentage")
          .text(percentageString);

      d3.select("#explanation")
          .style("visibility", "");*/

      var sequenceArray = getAncestors(d);
      updateBreadcrumbs(sequenceArray, percentageString);

      // Fade all the segments.
      d3.selectAll("path")
          .style("opacity", 0.3);

      // Then highlight only those that are an ancestor of the current segment.
      var cu = d.parent;
      while(cu.parent){
        cu = cu.parent;
      }
      if(cu.name == "2015"){
        vis.selectAll("path")
            .filter(function(node) {
                      return (sequenceArray.indexOf(node) >= 0);
                    })
            .style("opacity", 1);
      }else{
        vis2.selectAll("path")
            .filter(function(node) {
                      return (sequenceArray.indexOf(node) >= 0);
                    })
            .style("opacity", 1);
      }
    }

    // Restore everything to full opacity when moving off the visualization.
    function mouseleave(d) {
      vm.tip.hide();
      // Hide the breadcrumb trail
      d3.select("#trail")
          .style("visibility", "hidden");

      // Deactivate all segments during transition.
      d3.selectAll("path").on("mouseover", null);

      // Transition each segment to full opacity and then reactivate it.
      d3.selectAll("path")
          .transition()
          .duration(1000)
          .style("opacity", 1)
          .each("end", function() {
                  d3.select(this).on("mouseover", mouseover);
                });

      /*d3.select("#explanation")
          .style("visibility", "hidden");*/
    }

    // Given a node in a partition layout, return an array of all of its ancestor
    // nodes, highest first, but excluding the root.
    function getAncestors(node) {
      var path = [];
      var current = node;
      while (current.parent) {
        path.unshift(current);
        /*if(current.calidad != undefined){
          current = current.parent.parent;
        }else{*/
          current = current.parent
        //}

      }
      path.unshift(current);
      return path;
    }

    function initializeBreadcrumbTrail() {
      // Add the svg area.
      var trail = d3.select("#sequence").append("svg:svg")
          .attr("width", $("#sequence").width())
          .attr("height", 50)
          .attr("id", "trail");
      // Add the label at the end, for the percentage.
      trail.append("svg:text")
        .attr("id", "endlabel")
        .style("fill", "#000");
    }

    // Generate a string that describes the points of a breadcrumb polygon.
    function breadcrumbPoints(d, i) {
      b.w = d.title.length * 10;
      if(b.w < 75){
        b.w = 75;
      }
      var points = [];
      points.push("0,0");
      points.push(b.w + ",0");
      points.push(b.w + b.t + "," + (b.h / 2));
      points.push(b.w + "," + b.h);
      points.push("0," + b.h);
      if (i > 0) { // Leftmost breadcrumb; don't include 6th vertex.
        points.push(b.t + "," + (b.h / 2));
      }
      b.w = 75;
      return points.join(" ");
    }

    // Update the breadcrumb trail to show the current sequence and percentage.
    function updateBreadcrumbs(nodeArray, percentageString) {
      // Data join; key function combines name and depth (= position in sequence).
      var g = d3.select("#trail")
          .selectAll("g")
          .data(nodeArray, function(d) { return d.name + d.depth; });

      // Add breadcrumb and label for entering nodes.
      var entering = g.enter().append("svg:g");

      entering.append("svg:polygon")
          .attr("points", breadcrumbPoints)
          .style("fill", function(d) {
            if (d.name != "2015" && d.name != "2016"){
              if(d.concepto){
                return vm.colors.Concepto[d.concepto];
              }else if(d.calidad){
                return vm.colors["Calidad de la información enviada por la dependencia para respaldar su gasto"][d.calidad];
              }else{
                return colors[d.name];
              }
            }else{
              return "#989898";
            }
          });


      entering.append("svg:text")
          .attr("x", function(d){
            var f = d.title.length*10;
            if(f < 75){
              f=75;
            }
            return (f + b.t) / 2
          })
          .attr("y", b.h / 2)
          .attr("dy", "0.35em")
          .attr("text-anchor", "middle")
          .text(function(d) { return d.title; });

      // Set position for entering and updating nodes.
      var pl;
      g.attr("transform", function(d, i) {
        var f = 0;
        var current = d.parent;
        if(current != undefined && current.concepto != undefined){
          current = current.parent;
        }
        while (current != undefined) {
          var t = current.title.length * 10;
          if(t < 75){
            t = 75;
          }
          f = f + t;
          current = current.parent;
        }
        var pp = d.title.length * 10;
        if(pp < 75){
          pp = 75;
        }
        pl = f +  pp;
        return "translate("+(f + b.s + 5) + ", 0)";
      });

      // Remove exiting nodes.
      g.exit().remove();

      // Now move and update the percentage at the end.
      d3.select("#trail").select("#endlabel")
          .attr("x", (pl + 30))
          .attr("y", b.h / 2)
          .attr("dy", "0.35em")
          .attr("text-anchor", "start")
          .text(percentageString);

      // Make the breadcrumb trail visible, if it's hidden.
      d3.select("#trail")
          .style("visibility", "");

    }


    // Take a 2-column CSV and transform it into a hierarchical structure suitable
    // for a partition layout. The first column is a sequence of step names, from
    // root to leaf, separated by hyphens. The second column is a count of how
    // often that sequence occurred.
    function buildHierarchy(csv,y) {
      var root = {"name": y, "title":y,"children": []};
      for (var i = 0; i < csv.length; i++) {
        var sequence = csv[i][0];
        var size = +csv[i][1];
        var title = csv[i][2];
        var concepto = csv[i][3];
        var calidad = csv[i][4];
        if (isNaN(size)) { // e.g. if this is a header row
          continue;
        }
        var parts = sequence.split("-");
        var currentNode = root;
        for (var j = 0; j < parts.length; j++) {
          var children = currentNode["children"];
          var nodeName = parts[j];
          var childNode;
          if (j + 1 < parts.length) {
             // Not yet at the end of the sequence; move down the tree.
            var foundChild = false;
            for (var k = 0; k < children.length; k++) {
              if (children[k]["name"] == nodeName) {
                childNode = children[k];
                foundChild = true;
                break;
              }
            }
            // If we don't already have a child node for this branch, create it.
            if (!foundChild) {
              if(["CONAPO","SSA","SHCP/INMUJERES"].indexOf(nodeName) != -1){
                childNode = {"name": nodeName, title:nodeName, "children": []};
              }else{
                childNode = {"name": nodeName, title:title, concepto:concepto,"children": []};
              }

              children.push(childNode);
            }
            currentNode = childNode;
          } else {
            // Reached the end of the sequence; create a leaf node.
            childNode = {"name": nodeName, "size": size, title:title,calidad:calidad,concepto:concepto};
            children.push(childNode);
          }
        }
      }
      return root;
    };
    //End code


  }
})();

// # simple-statistics
//
// A simple, literate statistics system. The code below uses the
// [Javascript module pattern](http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth),
// eventually assigning `simple-statistics` to `ss` in browsers or the
// `exports object for node.js
(function() {
    var ss = {};

    if (typeof module !== 'undefined') {
        // Assign the `ss` object to exports, so that you can require
        // it in [node.js](http://nodejs.org/)
        exports = module.exports = ss;
    } else {
        // Otherwise, in a browser, we assign `ss` to the window object,
        // so you can simply refer to it as `ss`.
        this.ss = ss;
    }

    // # [Linear Regression](http://en.wikipedia.org/wiki/Linear_regression)
    //
    // [Simple linear regression](http://en.wikipedia.org/wiki/Simple_linear_regression)
    // is a simple way to find a fitted line
    // between a set of coordinates.
    ss.linear_regression = function() {
        var linreg = {},
            data = [];

        // Assign data to the model. Data is assumed to be an array.
        linreg.data = function(x) {
            if (!arguments.length) return data;
            data = x.slice();
            return linreg;
        };

        // ## Fitting The Regression Line
        //
        // This is called after `.data()` and returns the
        // equation `y = f(x)` which gives the position
        // of the regression line at each point in `x`.
        linreg.line = function() {

            //if there's only one point, arbitrarily choose a slope of 0
            //and a y-intercept of whatever the y of the initial point is
            if (data.length == 1) {
                m = 0;
                b = data[0][1];
            } else {
                // Initialize our sums and scope the `m` and `b`
                // variables that define the line.
                var sum_x = 0, sum_y = 0,
                    sum_xx = 0, sum_xy = 0,
                    m, b;

                // Gather the sum of all x values, the sum of all
                // y values, and the sum of x^2 and (x*y) for each
                // value.
                //
                // In math notation, these would be SS_x, SS_y, SS_xx, and SS_xy
                for (var i = 0; i < data.length; i++) {
                    sum_x += data[i][0];
                    sum_y += data[i][1];

                    sum_xx += data[i][0] * data[i][0];
                    sum_xy += data[i][0] * data[i][1];
                }

                // `m` is the slope of the regression line
                m = ((data.length * sum_xy) - (sum_x * sum_y)) /
                    ((data.length * sum_xx) - (sum_x * sum_x));

                // `b` is the y-intercept of the line.
                b = (sum_y / data.length) - ((m * sum_x) / data.length);
            }

            // Return a function that computes a `y` value for each
            // x value it is given, based on the values of `b` and `a`
            // that we just computed.
            return function(x) {
                return b + (m * x);
            };
        };

        return linreg;
    };

    // # [R Squared](http://en.wikipedia.org/wiki/Coefficient_of_determination)
    //
    // The r-squared value of data compared with a function `f`
    // is the sum of the squared differences between the prediction
    // and the actual value.
    ss.r_squared = function(data, f) {
        if (data.length < 2) return 1;

        // Compute the average y value for the actual
        // data set in order to compute the
        // _total sum of squares_
        var sum = 0, average;
        for (var i = 0; i < data.length; i++) {
            sum += data[i][1];
        }
        average = sum / data.length;

        // Compute the total sum of squares - the
        // squared difference between each point
        // and the average of all points.
        var sum_of_squares = 0;
        for (var j = 0; j < data.length; j++) {
            sum_of_squares += Math.pow(average - data[j][1], 2);
        }

        // Finally estimate the error: the squared
        // difference between the estimate and the actual data
        // value at each point.
        var err = 0;
        for (var k = 0; k < data.length; k++) {
            err += Math.pow(data[k][1] - f(data[k][0]), 2);
        }

        // As the error grows larger, it's ratio to the
        // sum of squares increases and the r squared
        // value grows lower.
        return 1 - (err / sum_of_squares);
    };


    // # [Bayesian Classifier](http://en.wikipedia.org/wiki/Naive_Bayes_classifier)
    //
    // This is a naïve bayesian classifier that takes
    // singly-nested objects.
    ss.bayesian = function() {
        // The `bayes_model` object is what will be exposed
        // by this closure, with all of its extended methods, and will
        // have access to all scope variables, like `total_count`.
        var bayes_model = {},
            // The number of items that are currently
            // classified in the model
            total_count = 0,
            // Every item classified in the model
            data = {};

        // ## Train
        // Train the classifier with a new item, which has a single
        // dimension of Javascript literal keys and values.
        bayes_model.train = function(item, category) {
            // If the data object doesn't have any values
            // for this category, create a new object for it.
            if (!data[category]) data[category] = {};

            // Iterate through each key in the item.
            for (var k in item) {
                var v = item[k];
                // Initialize the nested object `data[category][k][item[k]]`
                // with an object of keys that equal 0.
                if (data[category][k] === undefined) data[category][k] = {};
                if (data[category][k][v] === undefined) data[category][k][v] = 0;

                // And increment the key for this key/value combination.
                data[category][k][item[k]]++;
            }
            // Increment the number of items classified
            total_count++;
        };

        // ## Score
        // Generate a score of how well this item matches all
        // possible categories based on its attributes
        bayes_model.score = function(item) {
            // Initialize an empty array of odds per category.
            var odds = {}, category;
            // Iterate through each key in the item,
            // then iterate through each category that has been used
            // in previous calls to `.train()`
            for (var k in item) {
                var v = item[k];
                for (category in data) {
                    // Create an empty object for storing key - value combinations
                    // for this category.
                    if (odds[category] === undefined) odds[category] = {};

                    // If this item doesn't even have a property, it counts for nothing,
                    // but if it does have the property that we're looking for from
                    // the item to categorize, it counts based on how popular it is
                    // versus the whole population.
                    if (data[category][k]) {
                        odds[category][k + '_' + v] = (data[category][k][v] || 0) / total_count;
                    } else {
                        odds[category][k + '_' + v] = 0;
                    }
                }
            }

            // Set up a new object that will contain sums of these odds by category
            var odds_sums = {};

            for (category in odds) {
                // Tally all of the odds for each category-combination pair -
                // the non-existence of a category does not add anything to the
                // score.
                for (var combination in odds[category]) {
                    if (odds_sums[category] === undefined) odds_sums[category] = 0;
                    odds_sums[category] += odds[category][combination];
                }
            }

            return odds_sums;
        };

        // Return the completed model.
        return bayes_model;
    };

    // # sum
    //
    // is simply the result of adding all numbers
    // together, starting from zero.
    //
    // This runs on `O(n)`, linear time in respect to the array
    ss.sum = function(x) {
        var sum = 0;
        for (var i = 0; i < x.length; i++) {
            sum += x[i];
        }
        return sum;
    };

    // # mean
    //
    // is the sum over the number of values
    //
    // This runs on `O(n)`, linear time in respect to the array
    ss.mean = function(x) {
        // The mean of no numbers is null
        if (x.length === 0) return null;

        return ss.sum(x) / x.length;
    };

    // # geometric mean
    //
    // a mean function that is more useful for numbers in different
    // ranges.
    //
    // this is the nth root of the input numbers multipled by each other
    //
    // This runs on `O(n)`, linear time in respect to the array
    ss.geometric_mean = function(x) {
        // The mean of no numbers is null
        if (x.length === 0) return null;

        // the starting value.
        var value = 1;

        for (var i = 0; i < x.length; i++) {
            // the geometric mean is only valid for positive numbers
            if (x[i] <= 0) return null;

            // repeatedly multiply the value by each number
            value *= x[i];
        }

        return Math.pow(value, 1 / x.length);
    };

    // Alias this into its common name
    ss.average = ss.mean;

    // # min
    //
    // This is simply the minimum number in the set.
    //
    // This runs on `O(n)`, linear time in respect to the array
    ss.min = function(x) {
        var min;
        for (var i = 0; i < x.length; i++) {
            // On the first iteration of this loop, min is
            // undefined and is thus made the minimum element in the array
            if (x[i] < min || min === undefined) min = x[i];
        }
        return min;
    };

    // # max
    //
    // This is simply the maximum number in the set.
    //
    // This runs on `O(n)`, linear time in respect to the array
    ss.max = function(x) {
        var max;
        for (var i = 0; i < x.length; i++) {
            // On the first iteration of this loop, min is
            // undefined and is thus made the minimum element in the array
            if (x[i] > max || max === undefined) max = x[i];
        }
        return max;
    };

    // # [variance](http://en.wikipedia.org/wiki/Variance)
    //
    // is the sum of squared deviations from the mean
    ss.variance = function(x) {
        // The variance of no numbers is null
        if (x.length === 0) return null;

        var mean = ss.mean(x),
            deviations = [];

        // Make a list of squared deviations from the mean.
        for (var i = 0; i < x.length; i++) {
            deviations.push(Math.pow(x[i] - mean, 2));
        }

        // Find the mean value of that list
        return ss.mean(deviations);
    };

    // # [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
    //
    // is just the square root of the variance.
    ss.standard_deviation = function(x) {
        // The standard deviation of no numbers is null
        if (x.length === 0) return null;

        return Math.sqrt(ss.variance(x));
    };

     ss.sum_squared_deviations = function(x) {
        // The variance of no numbers is null
        if (x.length <= 1) return null;

        var mean = ss.mean(x),
            sum = 0;

        // Make a list of squared deviations from the mean.
        for (var i = 0; i < x.length; i++) {
            sum += Math.pow(x[i] - mean, 2);
        }

        return sum;
     };

    // # [variance](http://en.wikipedia.org/wiki/Variance)
    //
    // is the sum of squared deviations from the mean
    ss.sample_variance = function(x) {
        var sum_squared_deviations = ss.sum_squared_deviations(x);
        if (sum_squared_deviations === null) return null;

        // Find the mean value of that list
        return sum_squared_deviations / (x.length - 1);
    };

    // # [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
    //
    // is just the square root of the variance.
    ss.sample_standard_deviation = function(x) {
        // The standard deviation of no numbers is null
        if (x.length <= 1) return null;

        return Math.sqrt(ss.sample_variance(x));
    };

    // # [covariance](http://en.wikipedia.org/wiki/Covariance)
    //
    // sample covariance of two datasets:
    // how much do the two datasets move together?
    // x and y are two datasets, represented as arrays of numbers.
    ss.sample_covariance = function(x, y) {

        // The two datasets must have the same length which must be more than 1
        if (x.length <= 1 || x.length != y.length){
          return null;
        }

        // determine the mean of each dataset so that we can judge each
        // value of the dataset fairly as the difference from the mean. this
        // way, if one dataset is [1, 2, 3] and [2, 3, 4], their covariance
        // does not suffer because of the difference in absolute values
        var xmean = ss.mean(x),
            ymean = ss.mean(y),
            sum = 0;

        // for each pair of values, the covariance increases when their
        // difference from the mean is associated - if both are well above
        // or if both are well below
        // the mean, the covariance increases significantly.
        for (var i = 0; i < x.length; i++){
            sum += (x[i] - xmean) * (y[i] - ymean);
        }

        // the covariance is weighted by the length of the datasets.
        return sum / (x.length - 1);
    };

    // # [correlation](http://en.wikipedia.org/wiki/Correlation_and_dependence)
    //
    // Gets a measure of how correlated two datasets are, between -1 and 1
    ss.sample_correlation = function(x, y) {
        var cov = ss.sample_covariance(x, y),
            xstd = ss.sample_standard_deviation(x),
            ystd = ss.sample_standard_deviation(y);

        if (cov === null || xstd === null || ystd === null) {
            return null;
        }

        return cov / xstd / ystd;
    };

    // # [median](http://en.wikipedia.org/wiki/Median)
    ss.median = function(x) {
        // The median of an empty list is null
        if (x.length === 0) return null;

        // Sorting the array makes it easy to find the center, but
        // use `.slice()` to ensure the original array `x` is not modified
        var sorted = x.slice().sort(function (a, b) { return a - b; });

        // If the length of the list is odd, it's the central number
        if (sorted.length % 2 === 1) {
            return sorted[(sorted.length - 1) / 2];
        // Otherwise, the median is the average of the two numbers
        // at the center of the list
        } else {
            var a = sorted[(sorted.length / 2) - 1];
            var b = sorted[(sorted.length / 2)];
            return (a + b) / 2;
        }
    };

    // # [mode](http://bit.ly/W5K4Yt)
    // This implementation is inspired by [science.js](https://github.com/jasondavies/science.js/blob/master/src/stats/mode.js)
    ss.mode = function(x) {

        // Handle edge cases:
        // The median of an empty list is null
        if (x.length === 0) return null;
        else if (x.length === 1) return x[0];

        // Sorting the array lets us iterate through it below and be sure
        // that every time we see a new number it's new and we'll never
        // see the same number twice
        var sorted = x.slice().sort(function (a, b) { return a - b; });

        // This assumes it is dealing with an array of size > 1, since size
        // 0 and 1 are handled immediately. Hence it starts at index 1 in the
        // array.
        var last = sorted[0],
            // store the mode as we find new modes
            mode,
            // store how many times we've seen the mode
            max_seen = 0,
            // how many times the current candidate for the mode
            // has been seen
            seen_this = 1;

        // end at sorted.length + 1 to fix the case in which the mode is
        // the highest number that occurs in the sequence. the last iteration
        // compares sorted[i], which is undefined, to the highest number
        // in the series
        for (var i = 1; i < sorted.length + 1; i++) {
            // we're seeing a new number pass by
            if (sorted[i] !== last) {
                // the last number is the new mode since we saw it more
                // often than the old one
                if (seen_this > max_seen) {
                    max_seen = seen_this;
                    seen_this = 1;
                    mode = last;
                }
                last = sorted[i];
            // if this isn't a new number, it's one more occurrence of
            // the potential mode
            } else { seen_this++; }
        }
        return mode;
    };

    // # [t-test](http://en.wikipedia.org/wiki/Student's_t-test)
    //
    // This is to compute a one-sample t-test, comparing the mean
    // of a sample to a known value, x.
    //
    // in this case, we're trying to determine whether the
    // population mean is equal to the value that we know, which is `x`
    // here. usually the results here are used to look up a
    // [p-value](http://en.wikipedia.org/wiki/P-value), which, for
    // a certain level of significance, will let you determine that the
    // null hypothesis can or cannot be rejected.
    ss.t_test = function(sample, x) {
      // The mean of the sample
      var sample_mean = ss.mean(sample);

      // The standard deviation of the sample
      var sd = ss.standard_deviation(sample);

      // Square root the length of the sample
      var rootN = Math.sqrt(sample.length);

      // Compute the known value against the sample,
      // returning the t value
      return (sample_mean - x) / (sd / rootN);
    };

    // # quantile
    // This is a population quantile, since we assume to know the entire
    // dataset in this library. Thus I'm trying to follow the
    // [Quantiles of a Population](http://en.wikipedia.org/wiki/Quantile#Quantiles_of_a_population)
    // algorithm from wikipedia.
    //
    // Sample is a one-dimensional array of numbers,
    // and p is a decimal number from 0 to 1. In terms of a k/q
    // quantile, p = k/q - it's just dealing with fractions or dealing
    // with decimal values.
    ss.quantile = function(sample, p) {

        // We can't derive quantiles from an empty list
        if (sample.length === 0) return null;

        // invalid bounds. Microsoft Excel accepts 0 and 1, but
        // we won't.
        if (p >= 1 || p <= 0) return null;

        // Sort a copy of the array. We'll need a sorted array to index
        // the values in sorted order.
        var sorted = sample.slice().sort(function (a, b) { return a - b; });

        // Find a potential index in the list. In Wikipedia's terms, this
        // is I<sub>p</sub>.
        var idx = (sorted.length) * p;

        // If this isn't an integer, we'll round up to the next value in
        // the list.
        if (idx % 1 !== 0) {
            return sorted[Math.ceil(idx) - 1];
        } else if (sample.length % 2 === 0) {
            // If the list has even-length and we had an integer in the
            // first place, we'll take the average of this number
            // and the next value, if there is one
            return (sorted[idx - 1] + sorted[idx]) / 2;
        } else {
            // Finally, in the simple case of an integer value
            // with an odd-length list, return the sample value at the index.
            return sorted[idx];
        }
    };

    // Compute the matrices required for Jenks breaks. These matrices
    // can be used for any classing of data with `classes <= n_classes`
    ss.jenksMatrices = function(data, n_classes) {

        // in the original implementation, these matrices are referred to
        // as `LC` and `OP`
        //
        // * lower_class_limits (LC): optimal lower class limits
        // * variance_combinations (OP): optimal variance combinations for all classes
        var lower_class_limits = [],
            variance_combinations = [],
            // loop counters
            i, j,
            // the variance, as computed at each step in the calculation
            variance = 0;

        // Initialize and fill each matrix with zeroes
        for (i = 0; i < data.length + 1; i++) {
            var tmp1 = [], tmp2 = [];
            for (j = 0; j < n_classes + 1; j++) {
                tmp1.push(0);
                tmp2.push(0);
            }
            lower_class_limits.push(tmp1);
            variance_combinations.push(tmp2);
        }

        for (i = 1; i < n_classes + 1; i++) {
            lower_class_limits[1][i] = 1;
            variance_combinations[1][i] = 0;
            // in the original implementation, 9999999 is used but
            // since Javascript has `Infinity`, we use that.
            for (j = 2; j < data.length + 1; j++) {
                variance_combinations[j][i] = Infinity;
            }
        }

        for (var l = 2; l < data.length + 1; l++) {

            // `SZ` originally. this is the sum of the values seen thus
            // far when calculating variance.
            var sum = 0, 
                // `ZSQ` originally. the sum of squares of values seen
                // thus far
                sum_squares = 0,
                // `WT` originally. This is the number of 
                w = 0,
                // `IV` originally
                i4 = 0;

            // in several instances, you could say `Math.pow(x, 2)`
            // instead of `x * x`, but this is slower in some browsers
            // introduces an unnecessary concept.
            for (var m = 1; m < l + 1; m++) {

                // `III` originally
                var lower_class_limit = l - m + 1,
                    val = data[lower_class_limit - 1];

                // here we're estimating variance for each potential classing
                // of the data, for each potential number of classes. `w`
                // is the number of data points considered so far.
                w++;

                // increase the current sum and sum-of-squares
                sum += val;
                sum_squares += val * val;

                // the variance at this point in the sequence is the difference
                // between the sum of squares and the total x 2, over the number
                // of samples.
                variance = sum_squares - (sum * sum) / w;

                i4 = lower_class_limit - 1;

                if (i4 !== 0) {
                    for (j = 2; j < n_classes + 1; j++) {
                        if (variance_combinations[l][j] >=
                            (variance + variance_combinations[i4][j - 1])) {
                            lower_class_limits[l][j] = lower_class_limit;
                            variance_combinations[l][j] = variance +
                                variance_combinations[i4][j - 1];
                        }
                    }
                }
            }

            lower_class_limits[l][1] = 1;
            variance_combinations[l][1] = variance;
        }

        return {
            lower_class_limits: lower_class_limits,
            variance_combinations: variance_combinations
        };
    };

    // # [Jenks natural breaks optimization](http://en.wikipedia.org/wiki/Jenks_natural_breaks_optimization)
    //
    // Implementations: [1](http://danieljlewis.org/files/2010/06/Jenks.pdf) (python),
    // [2](https://github.com/vvoovv/djeo-jenks/blob/master/main.js) (buggy),
    // [3](https://github.com/simogeo/geostats/blob/master/lib/geostats.js#L407) (works)

    ss.jenks = function(data, n_classes) {

        // sort data in numerical order
        data = data.slice().sort(function (a, b) { return a - b; });

        // get our basic matrices
        var matrices = ss.jenksMatrices(data, n_classes),
            // we only need lower class limits here
            lower_class_limits = matrices.lower_class_limits,
            k = data.length - 1,
            kclass = [],
            countNum = n_classes;

        // the calculation of classes will never include the upper and
        // lower bounds, so we need to explicitly set them
        kclass[n_classes] = data[data.length - 1];
        kclass[0] = data[0];

        // the lower_class_limits matrix is used as indexes into itself
        // here: the `k` variable is reused in each iteration.
        while (countNum > 1) {
            kclass[countNum - 1] = data[lower_class_limits[k][countNum] - 2];
            k = lower_class_limits[k][countNum] - 1;
            countNum--;
        }

        return kclass;
    };

    // # Mixin
    //
    // Mixin simple_statistics to the Array native object. This is an optional
    // feature that lets you treat simple_statistics as a native feature
    // of Javascript.
    ss.mixin = function() {
        var support = !!(Object.defineProperty && Object.defineProperties);
        if (!support) throw new Error('without defineProperty, simple-statistics cannot be mixed in');

        // only methods which work on basic arrays in a single step
        // are supported
        var arrayMethods = ['median', 'standard_deviation', 'sum',
            'mean', 'min', 'max', 'quantile', 'geometric_mean'];

        // create a closure with a method name so that a reference
        // like `arrayMethods[i]` doesn't follow the loop increment
        function wrap(method) {
            return function() {
                // cast any arguments into an array, since they're
                // natively objects
                var args = Array.prototype.slice.apply(arguments);
                // make the first argument the array itself
                args.unshift(this);
                // return the result of the ss method
                return ss[method].apply(ss, args);
            };
        }

        // for each array function, define a function off of the Array
        // prototype which automatically gets the array as the first
        // argument. We use [defineProperty](https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Object/defineProperty)
        // because it allows these properties to be non-enumerable:
        // `for (var in x)` loops will not run into problems with this
        // implementation.
        for (var i = 0; i < arrayMethods.length; i++) {
            Object.defineProperty(Array.prototype, arrayMethods[i], {
                value: wrap(arrayMethods[i]),
                configurable: true,
                enumerable: false,
                writable: true
            });
        }
    };

})(this);

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('datosMaternidadController', datosMaternidadController);

  /** @ngInject */
  function datosMaternidadController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.json = [];
    vm.loading = true;



    d3.csv("https://docs.google.com/spreadsheet/pub?key=1FL9r4aV1brnV-6eMUfFhj4Z6Q9mXi2XPPigTxbAm0Zg&output=csv",
      function(data){
        $timeout(function(){
          console.log(data);
          vm.json = data;
          vm.loading = false;
        });
      }
    );

    vm.opciones = [      
      //{label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]

    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('corresponsabilidadController', corresponsabilidadController);

  /** @ngInject */
  function corresponsabilidadController($timeout) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.show = true;
    angular.element(window).bind("scroll", function() {
      $timeout(function(){
        vm.show = false;
      })
    });
    vm.updateBtn = function(){
      vm.show = !vm.show;
    }
    vm.stateSelected = "Aguascalientes";
    vm.states = {
      "Aguascalientes" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "La distribución de métodos anticonceptivos en el Estado de Aguascalientes, se reportó de en dos apartados de entrega, por un lado los que se entregaron dentro de las unidades de planificación familiar y los que se entregaron fuera de estas unidades (folio 32478).",
        "video":'',
        "portada":'aguascalientes',
        "color": [251,101,0],
        "link":'aguascalientes'
      },
      "Chiapas" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "La Secretaría de Salud de Chiapas señala que es el Centro Nacional de Equidad de Gpenero y Salud Reproductiva (CNEGSyR) quien efectúa la compra del total de métodos anticonceptivos.",
        "video":'JR6P4oFGn8o',
        "portada":'chiapas',
        "color": [94,197,200],
        "link":'chiapas'
      },
      "Guanajuato" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Se encontró un abasto de métodos anticonceptivos en las siguientes gamas: Oral, Inyectable mensual, Implante subdérmico, DIU, Preservativo masculino, Parche dérmico, pastillas anticonceptivas de emergencia. En las respuestas obtenidas no se reportaron condones femeninos para el estado.",
        "video":'zJ0mptSEsbY',
        "portada":'guanajuato',
        "color": [255,161,25],
        "link":'guanajuato'
      },
      "Guerrero" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "Solo 8.6 por ciento de los municipios de todo el estado de Guerrero reportan distribución de métodos anticonceptivos.",
        "video":'JxyDzhpfKbk',
        "portada":'guerrero',
        "color": [112,0,176],
        "link":'guerrero'
      },
      "Morelos" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Al preguntar sobre el abasto de métodos anticonceptivos en el estado de Morelos recibimos información contradictoria entre las respuestas de acceso a la información pública (folio 00332616, 00332516 y 00333016) y el l folio 00332516, respecto del número de condones femeninos y masculinos desagregado por centro de salud.",
        "video":'dk5z_aI-utk',
        "portada":'morelos',
        "color": [40,102,110],
        "link":'morelos'
      },
      "Oaxaca" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el Estado se reportó la siguiente distribución de métodos anticonceptivos (por las 6 jurisdicciones sanitarias: Valles centrales, Istmo, Tuxtepec Costa, Mixteca, Sierra)",
        "video":'g42YGwftY_k',
        "portada":'oaxaca',
        "color": [249,56,129],
        "link":'oaxaca'
      },
      "Puebla" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "La Secretaría de Salud del estado de Puebla no proporcionó información sobre el número ni la forma en que se distribuyeron los métodos anticonceptivos en la entidad, solo los montos de compra de tres tipos de métodos: parches anticonceptivos ($67,317.12), implantes subdérmicos ($19,600.99 ) y dispositivos intrauterinos o DIU ($141,643.68).",
        "video":'slAahWUl3s4',
        "portada":'puebla',
        "color": [153,0,51],
        "link":'puebla'
      },
      "Quintana Roo" : {
        "hallazgos":[
          "No se especifican los cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "Centrar la corresponsabilidad masculina en la planificación familiar, en métodos anticonceptivos permanentes, en específico en la Vasectomía sin Bisturí"
        ],
        "resumen": "A través de solicitudes de acceso a la información pública, se  reportaron  para  2015 un  total  de  0  condones  masculinos,  0  condones femeninos, 8,957  implantes  hormonales  subdérmicos,  2,000  DIU, 357  pastillas  anticonceptivas, 4,190  parches  anticonceptivos  y  6,242  Anticoncepción  Hormonal  inyectable,  adquiridos.  Según la misma solicitud, para abril de 2016 no se adquirieron métodos anticonceptivos por parte de Secretaría de Salud",
        "video":'RpS0J_CBoTg',
        "portada":'quintana-roo',
        "color": [237,106,90],
        "link":'quintana-roo'
      },
      "Veracruz" : {
        "hallazgos":[
          "Talleres impartidos respecto a la corresponsabilidad masculina en la planificación familiar centrado en la Vasectomía sin Bisturí"
        ],
        "recomendaciones":[
          "No se realizaron campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para el estado de Veracruz no se reportaron métodos anticonceptivos durante 2015 (enero 2015 a febrero de 2016) (folios con número 00212516, 00212716, 00212816, 00213016, 0213116).",
        "video":'4kCrV-8w7q8',
        "portada":'veracruz',
        "color": [115,197,159],
        "link":'veracruz'
      },
      "Yucatán" : {
        "hallazgos":[
          "No se cuenta con cursos impartidos para la capacitación/sensibilización para personal médico de unidades de salud de primer y segundo nivel, respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "recomendaciones":[
          "No se cuenta con información a sobre campañas de comunicación respecto a la corresponsabilidad masculina en la planificación familiar"
        ],
        "resumen": "Para todo el estado se reportó la siguiente distribución de métodos anticonceptivos (Folio 15564)",
        "video":'egMMIbqZvI8',
        "portada":'yucatan',
        "color": [61,165,217],
        "link":'yucatan'
      },
    }
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},
      //{label:"Gasto en prevención por adolescente",view:"gasto-prevencion-adolescente",image:''},
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      //{label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]
    vm.updateState = function(st){
      $timeout(function(){
        vm.stateSelected = st;
        console.log(vm.stateSelected);
      })      
    }
  }
})();

angular
    .module('embarazoAdolecente')
    .directive('hand', function() {
	  return {
	    template: '<svg width="34px" height="36px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 502 502" style="enable-background:new 0 0 502 502;" xml:space="preserve"><g><g><g><path d="M461.63,251.914l-15.038-34.207c-0.89-2.026-1.879-4.035-2.938-5.968c-6.272-11.469-16.565-20.103-28.981-24.313 c-12.377-4.196-25.794-3.636-37.784,1.578l-5.795,2.52l-7.405-16.845c-0.001-0.002-0.002-0.005-0.003-0.007l-5.456-12.41 c-4.662-10.604-13.188-18.74-24.007-22.907c-10.766-4.146-22.478-3.845-32.987,0.846l-19.228,8.33c-3.557-5.06-7.877-8.921-12.914-11.528c-10.521-5.445-23.178-4.987-37.621,1.363l-13.759,6.048l-17.81-40.514c-7.25-16.493-20.706-27.81-36.916-31.05c-15.239-3.046-30.755,1.265-41.51,11.53c-16.139,15.402-20.776,38.528-11.822,58.895l67.466,154.435c-5.649-1.143-11.602-1.666-17.643-1.519c-15.691,0.387-29.8,5.377-39.247,13.79c-0.62,0.402-1.203,0.878-1.737,1.428c-9.494,9.777-14.174,21.604-13.537,34.201c0.797,15.743,9.79,31.268,26.006,44.898c0.082,0.069,0.165,0.137,0.25,0.203l138.681,109.147c1.794,1.413,3.979,2.142,6.186,2.142c1.362,0,2.732-0.278,4.023-0.846l198.672-87.337c3.425-1.505,5.723-4.797,5.956-8.531l1.081-17.312C488.713,341.548,480.351,294.499,461.63,251.914z M465.853,386.728l-0.702,11.231L277.55,480.431L143.715,375.097c-11.612-9.796-18.28-20.623-18.78-30.498c-0.324-6.402,1.87-12.364,6.526-17.748c0.336-0.267,0.658-0.558,0.964-0.873c11.971-12.329,41.824-13.181,57.414-1.748l34.447,33.084c1.939,1.862,4.434,2.788,6.926,2.788c2.627,0,5.25-1.029,7.214-3.073c3.826-3.983,3.698-10.314-0.285-14.14l-33.516-32.191l-76.648-175.452c-6.717-15.28-0.627-28.821,7.313-36.398c5.953-5.682,15.066-8.129,23.782-6.386c9.87,1.973,17.87,8.893,22.527,19.486l58.06,132.072c1.647,3.747,5.313,5.978,9.16,5.978c1.344,0,2.71-0.272,4.019-0.848c5.056-2.223,7.353-8.123,5.13-13.179l-32.201-73.249l13.76-6.049c8.636-3.795,15.493-4.438,20.379-1.909c3.458,1.79,6.373,5.338,8.663,10.546l34.24,77.888c1.647,3.747,5.313,5.978,9.16,5.978c1.344,0,2.71-0.272,4.019-0.848c5.056-2.223,7.353-8.123,5.13-13.179l-30.194-68.685l18.32-7.937c0.039-0.017,0.077-0.033,0.115-0.051c5.625-2.521,11.904-2.685,17.681-0.46c5.809,2.237,10.385,6.602,12.886,12.292l40.687,92.565c1.647,3.747,5.313,5.978,9.16,5.978c1.344,0,2.71-0.272,4.019-0.848c5.056-2.222,7.353-8.123,5.13-13.179l-19.779-44.992l5.722-2.488c15.467-6.727,33.2-0.713,41.244,13.994c0.783,1.431,1.514,2.916,2.173,4.416l15.039,34.208C460.762,299.638,468.554,343.473,465.853,386.728z"/><path d="M426.561,384.075l-9.865,4.327c-5.058,2.218-7.359,8.116-5.141,13.174c1.645,3.751,5.313,5.986,9.163,5.986c1.341,0,2.705-0.271,4.011-0.845l9.865-4.327c5.058-2.218,7.359-8.116,5.141-13.174C437.518,384.158,431.62,381.856,426.561,384.075z"/><path d="M386.77,401.751l-105.353,46.208c-5.058,2.218-7.359,8.116-5.141,13.174c1.645,3.751,5.313,5.986,9.163,5.986c1.341,0,2.705-0.271,4.011-0.844l105.353-46.209c5.058-2.218,7.359-8.116,5.141-13.174C397.727,401.835,391.83,399.533,386.77,401.751z"/><path d="M127.017,45.197c0.976,4.727,5.139,7.98,9.783,7.98c0.67,0,1.351-0.068,2.032-0.208c5.409-1.117,8.888-6.407,7.771-11.816l-6.85-33.174c-1.116-5.408-6.408-8.885-11.815-7.771c-5.409,1.116-8.888,6.406-7.771,11.815L127.017,45.197z"/><path d="M41.035,46.913c2.909-4.696,1.459-10.859-3.236-13.767l-6.907-4.277c-4.696-2.909-10.859-1.46-13.767,3.236c-2.909,4.696-1.459,10.859,3.236,13.767l6.907,4.277c1.64,1.016,3.459,1.5,5.256,1.5C35.871,51.649,39.143,49.968,41.035,46.913z"/><path d="M60.454,72.245l21.332,14.031c1.694,1.114,3.6,1.646,5.486,1.646c3.253,0,6.443-1.585,8.365-4.506c3.035-4.614,1.754-10.815-2.86-13.85L71.444,55.535c-4.615-3.035-10.815-1.754-13.85,2.86C54.559,63.009,55.84,69.21,60.454,72.245z"/><path d="M86.622,135.491c-1.117-5.408-6.405-8.886-11.816-7.771l-33.174,6.85c-5.409,1.116-8.888,6.406-7.771,11.815c0.976,4.727,5.139,7.98,9.783,7.98c0.67,0,1.351-0.068,2.033-0.208l33.174-6.85C84.26,146.19,87.739,140.9,86.622,135.491z"/><path d="M111.775,186.982c-4.615-3.036-10.816-1.754-13.85,2.86l-18.614,28.301c-3.035,4.614-1.754,10.815,2.86,13.85c1.694,1.114,3.6,1.646,5.486,1.646c3.253,0,6.443-1.585,8.364-4.506l18.614-28.301C117.67,196.218,116.389,190.017,111.775,186.982z"/><path d="M221.355,105.18c0.976,4.726,5.139,7.979,9.783,7.979c0.67,0,1.35-0.068,2.033-0.208l22.116-4.567c5.409-1.117,8.888-6.407,7.771-11.816c-1.117-5.409-6.406-8.888-11.816-7.771l-22.116,4.567C223.717,94.481,220.238,99.771,221.355,105.18z"/><path d="M293.34,100.315c0.67,0,1.351-0.068,2.033-0.208l6.912-1.427c5.409-1.117,8.888-6.407,7.771-11.816c-1.117-5.408-6.404-8.887-11.816-7.771l-6.912,1.427c-5.409,1.117-8.888,6.407-7.771,11.816C284.533,97.062,288.696,100.315,293.34,100.315z"/><path d="M190.907,61.982c1.694,1.114,3.6,1.646,5.486,1.646c3.253,0,6.444-1.585,8.364-4.506l18.614-28.301c3.035-4.614,1.754-10.815-2.86-13.85c-4.615-3.036-10.816-1.754-13.85,2.86l-18.614,28.301C185.012,52.746,186.293,58.947,190.907,61.982z"/></g></g></g></svg>'
	  };
	});
(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('actividadesController', actividadesController);

  /** @ngInject */
  function actividadesController($timeout,$rootScope) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.json = [];
    vm.actividades = [];
    d3.csv("https://docs.google.com/spreadsheet/pub?key=11_BjcHHINaduxAC74b0TFmP8H1DoKBMLaNrm8VhN2ME&output=csv",
      function(data){    
        $timeout(function(){
          vm.actividades = data;                
          $rootScope.loading = false;                        
        });
      }
    );
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      //{label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]

    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });
    d3.csv("assets/data/actividades.csv",function(data){
      $timeout(function(){
        vm.actividades = data;
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('accesoServiciosMedicosController', accesoServiciosMedicosController);

  /** @ngInject */
  function accesoServiciosMedicosController($timeout,$rootScope) {
    d3.select(".d3-tip").remove();
    var vm = this;
    vm.json = [];
    vm.servicios = [];
    vm.serviciosTipo = [];
    $rootScope.loading = true;  
    d3.csv("https://docs.google.com/spreadsheet/pub?key=1ZbwaR89ybqYq4dduD361bLDSTPd6HBVTXA-PqJzx5eQ&output=csv",
      function(data){        
        $timeout(function(){
          vm.servicios = data;
          d3.csv("https://docs.google.com/spreadsheet/pub?key=17E4vPvNYm-OEJl0eYigKh9SMlz65kh3fdSlJarjjUYI&output=csv",
            function(data){              
              $timeout(function(){
                vm.serviciosTipo = data;
                $rootScope.loading = false;
              });
            }
          );
        });
      }
    );       
    vm.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      //{label:"Acceso servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},      
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
      {label:"Investigación Aguascalientes",view:"narrativa-aguascalientes",image:'Aguascalientes'},      
    ]

    /*d3.csv("assets/data/base.csv",function(data){
      $timeout(function(){
        vm.json = data;
      });
    });
    d3.csv("assets/data/servicios.csv",function(data){
      $timeout(function(){
        vm.servicios = data;
      });
    });

    d3.csv("assets/data/servicios_por_tipo.csv",function(data){
      $timeout(function(){
        vm.serviciosTipo = data;
      });
    });*/
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $state, $rootScope,$timeout) {
    $timeout(function(){
      $rootScope.state = $state;
    },600)
    $log.debug('runBlock end');

    $rootScope.opciones = [      
      {label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente",image:'MujeresAdolescentes'},
      {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes",image:'ActividadesPrincipales'},
      {label:"Acceso a servicios de salud",view:"acceso-servicios-medicos",image:'AccesoServicios'},
      {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion",image:'Presupuesto'},
      //{label:"Gasto en prevención por adolescente",view:"gasto-prevencion-adolescente",image:''},
      {label:"Evaluación de programas de prevención",view:"evaluacion-programas",image:'Evaluacion'},
      {label:"Corresponsabilidad",view:"corresponsabilidad",image:'Corresponsabilidad_c'},
      {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea",image:'MayorTransparencia'},      
      {label:"Narrativas digitales",view:"narrativas",image:'NarrativasDigitales'},      
    ];

    $rootScope.estados = [
      {state_code: 1, state_name: "Aguascalientes"},
      {state_code: 2, state_name: "Baja California"},
      {state_code: 3, state_name: "Baja California Sur"},
      {state_code: 4, state_name: "Campeche"},
      {state_code: 5, state_name: "Coahuila"},
      {state_code: 6, state_name: "Colima"},
      {state_code: 7, state_name: "Chiapas"},
      {state_code: 8, state_name: "Chihuahua"},
      {state_code: 9, state_name:"Distrito Federal"},
      {state_code: 10, state_name: "Durango"},
      {state_code: 11, state_name: "Guanajuato"},
      {state_code: 12, state_name: "Guerrero"},
      {state_code: 13, state_name: "Hidalgo"},
      {state_code: 14, state_name: "Jalisco"},
      {state_code: 15, state_name: "Estado de México"},
      {state_code: 16, state_name: "Michoacán"},
      {state_code: 17, state_name: "Morelos"},
      {state_code: 18, state_name: "Nayarit"},
      {state_code: 19, state_name: "Nuevo León"},
      {state_code: 20, state_name: "Oaxaca"},
      {state_code: 21, state_name: "Puebla"},
      {state_code: 22, state_name: "Querétaro"},
      {state_code: 23, state_name: "Quintana Roo"},
      {state_code: 24, state_name: "San Luis Potosí"},
      {state_code: 25, state_name: "Sinaloa"},
      {state_code: 26, state_name: "Sonora"},
      {state_code: 27, state_name: "Tabasco"},
      {state_code: 28, state_name: "Tamaulipas"},
      {state_code: 29, state_name: "Tlaxcala"},
      {state_code: 30, state_name: "Veracruz"},            
      {state_code: 31, state_name: "Yucatán"},
      {state_code: 32, state_name: "Zacatecas"},
    ]
    $rootScope.$on('$stateChangeSuccess', function() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ','
      }
  });
  }
})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider,$locationProvider) {
    
    /*$locationProvider.html5Mode({
      enabled: true,
      requireBase: true
    });*/
    
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      })
      .state('datos-maternidad-adolescente', {
        url: '/datos-maternidad-adolescente',
        templateUrl: 'app/datos/datos.html',
        controller: 'datosMaternidadController',
        controllerAs: 'vm'
      })
      .state('actividades-madres-adolescentes', {
        url: '/actividades-madres-adolescentes',
        templateUrl: 'app/actividades/actividades.html',
        controller: 'actividadesController',
        controllerAs: 'vm'
      })
      .state('acceso-servicios-medicos', {
        url: '/acceso-servicios-medicos',
        templateUrl: 'app/acceso-servicios-medicos/accesoServiciosMedicos.html',
        controller: 'accesoServiciosMedicosController',
        controllerAs: 'vm'
      })
      .state('presupuesto-prevencion', {
        url: '/presupuesto-prevencion',
        templateUrl: 'app/presupuesto-prevencion/presupuesto-prevencion.html',
        controller: 'presupuestoPrevencionController',
        controllerAs: 'vm'
      })
      .state('gasto-prevencion-adolescente', {
        url: '/gasto-prevencion-adolescente',
        templateUrl: 'app/gasto/gasto.html',
        controller: 'gastoController',
        controllerAs: 'vm'
      })
      .state('presupuesto-gasto-prevencion', {
        url: '/presupuesto-gasto-prevencion',
        templateUrl: 'app/presupuesto-gasto-prevencion/presupuesto-gasto-prevencion.html',
        controller: 'presupuestoGastoPrevencionController',
        controllerAs: 'vm'
      })
      .state('evaluacion-programas', {
        url: '/evaluacion-programas',
        templateUrl: 'app/evaluacion/evaluacion.html',
        controller: 'evaluacionController',
        controllerAs: 'vm'
      })
      .state('corresponsabilidad', {
        url: '/corresponsabilidad',
        templateUrl: 'app/corresponsabilidad/corresponsabilidad.html',
        controller: 'corresponsabilidadController',
        controllerAs: 'vm'
      })
      .state('hallazgos', {
        url: '/hallazgos',
        templateUrl: 'app/hallazgos/hallazgos.html',
        controller: 'hallazgosController',
        controllerAs: 'vm'
      })
      .state('enapea', {
        url: '/enapea',
        templateUrl: 'app/enapea/enapea.html',
        controller: 'enapeaController',
        controllerAs: 'vm'
      })
      .state('enapea-embed', {
        url: '/enapea-embed',
        templateUrl: 'app/enapea/enapea-embed.html',
        controller: 'enapeaController',
        controllerAs: 'vm'
      })
      .state('narrativas', {
        url: '/narrativas',
        templateUrl: 'app/narrativas/narrativas.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-aguascalientes', {
        url: '/narrativa/aguascalientes',
        templateUrl: 'app/narrativas/aguascalientes.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-chiapas', {
        url: '/narrativa/chiapas',
        templateUrl: 'app/narrativas/chiapas.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-guanajuato', {
        url: '/narrativa/guanajuato',
        templateUrl: 'app/narrativas/guanajuato.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-guerrero', {
        url: '/narrativa/guerrero',
        templateUrl: 'app/narrativas/guerrero.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-morelos', {
        url: '/narrativa/morelos',
        templateUrl: 'app/narrativas/morelos.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-oaxaca', {
        url: '/narrativa/oaxaca',
        templateUrl: 'app/narrativas/oaxaca.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-puebla', {
        url: '/narrativa/puebla',
        templateUrl: 'app/narrativas/puebla.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-quintana-roo', {
        url: '/narrativa/quintana-roo',
        templateUrl: 'app/narrativas/quintana-roo.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-yucatan', {
        url: '/narrativa/yucatan',
        templateUrl: 'app/narrativas/yucatan.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })
      .state('narrativa-veracruz', {
        url: '/narrativa/veracruz',
        templateUrl: 'app/narrativas/veracruz.html',
        controller: 'narrativasController',
        controllerAs: 'vm'
      })



    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .controller('indexController', indexController);

    /** @ngInject */
    function indexController($timeout, $rootScope,$stateParams,$state) {
      var vm = this;
      $rootScope.$watch('state',function(){
        if($rootScope.state != undefined){
          if($rootScope.state.current.name != "enapea-embed"){
            $(".oculta").removeClass("oculta");
          }
        }

      });

      vm.isHome = function(){
        return $state.current.name === 'home';        
      }

      vm.menu = [
        /*{label:"Mujeres adolescentes con hijas e hijos",view:"datos-maternidad-adolescente"},
        {label:"Actividades principales de mujeres adolescentes",view:"actividades-madres-adolescentes"},
        {label:"Acceso servicios de salud",view:"acceso-servicios-medicos"},
        {label:"Presupuesto y gasto para prevención",view:"presupuesto-gasto-prevencion"},*/
        //{label:"Gasto en prevención por adolescente",view:"gasto-prevencion-adolescente"},
        //{label:"Evaluación de programas de prevención",view:"evaluacion-programas"},
        //{label:"Corresponsabilidad",view:"corresponsabilidad"},
        {label:"Mayor transparencia y presupuesto para la ENAPEA",view:"enapea"},
      ]
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('embarazoAdolecente')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("embarazoAdolecente").run(["$templateCache", function($templateCache) {$templateCache.put("app/acceso-servicios-medicos/accesoServiciosMedicos.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso servicios de salud de mujeres adolescentes</h2><p>En la siguiente sección se muestra el acceso de las mujeres adolescentes, con y sin hijas o hijos, a diversos tipos de servicios de salud.</p></div><div class=\"loading\" ng-show=\"loading\"><div class=\"mask\" style=\"height:300px;\"><img src=\"./assets/images/loading.gif\"></div></div><mapa-servicios-medicos servicios=\"vm.servicios\" tipos=\"vm.serviciosTipo\"></mapa-servicios-medicos><div class=\"texto\"><p>En comparativo, con estos datos, se puede observar que las mujeres adolescentes sin hijas e hijos tienen un porcentaje mayor de derechohabiencia (43.08%) al IMSS que las mujeres con hijas e hijos (26.06%). En contraste, la derechohabiencia con la que cuentan mayoritariamente las mujeres con hijas e hijos es el Seguro Popular con un porcentaje de 69.18%, mientras que las mujeres adolescentes son hijas e hijos tienen un porcentaje de derechohabiencia en el Seguro Popular de 41.31%</p><p>El acceso mayoritario al IMSS por parte de mujeres adolescentes sin hijos podría leerse como una afiliación que se da por un tercero asegurado (familiar) o contar con seguro facultativo para estudiantes de educación media superior y superior. En contraste, un porcentaje menor en mujeres adolescentes con hijas e hijos en la derechohabiencia al IMSS podría explicarse por condiciones de dependencia y por cuestiones relativas al abandono escolar.</p><p>Las cifras del acceso a los diferentes tipos de derechohabiencia varían por estado, por ejemplo, en los estados de Guerrero, Chiapas, Campeche, Tabasco e Hidalgo las mujeres adolescentes con hijos y sin hijos acceden mayoritariamente a los servicios médicos del Seguro Popular.</p></div></div><download-button json=\"vm.servicios\" ng-show=\"vm.servicios.length > 0\"></download-button><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/actividades/actividades.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Actividades principales de mujeres adolescentes</h2><p>En este apartado se ilustran las principales actividades que desempeñan las adolescentes antes y después de un embarazo, lo que nos habla de la persistencia de roles tradicionales y estereotipos de género, en específico de actividades de cuidado en el espacio doméstico</p></div><div class=\"loading\" ng-show=\"loading\"><div class=\"mask\" style=\"height:300px;\"><img src=\"./assets/images/loading.gif\"></div></div><mapa-actividades actividades=\"vm.actividades\"></mapa-actividades><div class=\"texto\"><p>La principal actividad que realizan las adolescentes sin hijos en todo el país es la de estudiantes, mientras que su actividad cambia a trabajo en el hogar, cuando son adolescentes con hijos.</p><p>Chiapas presenta el menor porcentaje (2.46%) de las mujeres adolescentes con hijas e hijos que se dedica a estudiar. Le siguen estados como Michoacán, Oaxaca, Guerrero y Guanajuato con porcentajes menores al 4 por ciento.</p><p>Estas entidades presentan <a href=\"http://www.coneval.org.mx/salaprensa/documents/comunicado005_medicion_pobreza_2014.pdf\" target=\"_blank\">los porcentajes de mayor pobreza en el país,</a> lo que señala la necesidad de analizar las consecuencias del embarazo adolescente desde intersecciones como la condición económica o la pertenencia a algún pueblo indígena. En contraste, la Ciudad de México es la única entidad donde más del 10 por ciento de las adolescentes con hijas e hijos se dedican a ser estudiantes como actividad principal.</p></div></div><download-button json=\"vm.actividades\" ng-show=\"vm.actividades.length > 0\"></download-button><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/enapea/enapea-embed.html","<div class=\"container\"><div class=\"enapea\"><div class=\"box effect6\"></div><div class=\"row\"><div class=\"col-xs-12 text-center\"><div id=\"barchart\"></div><p>Presupuesto de Egreso de la Federación (PEF) ENAPEA</p></div></div><div class=\"piecharts\"><div id=\"sequence\"></div><div id=\"main\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div id=\"chart\"><div id=\"explanation\" style=\"visibility: visible;\"><span id=\"percentage\">2015</span><br><label></label></div></div></div><div class=\"col-xs-12 col-sm-6\"><div id=\"chart2\"><div id=\"explanation2\" style=\"visibility: visible;\"><span id=\"percentage2\">2016</span><br><label></label></div></div></div></div></div><div class=\"row cont-leyendas\"><div class=\"col-xs-12 group\"><div class=\"leyendas\" ng-repeat=\"(key,value) in vm.leyendas\"><h3>{{key}}</h3><ul><li ng-repeat=\"(key2,value2) in value\"><div class=\"recuadro\" style=\"background-color:{{value2}};\"></div>{{key2}}</li></ul></div></div></div><script type=\"text/javascript\">\n          // Hack to make this example display correctly in an iframe on bl.ocks.org\n          d3.select(self.frameElement).style(\"height\", \"700px\");\n      </script></div></div></div>");
$templateCache.put("app/enapea/enapea.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Mayor transparencia y presupuesto para la ENAPEA</h2></div><div class=\"enapea container-viz\"><div class=\"row\"><div class=\"col-xs-12 text-center\"><div id=\"barchart\"></div><h2>Presupuesto de Egreso de la Federación (PEF) ENAPEA</h2></div></div><div class=\"fuente visible-xs\"><p><hand></hand>Selecciona las gráficas para interactuar con ellas</p></div><div class=\"piecharts\"><div id=\"sequence\"></div><div id=\"main\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div id=\"chart\"><div id=\"explanation\" style=\"visibility: visible;\"><span id=\"percentage\">2015</span><br><label></label></div></div></div><div class=\"col-xs-12 col-sm-6\"><div id=\"chart2\"><div id=\"explanation2\" style=\"visibility: visible;\"><span id=\"percentage2\">2016</span><br><label></label></div></div></div></div></div><div class=\"row cont-leyendas\"><div class=\"col-xs-12 group\"><div class=\"leyendas\" ng-repeat=\"(key,value) in vm.leyendas\"><h3>{{key}}</h3><ul><li ng-repeat=\"(key2,value2) in value\"><div class=\"recuadro\" style=\"background-color:{{value2}};\"></div>{{key2}}</li></ul></div></div></div><script type=\"text/javascript\">\n          // Hack to make this example display correctly in an iframe on bl.ocks.org\n          d3.select(self.frameElement).style(\"height\", \"700px\");\n      </script></div><div class=\"fuente\"><p class=\"hidden-xs\"><hand></hand>Selecciona las gráficas para interactuar con ellas</p><p>Respuestas a Solicitudes de Información Pública.</p></div></div><div class=\"texto\"><p>En México ocurren cada día 997 nacimientos en mujeres de 10 a 19 años de edad. En este contexto, en el 2015 el Presidente puso en marcha la Estrategia Nacional para Prevenir el Embarazo en adolescentes como acción “prioritaria”.</p><p>No se conoce con precisión el presupuesto total disponible para la ejecución de la Estrategia.</p><p>En 2016, el presupuesto público identificado por el INAI para la coordinación interinstitucional de la Estrategia se redujo un 45%.</p><p>Existen incongruencias en la comprobación del gasto.</p><p>Luego de un año de investigación realizada por mujeres indígenas y jóvenes, el Instituto de Liderazgo Simone de Beauvoir (ILSB), encontró que el presupuesto etiquetado para la Estrategia Nacional de Prevención del Embarazo Adolescente (ENAPEA) es insuficiente, que no hay claridad en la totalidad de recursos que las dependencias destinan a acciones relacionadas con esta estrategia y que existen deficiencias administrativas en la comprobación del gasto.</p><p>El embarazo adolescente “desencadena uniones tempranas, reproduce el círculo de pobreza, y genera una mayor exposición a situaciones de inseguridad, desprotección y maltrato”, así lo asegura el documento que presentó el Presidente Enrique Peña Nieto, definiendo a la ENAPEA como una acción “prioritaria” desde su creación en enero 2015.</p><p>Como parte de una investigación más amplia sobre la implementación de la ENAPEA, el ILSB realizó una serie de solicitudes de acceso a la información para conocer a profundidad el ejercicio presupuestal de esa estrategia y sus resultados en distintas líneas de acción. A partir de 2015, el ILSB ha dado seguimiento al presupuesto asignado a esta política pública. A las primeras solicitudes de acceso a la información realizadas al Consejo Nacional de Población (CONAPO), el INMUJERES y la Secretaría de Salud (instancias que coordinan la red interinstitucional responsable de llevarla a cabo) éstas respondieron que la estrategia carecía de recursos.</p><p>Después de un año de interponer recursos de revisión, el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI) identificó la asignación de recursos públicos para la ENAPEA, y requirió a las instituciones una nueva búsqueda y entrega de la información solicitada.</p><p>El ILSB, en colaboración con organizaciones aliadas como Controla Tu Gobierno, analizó las respuestas obtenidas y encontró los siguientes hallazgos:</p><p>No se tienen concentrados ni se conocen con precisión cuántos recursos destinan todas las dependencias federales que a través de sus diversos programas abonan a la consecución de los objetivos de la ENAPEA.</p><p>El presupuesto público destinado a la coordinación interinstitucional se redujo un 45% a partir del segundo año de la Estrategia (2016) dejando fuera de los recursos asignados a instancias coordinadoras como el INMUJERES.</p><p>En cuanto al ejercicio y comprobación del gasto para los años 2015 y 2016:</p><p>En 2015 el Consejo Nacional de Población (CONAPO) informó la contratación de campañas en “medios electrónicos” y “medios complementarios”, y aunque no se precisa qué productos estuvieron dirigidos específicamente a la ENAPEA, existe un vínculo claro al tema de prevención. Se detectó que en el programa de comunicación social la edad de la población objetivo a la que van dirigidas las campañas deja fuera al grupo de edad de 10 a 12 años, pese a que se hace explícito como prioritario dentro de la Estrategia.</p><p>El Instituto Nacional de las Mujeres destinó una parte del presupuesto a la elaboración de estudios y diagnósticos algunos de estos desarrollados por el Instituto Nacional de Salud Pública, entre los que se encuentran: el Plan de Monitoreo y del Esquema de Evaluación de la Estrategia Nacional para la Prevención del Embarazo Adolescente; el Estudio sobre la prevención del embarazo en adolescentes desde las masculinidades, la asesoría y acompañamiento para la implementación y seguimiento de la ENAPEA y el curso para “Madres y padres en la prevención del embarazo adolescente”.</p><p>En 2015 más del 50% del gasto asignado al Instituto Nacional de Salud Pública (INSP) para la ENAPEA se destinó a “asesorías”, “congresos y convenciones”. Este punto merece atención ya que este tipo de programas debe ir para actividades de atención directa de la población objetivo.</p><p>En 2016 el Instituto Nacional de Salud Pública (INSP), ejerció más del 40% en rubros que no guardan relación directa con las líneas de acción de la ENAPEA. Los comprobantes amparan la renta de maquinaria pesada, pago de servicios como luz y agua, fumigación, lavandería, jardinería, renta de estacionamiento público, compra de uniformes, combustibles, productos químicos y otros rubros, sin explicar cómo estos gastos contribuyen a prevenir el embarazo adolescente. De acuerdo con los comprobantes fiscales presentados, los montos ejercidos van de los 150 mil hasta los 500 mil pesos por factura.</p><p>Posterior a la entrega de la copia de los comprobantes fiscales, el INSP envió un oficio (SRF/0034/17) informando que existía un “error involuntario” en la entrega correspondiente al ejercicio fiscal 2016, aduciendo que “el personal que le fue encomendado dar atención dio una mala interpretación a las solicitudes recibidas” y “omitió incluir el gasto correspondiente a servicios personales”. Con este cambio, 62.8% del ejercicio para 2016 quedó bajo el rubro de servicios personales; ello modifica radicalmente la primera respuesta y elimina todos los gastos que no guardaban relación directa con la ENAPEA. Puedes consultar las nuevas facturas <a href=\"https://www.dropbox.com/sh/eyntz9aean3zap8/AADK6Iwv4EpwyQo8L4lNfI8ua?dl=0\" target=\"_blank\">aquí.</a></p><p>Estos hallazgos resultan relevantes ya que al ser escasos los recursos identificados para la coordinación de las acciones, estos deberían ser aplicados con mayor precisión.</p><p>El diseño de una política de estas características debe tomar en cuenta que el cumplimiento de objetivos no puede estar desvinculado de los instrumentos que dan seguimiento a los recursos, las organizaciones y los responsables de su ejecución, y en especial quienes ejecutan el recurso deben percibir que sus decisiones cotidianas tienen un impacto que puede facilitar o hacer más difícil la labor de comprobación. Como señalan expertos en la materia, se trata de que estos planes y estrategias se articulen a la planeación cotidiana, con las decisiones de presupuesto, personal, información y rendición de cuentas.</p><p>La inversión en el proyecto de vida de niñas, niños y adolescentes tendrá repercusiones en el desarrollo que como país nos planteamos, es por eso que los recursos para la Estrategia de Prevención del Embarazo en Adolescentes, deberían aumentar y contar con un modelo más riguroso y transparente para la rendición de cuentas.</p><p>La contraloría social busca reducir las asimetrías de información entre el gobierno y la ciudadanía, en el ILSB confiamos que estos ejercicios contribuyen a incentivar la rendición de cuentas de las instituciones y eficientar el uso de los recursos públicos en atender uno de los problemas más urgentes que enfrentan las personas jóvenes de nuestro país.</p></div></div><div class=\"downloadBtn center-align\"><a class=\"btn\" href=\"https://www.dropbox.com/sh/eyntz9aean3zap8/AADK6Iwv4EpwyQo8L4lNfI8ua?dl=0\" target=\"_blank\"><img src=\"./assets/images/download-icon.png\"> Consulta probatorios</a></div><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/evaluacion/evaluacion.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Evaluación de programas de prevención</h2><p>Aquí se presenta la Evaluación del Diseño de una serie de políticas locales dirigidas a la población adolescente en materia de salud sexual y reproductiva, especialmente en los rubros de prevención y atención del embarazo en adolescentes.</p></div><div class=\"loading\" ng-show=\"vm.loading\"><div class=\"mask\" style=\"height:300px;\"><img src=\"./assets/images/loading.gif\"></div></div><scatter-evaluacion evaluaciones=\"vm.evaluaciones\" programas=\"vm.programas_por_edo\" data=\"vm.data\" json=\"vm.json\"></scatter-evaluacion><div class=\"texto\"><p>Para su elaboración, se retomó el Modelo de Términos de Referencia en Materia de Diseño (MRD) desarrollado por Consejo Nacional de Evaluación de la Política Social (CONEVAL). Si bien la Ley General de Planeación no obliga a seguir un modelo de Gestión por Resultados (GpR), base de la evaluación que lleva a cabo el CONEVAL, es de esperarse que la política pública, para poder implementarse, tenga un diseño lo suficientemente robusto para responder bien a una evaluación de este tipo.</p><p>Las 21 preguntas del MRD fueron adaptadas a la investigación respetando el sentido original de su elaboración:</p><p><ul><li>Justificación de la creación y del diseño del programa</li><li>Contribución a los objetivos nacionales y a los sectoriales</li><li>Población potencial y objetivo</li><li>Matriz de Indicadores para Resultados (MIR)</li><li>Complementariedades y coincidencias con otros programas (en este caso estatales)</li></ul></p><p>Cada uno de estos puntos está representado gráficamente, de modo que pueda observarse como una calificación del 0 al 10. Como puede observarse, sólo uno de los programas evaluados contaría con una calificación aprobatoria. Por tanto, el diseño de la política para la prevención y atención del embarazo en adolescentes sería más que cuestionable.</p><p>Aunque esta no es una evaluación de los resultados o del impacto de la política pública, las deficiencias en el diseño no sólo advierte resultados malos o engañosos, sino que dificulta el seguimiento del ciclo de la política pública y permite que la rendición de cuentas tienda a la opacidad.</p><p>Para realización de esta evaluación, se elaboraron una serie de solicitudes de información pública a las instancias correspondientes siguiendo un <a href=\"http://ilsb.org.mx/wp-content/uploads/2016/03/Manual-de-Contralor%C3%ADa.pdf\" target=\"_blank\">modelo de Contraloría Social diseñado por el ILSB.</a></p><p>Las evaluaciones completas, los folios de las solicitudes de información y más información pertinente pueden revisarse en los documentos: <i>Análisis del diseño de las políticas, programas y acciones institucionales para la prevención del embarazo adolescente de los estados de Guanajuato, Morelos, Puebla, Quintana Roo, Veracruz, México, ILSB-Embajada de Países Bajos-INMujeres, 2015.</i></p></div></div><download-button json=\"vm.dataDownload\" ng-show=\"vm.dataDownload.length > 0\"></download-button><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/gasto/gasto.html","<div><mapa-gastos json=\"vm.json\" gasto=\"vm.gasto\"></mapa-gastos><div class=\"texto\"></div></div>");
$templateCache.put("app/hallazgos/hallazgos.html","<div class=\"container hallazgos-container\"><div class=\"texto\"><h2 class=\"titleViz\">Hallazgos de la contraloría social entorno a la corresponsabilidad masculina</h2></div><div class=\"container-viz container\"><div class=\"dropdowns\"><div class=\"drop\"><label>Entidad</label><div class=\"dropdown\"><button class=\"btn btn-primary dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">{{vm.stateSelected}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-click=\"vm.stateSelected = \'Aguascalientes\'\" ng-show=\"vm.states[\'Aguascalientes\'] != undefined\">Aguascalientes</li><li ng-click=\"vm.stateSelected = \'Baja California\'\" ng-show=\"vm.states[\'Baja California\'] != undefined\">Baja California</li><li ng-click=\"vm.stateSelected = \'Baja California Sur\'\" ng-show=\"vm.states[\'Baja California Sur\'] != undefined\">Baja California Sur</li><li ng-click=\"vm.stateSelected = \'Campeche\'\" ng-show=\"vm.states[\'Campeche\'] != undefined\">Campeche</li><li ng-click=\"vm.stateSelected = \'Coahuila\'\" ng-show=\"vm.states[\'Coahuila\'] != undefined\">Coahuila</li><li ng-click=\"vm.stateSelected = \'Colima\'\" ng-show=\"vm.states[\'Colima\'] != undefined\">Colima</li><li ng-click=\"vm.stateSelected = \'Chiapas\'\" ng-show=\"vm.states[\'Chiapas\'] != undefined\">Chiapas</li><li ng-click=\"vm.stateSelected = \'Chihuahua\'\" ng-show=\"vm.states[\'Chihuahua\'] != undefined\">Chihuahua</li><li ng-click=\"vm.stateSelected = \'Distrito Federal\'\" ng-show=\"vm.states[\'Distrito Federal\'] != undefined\">Distrito Federal</li><li ng-click=\"vm.stateSelected = \'Durango\'\" ng-show=\"vm.states[\'Durango\'] != undefined\">Durango</li><li ng-click=\"vm.stateSelected = \'Guanajuato\'\" ng-show=\"vm.states[\'Guanajuato\'] != undefined\">Guanajuato</li><li ng-click=\"vm.stateSelected = \'Guerrero\'\" ng-show=\"vm.states[\'Guerrero\'] != undefined\">Guerrero</li><li ng-click=\"vm.stateSelected = \'Hidalgo\'\" ng-show=\"vm.states[\'Hidalgo\'] != undefined\">Hidalgo</li><li ng-click=\"vm.stateSelected = \'Jalisco\'\" ng-show=\"vm.states[\'Jalisco\'] != undefined\">Jalisco</li><li ng-click=\"vm.stateSelected = \'Estado de México\'\" ng-show=\"vm.states[\'Estado de México\'] != undefined\">Estado de México</li><li ng-click=\"vm.stateSelected = \'Michoacán\'\" ng-show=\"vm.states[\'Michoacán\'] != undefined\">Michoacán</li><li ng-click=\"vm.stateSelected = \'Morelos\'\" ng-show=\"vm.states[\'Morelos\'] != undefined\">Morelos</li><li ng-click=\"vm.stateSelected = \'Nayarit\'\" ng-show=\"vm.states[\'Nayarit\'] != undefined\">Nayarit</li><li ng-click=\"vm.stateSelected = \'Nuevo León\'\" ng-show=\"vm.states[\'Nuevo León\'] != undefined\">Nuevo León</li><li ng-click=\"vm.stateSelected = \'Oaxaca\'\" ng-show=\"vm.states[\'Oaxaca\'] != undefined\">Oaxaca</li><li ng-click=\"vm.stateSelected = \'Puebla\'\" ng-show=\"vm.states[\'Puebla\'] != undefined\">Puebla</li><li ng-click=\"vm.stateSelected = \'Querétaro\'\" ng-show=\"vm.states[\'Querétaro\'] != undefined\">Querétaro</li><li ng-click=\"vm.stateSelected = \'Quintana Roo\'\" ng-show=\"vm.states[\'Quintana Roo\'] != undefined\">Quintana Roo</li><li ng-click=\"vm.stateSelected = \'San Luis Potosí\'\" ng-show=\"vm.states[\'San Luis Potosí\'] != undefined\">San Luis Potosí</li><li ng-click=\"vm.stateSelected = \'Sinaloa\'\" ng-show=\"vm.states[\'Sinaloa\'] != undefined\">Sinaloa</li><li ng-click=\"vm.stateSelected = \'Sonora\'\" ng-show=\"vm.states[\'Sonora\'] != undefined\">Sonora</li><li ng-click=\"vm.stateSelected = \'Tabasco\'\" ng-show=\"vm.states[\'Tabasco\'] != undefined\">Tabasco</li><li ng-click=\"vm.stateSelected = \'Tamaulipas\'\" ng-show=\"vm.states[\'Tamaulipas\'] != undefined\">Tamaulipas</li><li ng-click=\"vm.stateSelected = \'Tlaxcala\'\" ng-show=\"vm.states[\'Tlaxcala\'] != undefined\">Tlaxcala</li><li ng-click=\"vm.stateSelected = \'Veracruz\'\" ng-show=\"vm.states[\'Veracruz\'] != undefined\">Veracruz</li><li ng-click=\"vm.stateSelected = \'Yucatán\'\" ng-show=\"vm.states[\'Yucatán\'] != undefined\">Yucatán</li><li ng-click=\"vm.stateSelected = \'Zacatecas\'\" ng-show=\"vm.states[\'Zacatecas\'] != undefined\">Zacatecas</li></ul></div></div></div><div class=\"table-hr\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[vm.stateSelected].color[0]+\',\'+vm.states[vm.stateSelected].color[1]+\',\'+vm.states[vm.stateSelected].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[vm.stateSelected].color[0]+\',\'+vm.states[vm.stateSelected].color[1]+\',\'+vm.states[vm.stateSelected].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p ng-repeat=\"h in vm.states[vm.stateSelected].hallazgos\">{{h}}</p></div><div class=\"content\"><p ng-repeat=\"r in vm.states[vm.stateSelected].recomendaciones\">{{r}}</p></div></div></div><div class=\"narrativa\"><div class=\"resumen\" style=\"background:rgb({{vm.states[vm.stateSelected].color[0]+\',\'+vm.states[vm.stateSelected].color[1]+\',\'+vm.states[vm.stateSelected].color[2]}})\"><h2>{{vm.stateSelected}}</h2><p>{{vm.states[vm.stateSelected].resumen}}</p><a class=\"btn leer\" style=\"color:rgb({{vm.states[vm.stateSelected].color[0]+\',\'+vm.states[vm.stateSelected].color[1]+\',\'+vm.states[vm.stateSelected].color[2]}}) !important\" ui-sref=\"narrativa-{{vm.stateSelected.toLowerCase();}}\">LEER INVESTIGACIÓN</a></div><div class=\"video\" ng-show=\"vm.states[vm.stateSelected].portada != \'\'\"><div class=\"portada\"><img src=\"./assets/images/portadas/{{vm.states[vm.stateSelected].portada}}.png\"></div></div></div></div></div><div class=\"downloadBtn center-align\"><a class=\"btn\"><img src=\"./assets/images/download-icon.png\">Descargar datos</a></div><div class=\"floatBtn btnHallazgos\" ng-class=\"{\'btn-active\' : vm.show}\"><img src=\"./assets/images/arrow.png\" ng-click=\"vm.updateBtn();\"><p ui-sref=\"corresponsabilidad\">Corresponsabilidad masculina</p></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"p-titulo\"><p><strong>Esta plataforma es un esfuerzo interdisciplinario</strong> que apoyado en herramientas de análisis y visualización de datos, busca aportar a la discusión pública sobre la situación del embarazo y la maternidad en la adolescencia desde diversos ángulos, revisa la situación demográfica, el acceso a servicios de salud, el gasto en materia de prevención, el impacto en las actividades y roles de este grupo de la población en función de un embarazo, además de evaluar programas y acciones institucionales en algunos estados de la república enfocados en la prevención y atención de este tema.</p></div></div></div><div class=\"videoHome\"><video-section color=\"\'rgb(119,13,180)\'\" video=\"\'9Vtp82WBetY\'\" thumbnail=\"\'home\'\" onlyvideo=\"true\"></video-section></div></div><ul class=\"main-menu\"><li ng-repeat=\"opt in opciones\" ui-sref-active=\"active\" style=\"background:url(\'./assets/images/{{opt.view}}.png\')\"><div class=\"mask\" ng-class=\"vm.getClass($index);\" ui-sref=\"{{opt.view}}\"><span>{{opt.label}}</span></div></li></ul><div class=\"gray-container\"><div class=\"container\"><div class=\"botonesDescarga\"><a class=\"btn\" style=\"background:rgb(251,101,0)\" href=\"./assets/files/Hallazgos generales.pdf\" target=\"_blank\"><img src=\"./assets/images/download-icon.png\">Descargar hallazgos</a> <a class=\"btn\" style=\"background:rgb(94,197,200)\" href=\"./assets/files/Hoja de datos.pdf\" target=\"_blank\"><img src=\"./assets/images/download-icon.png\">Descargar Datos</a> <a class=\"btn\" style=\"background:rgb(255,161,25)\" href=\"./assets/files/Demandas a autoridades.pdf\" target=\"_blank\"><img src=\"./assets/images/download-icon.png\">Descargar Demandas</a></div></div></div>");
$templateCache.put("app/presupuesto-gasto-prevencion/presupuesto-gasto-prevencion.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Presupuesto y gasto para prevención</h2><p>Este apartado presenta los presupuestos estatales asignados entre 2010 y 2016 destinados al Centro Nacional de Equidad de Género y Salud Reproductiva (CNEGSR), y a dos de sus Programas de Acción Específica: Salud Sexual y Reproductiva para Adolescentes y Planificación Familiar y Anticoncepción.</p></div><div class=\"loading\" ng-show=\"vm.loading\"><div class=\"mask\" style=\"height:500px;\"><img src=\"./assets/images/loading.gif\"></div></div><mapa-presupuesto-gasto json=\"vm.json\" presupuesto=\"vm.presupuesto\" gasto=\"vm.gasto\"></mapa-presupuesto-gasto><div class=\"texto\"><p>Se puede observar que el programa de “Salud Sexual y Reproductiva para Adolescentes” recibe uno de los menores presupuestos del CNEGSR.</p><p>Durante 2010 en algunos estados el presupuesto asignado a este programa no rebasó el millón de pesos. Baja California como caso excepecional recibió apenas $25, 940. 00.</p><p>Para 2016, el presupuesto del programa de “Salud Sexual y Reproductiva para Adolescentes” no rebaso el 6% del total asignado al CNEGSR en cada uno de los estados. Como ejemplo el Estado de México destinó 4 millones de los 526.6 millones que se asignaron.</p><p>Entidades como Guanajuato, Querétaro y la Ciudad de México destinaron la mayor cantidad de presupuesto a este programa, sin embargo, ninguna entidad rebaso el 15 por ciento del presupuesto total de sus Centros de Equidad de Género y Salud Reproductiva.</p><p>El programa de acción “Planificación Familiar y Anticoncepción” recibe mayor presupuesto en comparación con el programa de “Salud Sexual y Reproductiva para Adolescentes”.</p><p>En los estados de Coahuila, Durango y Chihuahua que tienen las mayores Tasas de nacimientos en mujeres adolescentes, los porcentajes difierentre entre el 15 por ciento y el 75 por ciento de sus presupuestos destinado a planificación familiar y anticoncepción.</p><h3>Gasto en prevención por adolescente</h3><p>En esta sección se muestra el gasto que los gobiernos estatales ejercen por cada adolescente, según los presupuestos asignados a los Programas de Acción Específica de la Secretaria de Salud: Salud Sexual y Reproductiva para Adolescentes y Planificación Familiar y Anticoncepción de los años 2010-2016</p><p>Para el año 2010, el programa de Salud Sexual y Reproductiva para Adolescentes en los estados de Baja California, Chiapas, Coahuila, Durango, Hidalgo, Michoacán, Querétaro, Quintana Roo, San Luis Potosí, Tabasco, Tamaulipas, destinó menos de un peso a cada adolescente.</p><p>Para 2016 creció de forma moderada, de modo que estados Chiapas, Ciudad de México, Jalisco, Estado de México, Nuevo Léon, Oaxaca, Puebla, San Luis Potosí, Tamaulipas y Yucatán, destinaron menos de 5 pesos por adolescente.</p></div></div><download-button json=\"vm.presupuestoDownload\" ng-show=\"vm.presupuestoDownload.length > 0\" title=\"\'Descargar presupuesto\'\"></download-button><download-button json=\"vm.gastoDownload\" ng-show=\"vm.gastoDownload.length > 0\" title=\"\'Descargar gasto\'\"></download-button><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/narrativas/aguascalientes.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Aguascalientes\'\" color=\"vm.states[\'Aguascalientes\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Inexistencia de servicios de traducción en Unidades de Salud del Primer Nivel de Atención, así como de sensibilización, Capacitación e infraestructura con perspectiva intercultural</p></div><div class=\"content gray\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content gray\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content\"><p>Asegurar capacitaciones para el conocimiento de la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte fundamental de la atención para las mujeres que son víctimas de violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Aguascalientes.</p></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Inexistencia de servicios de traducción en Unidades de Salud del Primer Nivel de Atención, así como de sensibilización, Capacitación e infraestructura con perspectiva intercultural</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Asegurar capacitaciones para el conocimiento de la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte fundamental de la atención para las mujeres que son víctimas de violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Aguascalientes.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\" ng-show=\"vm.index < 2\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>La distribución de métodos anticonceptivos en el Estado de Aguascalientes, se reportó de en dos apartados de entrega, por un lado los que se entregaron dentro de las unidades de planificación familiar y los que se entregaron fuera de estas unidades (folio 32478).</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos en Aguascalientes</h3><div><multibarchart series=\"[{ name: \'Fuera de unidades de salud\', data: [16048,16302,9455,0,0,349016,0,0,0,0,0], color: \'#B24600\' }, { name: \'Dentro de unidades de salud\', data: [12903,16552,18619,2991,2910,405256,802,505,9020,1209,924], color:\'#FF6500\' }]\" categories=\"[\'Oral\', \'Inyectable mensual\', \'Inyectable bimestral\', \'Implante subdérmico\', \'DIU\',\'Preservativo\',\'Otro método\',\'DIU medicado\',\'Parche dérmico\',\'Anticoncep- ción de emergencia\',\'Preservativo femenino\']\"></multibarchart></div><p>La distribución de métodos anticonceptivos en el Estado de Aguascalientes, se reportó de en dos apartados de entrega, por un lado los que se entregaron dentro de las unidades de planificación familiar y los que se entregaron fuera de estas unidades (folio 32478).</p><h4 style=\"color:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Respecto de la información de personas hablantes de lengua indígena que pudieran asistir a otras personas que requirieran traductores el Instituto de Servicios de Salud del Estado de Aguascalientes, refirió que no se contaba con traductores en las unidades de salud, por la siguiente razón:</p><p class=\"italic\">Le hago saber que no se ha presentado el caso de pacientes de lengua indígena, por lo tanto no se ha requerido contar con traductor de lengua indígena (folio 32498).</p><p>Con base en dicha razón, el ISSEA respondió que no se contaba con materiales de difusión de métodos anticonceptivos producidos en lenguas.</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Aguascalientes\'].color[0]+\',\'+vm.states[\'Aguascalientes\'].color[1]+\',\'+vm.states[\'Aguascalientes\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Al realizar preguntas de acceso a la información relativas a las medios de difusión y comunicación relativos a la corresponsabilidad masculina, el Instituto de Servicios de Salud del Estado de Aguascalientes informó que los materiales de difusión y comunicación relativos a la corresponsabilidad masculina consistieron en dípticos y trípticos con los siguientes temas:</p><ul><li>Derechos sexuales y reproductivos</li><li>Beneficios de la planificación familiar</li><li>Vasectomía</li><li>Módulos de servicios amigables</li><li>Prevención de embarazo</li><li>Anticoncepción de emergencia</li><li>Regleta de métodos anticonceptivos</li><li>Ciclo menstrual</li></ul><p>Como se puede observar, <strong>resalta que uno de los dos métodos aborados en dichos materiales sea la vasectomía y que ninguno lleve por título o tema la corresponsabilidad masculina (folio 32510).</strong> Este es otro elemento central, ya que la vasectomía no la única manera en la que la corresponsabilidad masculina puede ser planteada dentro la planificación familiar, menos aún dentro en el marco de una estrategia para la prevención del embarazo en la población adolescente.</p><download color=\"vm.states[\'Aguascalientes\'].color\" link=\"\'./assets/files/Aguascalientes.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, ]\"></continuar-leyendo>");
$templateCache.put("app/narrativas/chiapas.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Chiapas\'\" color=\"vm.states[\'Chiapas\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Dotación escasa de métodos anticonceptivos.</p></div><div class=\"content gray\"><p>Asegurar recursos suficientes para dotar de métodos anticonceptivos a las unidades de salud, tanto de Anticonceptivos Reversibles de Acción Prolongada (ARAP), así como métodos de barrera.</p></div><div class=\"content gray\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Dotación escasa de métodos anticonceptivos.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Asegurar recursos suficientes para dotar de métodos anticonceptivos a las unidades de salud, tanto de Anticonceptivos Reversibles de Acción Prolongada (ARAP), así como métodos de barrera.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\" ng-show=\"vm.index < 4\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>La Secretaría de Salud de Chiapas señala que es el Centro Nacional de Equidad de Gpenero y Salud Reproductiva (CNEGSyR) quien efectúa la compra del total de métodos anticonceptivos.</p><p>En el reporte no se menciona la adquisición de condones masculinos y femeninos.</p><p>Solo se reporta un total de 257,464 anticonceptivos inyectables mensuales y 107,083 bimestrales; 10,190 parches dérmicos y 10,190 DIUs T de cobre (Folios del 15191 al 15195).</p><p>La cantidad de métodos anticonceptivos es alta, pero no se conoce su distribución a las unidades de salud regionales (Folio 15192).</p></div><video-section color=\"\'rgb(\'+vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]+\')\'\" video=\"\'JR6P4oFGn8o\'\" thumbnail=\"\'chiapas\'\" texto=\"\'La cantidad de métodos anticonceptivos es alta, pero no se conoce su distribución a las unidades de salud regionales No. de folio 15192\'\" autor=\"\'-Martha López Gómez, Promui\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Preguntamos sobre el número de traductores a lenguas indígenas que asisten a otras personas hablantes en las unidades de salud, la Secretaría de Salud de Chiapas respondió que no cuentan con personas acreditadas como traductoras:</p><p class=\"italic\">Me permito informar que en esta Institución no contamos con traductores contratados de lengua Indígena. Sin embargo, contamos con Auxiliares de Salud, personas capacitadas por esta Institución de las diversas localidades quienes apoyan en la traducción de las atenciones que solicitan los habitantes de las localidades de lengua indígena. (Folio 15205)</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Chiapas\'].color[0]+\',\'+vm.states[\'Chiapas\'].color[1]+\',\'+vm.states[\'Chiapas\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Buscamos conocer las acciones que se tienen contempladas desde las unidades de salud, en torno a la corresponsabilidad masculina para la prevención de embarazos y nos respondieron:</p><p class=\"italic\">“…en lo referente a corresponsabilidad masculina en la planificación familiar no se cuenta con capacitaciones impartidas sobre corresponsabilidad masculina en la Planificación Familiar” ( Folio 15110).</p><p>En caso de estos materiales con un enfoque de interculturalidad la Secretaría de Salud de Chiapas señalo que no los tenía contemplados ya que “el líder de esta estrategia es CONAPO a nivel nacional” (Folio 15112).En caso de estos materiales con un enfoque de interculturalidad la Secretaría de Salud de Chiapas señalo que no los tenía contemplados ya que “el líder de esta estrategia es CONAPO a nivel nacional” (Folio 15112).</p><download color=\"vm.states[\'Chiapas\'].color\" link=\"\'./assets/files/Chiapas.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, ]\"></continuar-leyendo>");
$templateCache.put("app/narrativas/guanajuato.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Guanajuato\'\" color=\"vm.states[\'Guanajuato\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content gray\"><p>Derogación de dicha condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content gray\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención de la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Derogación de dicha condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención de la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\" ng-show=\"vm.index < 4\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Se encontró un abasto de métodos anticonceptivos en las siguientes gamas: Oral, Inyectable mensual, Implante subdérmico, DIU, Preservativo masculino, Parche dérmico, pastillas anticonceptivas de emergencia. En las respuestas obtenidas no se reportaron condones femeninos para el estado. (folio: 0125557)</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos en el estado de Guanajuato</h3><div><barchart data=\"[{name:\'Condones masculinos\',y:265000,color:\'#5EC5C8\'},{name:\'Implante Hormonal Subdérmico\',y:4800,color:\'#009242\'},{name:\'Dispositivo Intrauterino\', y:5900, color:\'#7000B0\'}, {name:\'Pastillas Anticonceptivas\',y:15220, color:\'#E00F7B\'},{name:\'Parche Anticonceptivo \',y:6100,color:\'#FF6500\'},{name:\'Anticoncepción hormonal Inyectable\', y:24600, color:\'#3DA5D9\'}]\"></barchart></div></div><video-section color=\"\'rgb(\'+vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]+\')\'\" video=\"\'zJ0mptSEsbY\'\" thumbnail=\"\'guanajuato\'\" texto=\"\'“¿Tenemos condones femeninos?“. La persona del almacén dijo “sí, nos dieron uno“, y la doctora le preguntó “¿y en dónde está?“. “Yo lo tengo, me lo dieron a mí“. Es decir que la persona responsable del almacén se lo quedó para uso personal. \'\" autor=\"\'– Elena Sandoval (Investigadora, Redefine Guanajuato)\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Respecto de la información de personas hablantes de alguna lengua indígena que pudieran asistir a otras personas que requirieran traductores, la Secretaría de Salud de Guanajuato-Instituto de Salud Pública del Estado de Guanajuato (SSG–ISAPEG) respondió que la Jurisdicción Sanitaria II no contaba con traductores en las unidades de salud, y expresamente:</p><p class=\"italic\">“…lo que se ha observado es que las localidades donde se tienen identificados pacientes indígenas (estos) hablan español y su lengua materna, en algunas (unidades) hablan Chichimeca y en otras Otomí.”</p><p class=\"right-align\">Secretaría de Salud de Guanajuato, No. de Folio 25577.</p><p>Bajo el argumento anterior las autoridades de salud determinaron que no era necesario contar con traductores en las unidades:</p><p class=\"italic\">“Había el año pasado trípticos sobre interculturalidad. Vienen los que venden semillas y yo, (habla la Doctora), les pregunto su dialecto. Las mujeres indígenas son las que vienen más acompañadas, los esposos fungen como intérpretes”</p><p class=\"right-align\">Entrevista con personal médico en Unidad de Salud Urbana.</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Guanajuato\'].color[0]+\',\'+vm.states[\'Guanajuato\'].color[1]+\',\'+vm.states[\'Guanajuato\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>En las respuestas de acceso a la información se indica, sin explicar a fondo los contenidos, sobre 16 talleres que incluyen el tema de corresponsabilidad como “introducción a la Planificación Familiar y Taller”; “Capacitación Mensual de Salud Reproductiva”; “Taller Métodos de Planificación Familiar”; “Taller de Servicios Amigables y Planificación Familiar”; “Capacitación en Planificación Familiar (ICE)” y “Encuentro de Métodos Certificados en Vasectomía”. Todos dirigidos a personal médico de las unidades de salud de primer y segundo nivel de atención de los municipios.</p><p>Ninguno de los talleres hace referencia a la corresponsabilidad masculina en el ejercicio de la sexualidad por parte de adolescentes y jóvenes. (folio: 1625592).</p><div><piechart data=\"[{ name: \'Mujeres\', y: 68.19, color:\'#FFAD00\' }, { name: \'Hombres\', y: 31.81, color:\'#FF6500\' }]\"></piechart></div><download color=\"vm.states[\'Guanajuato\'].color\" link=\"\'./assets/files/Guanajuato.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, ]\"></continuar-leyendo>");
$templateCache.put("app/narrativas/guerrero.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Guerrero\'\" color=\"vm.states[\'Guerrero\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content gray\"><p>Derogación de la condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content gray\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Existencia de campañas de corresponsabilidad masculina con traducción a una lengua indígena de la región.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Promover, replicar y escalara estas campañas de forma suficiente para las zonas con mayor presencia indígena en la entidad. Innovar en campañas de corresponsabilidad que vayan más allá de trípticos de vasectomía sin bisturí. Traducir las campañas a otras lenguas indígenas de la región.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Condicionante de atención en salud sexual y reproductiva al estado civil (casado(a)) o la estabilidad de pareja.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015) señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Existencia de campañas de corresponsabilidad masculina con traducción a una lengua indígena de la región.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 5\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content\" ng-show=\"vm.index == 6\"><p>Condicionante de atención en salud sexual y reproductiva al estado civil (casado(a)) o la estabilidad de pareja.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Derogación de la condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Promover, replicar y escalara estas campañas de forma suficiente para las zonas con mayor presencia indígena en la entidad. Innovar en campañas de corresponsabilidad que vayan más allá de trípticos de vasectomía sin bisturí. Traducir las campañas a otras lenguas indígenas de la región.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 5\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"content\" ng-show=\"vm.index == 6\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015) señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\" ng-show=\"vm.index < 6\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Solo 8.6 por ciento de los municipios de todo el estado de Guerrero reportan distribución de métodos anticonceptivos.</p><p>La distribución fue reportada de la siguiente manera:</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\"><span>Distribución</span></th><th>Condón masculino</th><th class=\"impar\">Condón femenino</th><th>Implante Hormonal Subdérmico</th><th class=\"impar\">Parche Anticonceptivo</th><th>Anticoncepción inyectable</th><th class=\"impar\">DIU</th><th>Pastilla de Anticoncepción de Emergencia</th></tr></thead><tbody><tr><td>Estatal<br>(total)</td><td class=\"gray\">1,248,800</td><td>187</td><td class=\"gray\">13,714</td><td>15,605</td><td class=\"gray\">58,246</td><td>624</td><td class=\"gray\">54,476</td></tr><tr><td class=\"gray\">Tlapehuala</td><td>160,000</td><td class=\"gray\">S/I</td><td>225</td><td class=\"gray\">1,245</td><td>2,000</td><td class=\"gray\">40</td><td>6,196</td></tr><tr><td>Iguala de la Independencia</td><td class=\"gray\">S/I</td><td>S/I</td><td class=\"gray\">1,670</td><td>2,800</td><td class=\"gray\">S/I</td><td>90</td><td class=\"gray\">8,380</td></tr><tr><td class=\"gray\">Chilpancingo</td><td>195,600</td><td class=\"gray\">S/I</td><td>4,547</td><td class=\"gray\">3,200</td><td>20,845</td><td class=\"gray\">219</td><td>20,845</td></tr><tr><td>Tlapa de Comonfort</td><td class=\"gray\">S/I</td><td>S/I</td><td class=\"gray\">2,650</td><td>1,950</td><td class=\"gray\">7,036</td><td>15</td><td class=\"gray\">7,570</td></tr><tr><td class=\"gray\">Tecpan de Galeana</td><td>S/I</td><td class=\"gray\">S/I</td><td>870</td><td class=\"gray\">2,400</td><td>4,215</td><td class=\"gray\">60</td><td>7,000</td></tr><tr><td>Ometepec</td><td class=\"gray\">380,000</td><td>S/I</td><td class=\"gray\">2,120</td><td>2,000</td><td class=\"gray\">21,300</td><td>30</td><td class=\"gray\">8,780</td></tr><tr><td class=\"gray\">Acapulco</td><td>14,600</td><td class=\"gray\">187</td><td>1,650</td><td class=\"gray\">2,010</td><td>2,850</td><td class=\"gray\">170</td><td>8,150</td></tr></tbody></table></div><div class=\"texto fuente-table\"><p>Fuente: Solicitudes de información a la Secretaría de Salud del Estado de Guerrero (folios). i Incluye mensual y bimensual. ii Sólo reportó distribución de inyección bimensual. iii Sólo reportó distribución de inyección mensual.</p></div><div class=\"texto\"><p>Se centran en sólo 7 de 81 municipios: Acapulco, Chilpanchingo, Iguala de la Independencia, Tlapehuala, Tecpan de Galeana, Tlapa de Comonfort y Ometepec. (Folios con número: 00108016, 00108216, 00108316, 00108416 y 00108116).</p></div><video-section color=\"\'rgb(\'+vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]+\')\'\" video=\"\'JxyDzhpfKbk\'\" thumbnail=\"\'Guerrero\'\" texto=\"\'“…no tenemos la cantidad necesaria de métodos anticonceptivos para su uso, hay mujeres esperando a que lleguen los implantes desde hace mucho tiempo, y condones femeninos no hay, ni anticonceptivos de emergencia” \'\" autor=\"\'Personal médico entrevistado en la unidad rural\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Sobre materiales de difusión de métodos anticonceptivos elaborados en lenguas indígenas la Secretaría de Salud de Guerrero refirió que:</p><p class=\"italic\">La Campaña de Mercadotecnia Social en Salud de Planificación Familiar y Anticoncepción cuenta con diseños específicos para población indígena. Estos materiales son visuales y de audio, y fueron transmitidos en las Zonas de la Montaña (Folio no. 00109116).</p><img src=\"./assets/images/guerrero-image.png\" class=\"center-align img-responsive\"><p>La página web a la que refiere la campaña (http://www.yqusexo.com.mx), fungía como un órgano de difusión y sensibilización del Centro Nacional para la Equidad de Género y Salud Reproductiva (CNGESyR), pero lleva inactiva desde 2015.</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Sobre las campañas de comunicación para la corresponsabilidad masculina en la planificación familiar, la Secretaría de Salud de Guerrero respondió:</p><p class=\"italic\">“Dentro de la Campaña de Mercadotecnia Social en Salud referente a planificación familiar, fueron diseñados materiales de comunicación dirigido el hombre, los que buscan lograra la participación activa en la planificación familiar. Estos materiales son microperforados con mensajes dirigidos al género masculino y fueron colocados en unidades de transporte público, y vehículos particulares en zonas urbanas. Fueron distribuidos un total de 2,000 microperforados en las ciudades de: Chilpancingo, Acapulco e Iguala.”</p><p class=\"italic\">“Además de tener pendientes la entrega de 5,000 trípticos de vasectomía sin bisturí. Al respecto de campañas de mercadotecnia social en salud de corresponsabilidad del hombre en idioma indígena, hago de su conocimiento que no se realizó ningún material informativo de este tipo; sin embargo en las zonas rurales se llevan a cabo pláticas y talleres de planificación familiar con colaboración de intérpretes. De igual manera fue reproducido un spot de audio en idioma mep´ha”.</p><p class=\"right-align\">Folio no. 00109816</p><p class=\"italic\">“Manejamos trípticos, folletos, pero creo que no hay, ya que llegan pocos y esos se reparten de inmediato (…) Considero que serviría de mucho que nos proporcionaran material audio-visual para su promoción, ya que este material es más aceptable por la sociedad y se le entiende más”</p><p class=\"right-align\">– Personal médico entrevistado en la unidad urbana</p><download color=\"vm.states[\'Guerrero\'].color\" link=\"\'./assets/files/Guerrero.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Guerrero\'].color[0]+\',\'+vm.states[\'Guerrero\'].color[1]+\',\'+vm.states[\'Guerrero\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/morelos.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Morelos\'\" color=\"vm.states[\'Morelos\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Se ubicaron insuficientes servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención</p></div><div class=\"content gray\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content gray\"><p>Insuficientes cursos de capacitación/sensibilización sobre la perspectiva de género a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"content\"><p>Dotar y proveer mayores herramientas para la transversalización de la perspectiva de género al personal médico unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Insuficientes cursos de capacitación/sensibilización sobre la corresponsabilidad masculina en la planificación familiar a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Dotar y proveer mayores herramientas para la sensibilización respecto a la corresponsabilidad masculina en la planificación familiar a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Se ubicaron insuficientes servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Insuficientes cursos de capacitación/sensibilización sobre la perspectiva de género a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Insuficientes cursos de capacitación/sensibilización sobre la corresponsabilidad masculina en la planificación familiar a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Dotar y proveer mayores herramientas para la transversalización de la perspectiva de género al personal médico unidades de salud de primer y segundo nivel de atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Dotar y proveer mayores herramientas para la sensibilización respecto a la corresponsabilidad masculina en la planificación familiar a personal médico de unidades de salud de primer y segundo nivel de atención.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\" ng-show=\"vm.index < 3\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><p>Para el trabajo de campo se eligieron las unidades de salud de Tlaltenango, ubicado en el municipio de Cuernavaca y el centro de salud de Tepoztlán, en ese municipio.</p><p>Para poder realizar la investigación se solicitó un permiso emitido por las oficinas de Servicios de Salud Morelos (SSM), se siguieron las acciones solicitadas por la institución pero se nunca se obtuvo respuesta oficial.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Al preguntar sobre el abasto de métodos anticonceptivos en el estado de Morelos recibimos información contradictoria entre las respuestas de acceso a la información pública (folio 00332616, 00332516 y 00333016) y el l folio 00332516, respecto del número de condones femeninos y masculinos desagregado por centro de salud.</p><p>En la información no había correspondencia entre el nombre de la unidad de salud y el municipio al que se hacía referencia. Por ejemplo, el centro de salud de Cuernavaca ubicaba dentro del municipio de Temixco.</p><p>En el folio 00332516 se incluía información sobre el abasto de métodos anticonceptivos desagregada por municipio según la jurisdicción sanitaria, el problema radicó en que las cifras estaban equivocadas debido a las fórmulas establecidas en el formato de Excel.</p><p>El cuadro de abasto quedó distribuido de la siguiente manera:</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos</h3><div><barchart data=\"[{name:\'Implante subdérmico\',y:10471,color:\'#5EC5C8\'},{name:\'DIU medicado\',y:1910,color:\'#009242\'},{name:\'PAE\',y:2296,color:\'#7000B0\'},{name:\'Parche dérmico\',y:1308,color:\'#E00F7B\'},{name:\'Inyectable mensual\',y:2137,color:\'#FF6500\'},{name:\'Condones masculinos\',y:291966,color:\'#3DA5D9\'},{name:\'Condones femeninos\',y:109,color:\'#73C59F\'}]\"></barchart></div></div><video-section color=\"\'rgb(\'+vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]+\')\'\" video=\"\'dk5z_aI-utk\'\" thumbnail=\"\'morelos\'\" texto=\"\'“Las y los adolescentes, en otros espacios, nos han dicho que van por condones masculinos y se los niegan o les piden su número de teléfono para avisarle a los padres que están solicitando el condón, o de plano no les dan información y son muy agresivos que ellos y con ellas”\'\" autor=\"\'-Ana Rodríguez, Redefine Morelos.\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Preguntamos por las capacitaciones impartidas al personal médico de unidades de salud de primer y segundo nivel del estado de Morelos sobre temas de interculturalidad. Las respuestas arrojaron lo siguiente (Folio 00334116):</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\">No</th><th>Fechas</th><th class=\"impar\">Presencial/ Virtual</th><th>Tema</th><th class=\"impar\">Público al que son dirigidos</th><th>Asistencia (no específica sexo)</th></tr></thead><tbody><tr><td>1</td><td class=\"gray\">05/03/2015</td><td>Presencial</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria I</td><td class=\"gray\">41 asistentes</td></tr><tr><td class=\"gray\">2</td><td>30/05/2015</td><td class=\"gray\">No especifica</td><td>No especifica tema.</td><td class=\"gray\">Jurisdicción sanitaria I</td><td>23 asistentes</td></tr><tr><td>3</td><td class=\"gray\">08/10/2015</td><td>Presencial</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria I</td><td class=\"gray\">27 asistentes</td></tr><tr><td class=\"gray\">4</td><td>18/03/2015</td><td class=\"gray\">No especifica</td><td>No especifica tema.</td><td class=\"gray\">Jurisdicción sanitaria II</td><td>28 asistentes</td></tr><tr><td>5</td><td class=\"gray\">22/04/2015</td><td>Presencial</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria II</td><td class=\"gray\">26 asistentes</td></tr><tr><td class=\"gray\">6</td><td>22/07/2015</td><td class=\"gray\">Presencial</td><td>No especifica tema.</td><td class=\"gray\">Jurisdicción sanitaria II</td><td>33 asistentes</td></tr><tr><td>7</td><td class=\"gray\">10/11/2015</td><td>Virtual</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria II</td><td class=\"gray\">8 asistentes</td></tr><tr><td class=\"gray\">8</td><td>02/02/2015</td><td class=\"gray\">Presencial</td><td>No especifica tema.</td><td class=\"gray\">Jurisdicción sanitaria III</td><td>31 asistentes</td></tr><tr><td>9</td><td class=\"gray\">08/04/2015</td><td>Presencial</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria III</td><td class=\"gray\">23 asistentes</td></tr><tr><td class=\"gray\">10</td><td>19/08/2015</td><td class=\"gray\">Presencial</td><td>No especifica tema.</td><td class=\"gray\">Jurisdicción sanitaria III</td><td>19 asistentes</td></tr><tr><td>11</td><td class=\"gray\">30/07/2015</td><td>Virtual</td><td class=\"gray\">No especifica tema.</td><td>Jurisdicción sanitaria III</td><td class=\"gray\">26 asistentes</td></tr><tr><td class=\"gray\">12</td><td>25/05/2015</td><td class=\"gray\">Presencial</td><td>No especifica tema.</td><td class=\"gray\">REPSS</td><td>10 asistentes</td></tr></tbody></table></div><div class=\"texto\"><p>Mencionan que el total de personal capacitado fue de 295 personas.</p><p>En el cuadro señalan fechas, no se mencionan qué temas se impartieron en el taller, ni el nombre de los mismos. La información no se desagrego por sexo y no corresponde cada número de participantes.</p><p>En otro apartado se menciona que los temas fueron: Enfoque Intercultural de los Servicios de Salud; Lineamientos Interculturales para el personal de salud; Barreras culturales en los servicios de salud; Diversidad Cultural, Cosmovisión; Sistemas Médicos y Medicina Tradicional; Equidad de Género en Salud y Relación personal de salud-paciente, pero no se específica en que taller se dio cada uno.</p><p>Por último se menciona que se capacitó a REPSS, sin detallar el significado de estas siglas.</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Preguntamos sobre el número, tiraje y distribución de materiales informativos y/o educativos específicos para hombres con el tema de corresponsabilidad masculina en la planificación familiar.</p><p>La respuesta señala que no cuentan con dichos materiales, pero argumentan que pretendían difundir tarjetas informativas sobre \"Salud Sexual y Reproductiva del hombre con énfasis en vasectomía sin bisturí\" y trípticos de \"Planificación Familiar\" en 2016 y que estaban a la espera de ser aprobadas. No abundan más sobre el tema.</p><p>En la solicitud se habla de un CD las campañas llamado \"Planificación Familiar y Anticoncepción\" y \"Salud Sexual y Reproductiva Adolescente\" de los años 2015 y 2016, pero no se especificó en la respuesta dónde debía recogerse este material (Folio 00335216).</p><download color=\"vm.states[\'Morelos\'].color\" link=\"\'./assets/files/Morelos.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Morelos\'].color[0]+\',\'+vm.states[\'Morelos\'].color[1]+\',\'+vm.states[\'Morelos\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/narrativas.html","<div class=\"container narrativas-container\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>Buscamos saber mediante un ejercicio de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas delprimer nivel, de atención en 10 estados de la República.</p></div></div><div class=\"narrativas-grid\"><narrativa ng-repeat=\"(ind,narrativa) in vm.states\" color=\"narrativa.color\" resumen=\"narrativa.resumen\" state=\"ind\" video=\"narrativa.video\" portada=\"narrativa.portada\" inverse=\"vm.getInverse($index);\" link=\"narrativa.link\"></narrativa></div><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/narrativas/oaxaca.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Oaxaca\'\" color=\"vm.states[\'Oaxaca\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, de acuerdo con la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content gray\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades de Salud del Primer Nivel de Atención visitadas.</p></div><div class=\"content\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046- SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Oaxaca.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Se presenta la condicionante de atención en salud sexual y reproductiva al estado civil casado(a) o la estabilidad de pareja.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM- 047-SSA2- 2015) 1 señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades de Salud del Primer Nivel de Atención visitadas.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Se presenta la condicionante de atención en salud sexual y reproductiva al estado civil casado(a) o la estabilidad de pareja.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, de acuerdo con la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046- SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Oaxaca.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM- 047-SSA2- 2015) 1 señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\" ng-show=\"vm.index < 3\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Para todo el Estado se reportó la siguiente distribución de métodos anticonceptivos (por las 6 jurisdicciones sanitarias: Valles centrales, Istmo, Tuxtepec Costa, Mixteca, Sierra):</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos</h3><div><barchart data=\"[{name:\'condones masculinos\',y:20086,color:\'#5EC5C8\'},{name:\'Condones femeninos\',y:4994,color:\'#009242\'},{name:\'Implante hormonal subdérmico\',y:7310,color:\'#7000B0\'},{name:\'Dispositivo intrauterino (TCU)\',y:25048,color:\'#E00F7B\'},{name:\'Dispositivo intrauterino (NULIPARAS)\',y:832,color:\'#FF6500\'},{name:\'Dispositivo intrauterino Medicado\',y:2497,color:\'#3DA5D9\'},{name:\'Pastillas anticonceptivas\',y:14918,color:\'#73C59F\'},{name:\'Parche anticonceptivo\',y:33290,color:\'#28666E\'},{name:\'Anticonceptivo hormonal inyectable mensual\', y:183096,color:\'#990033\'},{name:\'Anticonceptivo hormonal inyectable bimestral\',y:141483,color:\'#A864CF\'},{name:\'Pastilla anticonceptiva de emergencia\',y:12498,color:\'#675973\'}]\"></barchart></div><p>Aunque la cantidad de métodos anticonceptivos es alta y su variedad es amplia, la información no permite identificar una distribución de acuerdo a las jurisdicciones el número asignado a cada región.</p></div><video-section color=\"\'rgb(\'+vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]+\')\'\" video=\"\'g42YGwftY_k\'\" thumbnail=\"\'oaxaca\'\" texto=\"\'Sobre el implante subdérmico. “Éste método es únicamente a petición de la paciente, y para su obtención tendrá que esperar hasta que por lo menos tres pacientes más lo soliciten, posteriormente el Centro de Salud hace su solicitud a nivel jurisdiccional de acuerdo al número de usuarias, ya que no es un método que se surta de manera mensual”\'\" autor=\"\'No. de Folio 20322\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Respecto de la información de personas hablantes de lengua indígena que pudieran asistir a otras personas que requirieran traductores la SSA refirió que:</p><p class=\"italic\">“Previa consulta en los diferentes subsistemas de información que se manejan en esta Dirección de Planeación y Desarrollo; ninguno reporta información de personal hablante de lengua indígena y/o pertenencia étnica que trabajen en las unidades de la Secretaría de Salud y Servicios de Salud de Oaxaca”</p><p class=\"right-align\">No. de Folio 20322</p><p>Esta información resulta contradictoria con la respuesta que se dio posteriormente, la cual menciona a las personas que fungían en labores de traducción, pero únicamente se envió información con respecto a 2 Jurisdicciones Sanitarias y del Hospital General Dr. Aurelio Valdivieso. En la siguiente solicitud de información en el Estado de Oaxaca se mencionan 53 personas que desarrollan labores de traducción:</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\">Municipio</th><th>Lengua</th><th class=\"impar\">Traductores Hombres</th><th>Traductores Mujeres</th><th class=\"impar\">Personal que lo realiza</th></tr></thead><tbody><tr><td>Jurisdicción sanitaria 1</td><td class=\"gray\">Mixteco, zapoteco, mazateco, chatino.</td><td>26</td><td class=\"gray\">8</td><td>Comité de Salud (10), Ciudadanía (3), Secretaría de Salud de Oaxaca (8), Limpieza (5), Municipio (6), Enfermería (1), Comunidad (1), Asistente de Salud (1)</td></tr><tr><td class=\"gray\">Jurisdicción sanitaria 4</td><td>No especifíca lengua</td><td class=\"gray\">No especifica sexo</td><td>No especifica sexo</td><td class=\"gray\">Personal de limpieza (6), Comité de Salud (3)</td></tr><tr><td>Hospital general DR Aurelio valdivieso</td><td class=\"gray\">Zapoteco sierra sur, Zapoteco sierra norte, Zapoteco valles centrales, Zapoteco istmo, Chanitino, Mixe.</td><td>26</td><td class=\"gray\">8</td><td>Enfermería (3), Camilleros (4), Médico (2), Secretaria (1)</td></tr></tbody></table></div><div class=\"texto\"><p class=\"right-align\">No. de Folio 20321</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Las respuestas obtenidas señalan “7 talleres de capacitación/sensibilización en corresponsabilidad masculina y en planificación familiar a personal de primer nivel de atención, con una asistencia de 69 hombres y 109 mujeres, cuyo costo fue de $49,895.52 c/u” (No. de Folio 20326).</p><p><strong>De estos talleres no se adjunta información que pueda sustentar su implementación, como sí se ha mencionado en temas de interculturalidad o en género y salud,</strong> como muestra la siguiente tabla:</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\">Temas</th><th>Público objetivo</th><th class=\"impar\">Asistencia Hombres</th><th>Asistencia Mujeres</th></tr></thead><tbody><tr><td>Jornada académica</td><td class=\"gray\">Directores del hospital</td><td>5</td><td class=\"gray\">21</td></tr><tr><td class=\"gray\">Taller de sensibilización en género</td><td>Responsables del programa</td><td class=\"gray\">8</td><td>7</td></tr><tr><td>Plática en género y salud</td><td class=\"gray\">Personal de enfermería</td><td>65</td><td class=\"gray\">7</td></tr><tr><td class=\"gray\">Plática en género y salud</td><td>Personal médico</td><td class=\"gray\">11</td><td>9</td></tr><tr><td></td><td class=\"gray\">Total</td><td>89</td><td class=\"gray\">44</td></tr></tbody></table></div><div class=\"texto hallazgos-container single-narrativa\"><download color=\"vm.states[\'Oaxaca\'].color\" link=\"\'./assets/files/Oaxaca.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Oaxaca\'].color[0]+\',\'+vm.states[\'Oaxaca\'].color[1]+\',\'+vm.states[\'Oaxaca\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/puebla.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Puebla\'\" color=\"vm.states[\'Puebla\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Se recomienda la abstinencia sexual como “método anticonceptivo”.</p></div><div class=\"content gray\"><p>Delimitar la recomendación de métodos anticonceptivos a aquellos métodos definidos en el Sistema de Salud Mexicano y con base en las Guías de Elegibilidad de la Organización Mundial de la Salud.</p></div><div class=\"content gray\"><p>Condicionamiento de no retirar métodos anticonceptivos de larga duración por motivos económicos y no médicos.</p></div><div class=\"content\"><p>Fomentar la libre elección de métodos anticonceptivos, en línea con la Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015), que señala la provisión de servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando al desarrollo de la autonomía sobre la toma de decisiones.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes. Capacitación suficiente en temas de interculturalidad en salud para todo el personal de salud, con especial atención en el que esté en el primer nivel.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Se recomienda la abstinencia sexual como “método anticonceptivo”.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Condicionamiento de no retirar métodos anticonceptivos de larga duración por motivos económicos y no médicos.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Delimitar la recomendación de métodos anticonceptivos a aquellos métodos definidos en el Sistema de Salud Mexicano y con base en las Guías de Elegibilidad de la Organización Mundial de la Salud.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Fomentar la libre elección de métodos anticonceptivos, en línea con la Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015), que señala la provisión de servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando al desarrollo de la autonomía sobre la toma de decisiones.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes. Capacitación suficiente en temas de interculturalidad en salud para todo el personal de salud, con especial atención en el que esté en el primer nivel.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\" ng-show=\"vm.index < 4\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>La Secretaría de Salud del estado de Puebla no proporcionó información sobre el número ni la forma en que se distribuyeron los métodos anticonceptivos en la entidad, solo los montos de compra de tres tipos de métodos: parches anticonceptivos ($67,317.12), implantes subdérmicos ($19,600.99 ) y dispositivos intrauterinos o DIU ($141,643.68). Folios 00103216, 00103316, 00103416 y 00103516</p></div><video-section color=\"\'rgb(\'+vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]+\')\'\" video=\"\'slAahWUl3s4\'\" thumbnail=\"\'puebla\'\" texto=\"\'“Las instituciones dicen que sí existe un abasto suficiente de métodos anticonceptivos, que cuentan con el personal para suministrarlos, sin embargo al momento de corroborarlo con la “usuaria simulada” te das cuenta de que la información esta sesgada”\'\" autor=\"\'- Yulitzin Granados, Redefine Puebla.\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Respecto de la información de personas hablantes de lengua indígena que pudieran asistir a otras personas que requirieren traductores, la Secretaría de Salud del estado de Puebla refirió (folio 00104316):</p><p>Aunque se reporta que existe personal que habla alguna lengua indígena al interior de las unidades de salud y que en algún momento realiza las actividades de traducción, no se trata de personal contratado específicamente para esas tareas.</p><p>Estas prácticas evitan o retardan la contratación específica de personal especializado para esa tarea. Por otro lado no se reporta si las personas que realizan esa labor de forma paralela a sus tareas, recibe una remuneración extra.</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\">Municipio</th><th>Lenguas</th><th class=\"impar\">Hombres</th><th>Mujeres</th></tr></thead><tbody><tr><td>Ahuacatlán</td><td class=\"gray\">Náhuatl (1), Totonaco (1)</td><td>-</td><td class=\"gray\">2</td></tr><tr><td class=\"gray\">Atlixco</td><td>Náhuatl</td><td class=\"gray\">1</td><td>1</td></tr><tr><td>Cuetzalan del Progreso</td><td class=\"gray\">Náhuatl</td><td>1</td><td class=\"gray\">2</td></tr><tr><td class=\"gray\">Eloxochitlán</td><td>Náhuatl</td><td class=\"gray\">1</td><td>-</td></tr><tr><td>Huehuetla</td><td class=\"gray\">Totonaco</td><td>2</td><td class=\"gray\">-</td></tr><tr><td class=\"gray\">Pantepec</td><td>Totonaco (1), Otomí (1)</td><td class=\"gray\">-</td><td>2</td></tr><tr><td>San Sebastián Tlacotepec</td><td class=\"gray\">Náhuatl</td><td>-</td><td class=\"gray\">2</td></tr><tr><td class=\"gray\">Tétela de Ocampo</td><td>Náhuatl</td><td class=\"gray\">2</td><td>-</td></tr><tr><td>Tlaola</td><td class=\"gray\">Totonaco</td><td>2</td><td class=\"gray\">-</td></tr><tr><td class=\"gray\">Zacapoaxtla</td><td>Totonaco (1), Otomí (1)</td><td class=\"gray\">1</td><td>1</td></tr><tr><td>Zapotitlán de Méndez</td><td class=\"gray\">Náhuatl (1), Totonaco (1)</td><td>-</td><td class=\"gray\">2</td></tr><tr><td class=\"gray\">Zoquitlán</td><td>Náhuatl</td><td class=\"gray\">1</td><td>1</td></tr><tr><td>Total</td><td class=\"gray\">Náhuatl, totonaco, otomí</td><td>11</td><td class=\"gray\">13</td></tr></tbody></table></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Sobre los materiales referentes a la corresponsabilidad masculina, se informó la existencia de un tríptico denominado “La Vasectomía sin Bisturí”:</p><p class=\"italic\">“durante el ejercicio presupuestal 2015, se elaboraron 6,944 trípticos sobre “salud sexual y reproductiva del hombre con énfasis en Vasectomía sin Bisturí”, mismos que fueron distribuidos a las jurisdicciones sanitarias, como apoyo didáctico a las sesiones educativas que se otorgan en las unidades de salud.</p><p class=\"center-align\">No omito mencionar, que los materiales de IEC programadas para 2016 se encuentran en trámite de diseño e impresión (Folio 00105016).</p><p class=\"center-align\">Lo anterior se informó hacia el mes junio de 2016.</p><download color=\"vm.states[\'Puebla\'].color\" link=\"\'./assets/files/Puebla.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Quintana Roo\',view:\'narrativa-quintana-roo\',image:\'QuintanaRoo\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Puebla\'].color[0]+\',\'+vm.states[\'Puebla\'].color[1]+\',\'+vm.states[\'Puebla\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/quintana-roo.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Quintana Roo\'\" color=\"vm.states[\'Quintana Roo\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content gray\"><p>Inexistencia de servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte fundamental de la atención para las mujeres que son víctimas de violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Quintana Roo.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inexistencia de servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Disponibilidad de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte fundamental de la atención para las mujeres que son víctimas de violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Quintana Roo.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\" ng-show=\"vm.index < 3\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>A través de solicitudes de acceso a la información pública, se reportaron para 2015 un total de 0 condones masculinos, 0 condones femeninos, 8,957 implantes hormonales subdérmicos, 2,000 DIU, 357 pastillas anticonceptivas, 4,190 parches anticonceptivos y 6,242 Anticoncepción Hormonal inyectable, adquiridos. Según la misma solicitud, para abril de 2016 no se adquirieron métodos anticonceptivos por parte de Secretaría de Salud</p><p class=\"right-align\">Folios no. 00031816, 00031616 y 00031516</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos</h3><div><barchart data=\"[{name:\'Inyectable mensual\',y:6242,color:\'#5EC5C8\'},{name:\'Dispositivo medicado\',y:2000,color:\'#009242\'},{name:\'Implante subdérmico\',y:8957,color:\'#7000B0\'},{name:\'Anticoncepción de emergencia\',y:375,color:\'#E00F7B\'},{name:\'Parche anticonceptivo\',y:4190,color:\'#FF6500\'}]\"></barchart></div></div><video-section color=\"\'rgb(\'+vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]+\')\'\" video=\"\'RpS0J_CBoTg\'\" thumbnail=\"\'quintana-roo\'\" texto=\"\'“[Hace falta] que surtan los métodos, hay carencia también en los insumos. Aún con abasto, hace falta material para colocar ciertos métodos: “incluso, tenemos DIU, pero no hay material para aplicar o retirarlos” \'\" autor=\"\'- Personal de salud entrevistado\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>En la respuesta a la solicitud de información pública, se considera: “Que el personal contratado en los servicios de salud, relacionado con la zona maya (Felipe Carrillo Puerto, José María Morelos, Lázaro Cárdenas, Puerto Morelos, Benito Juárez, Othón P. Blanco) se contempla que hable dicha lengua o en su defecto, sea nativa de esa zona para brindar una atención integral” No. de Folio 00032516.</p><div class=\"list\">– Las y los profesionales de salud consideran importante de manera unánime, conocer y comprender el origen étnico:<p>“son los grupos más vulnerables”, “sí [es] muy importante [preguntar por el origen o adscripción étnica], para respetar las creencias que puedan tener según el pueblo indígena de origen”.</p></div><div class=\"list\">– Pero parecen no contar con capacitación suficiente para conocer las necesidades profesionales que derivan de esto:<p>“No [es importante saber si son personas indígenas o no], sólo si se dan cuenta [lo/as médico/as] de la forma del dialecto”.</p></div><div class=\"list\">– Durante la investigación de campo no hubo unidad que contará con traductores disponibles al momento de realizar las entrevistas.<br></div><div class=\"list\"><br>– Jaer Padilla (Redefine Quintana Roo)</div></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>SEn las respuestas se informa que el personal capacitado en esta temática fueron 328 personas, numeralia que corresponde a las capacitaciones reportadas sobre “Logística y Distribución de Métodos Anticonceptivos”, “Sensibilización y Planificación Familiar” y “Planificación Familiar y Sistemas de Información”, y a estas listas se les agrega la siguiente leyenda: “Se contempla de manera general la corresponsabilidad masculina\".</p><p>Esta afirmación es difícil de probar ya que la solicitud no respondió a los requerimientos: temas, público objetivo, número de asistentes por sexo y tipo de capacitaciones impartidas.</p></div><div class=\"table-section\"><table class=\"table\"><thead><tr><th class=\"impar\">Jurisdicción Sanitaria</th><th>Médico</th><th class=\"impar\">Enfermería</th><th>Masculino</th><th>Femenino</th><th>Temas</th></tr></thead><tbody><tr><td>1</td><td class=\"gray\">33</td><td>27</td><td class=\"gray\">30</td><td>30</td><td class=\"gray\">Logística y distribución de métodos de Planificación Familiar</td></tr><tr><td class=\"gray\">2</td><td>45</td><td class=\"gray\">49</td><td>45</td><td class=\"gray\">49</td><td>Sensibilización en Planificación Familiar</td></tr><tr><td>3</td><td class=\"gray\">40</td><td>44</td><td class=\"gray\">42</td><td>42</td><td class=\"gray\">Planificación familiar y Sistemas de Información</td></tr><tr><td class=\"gray\">Total</td><td>118</td><td class=\"gray\">120</td><td>117</td><td class=\"gray\">121</td><td></td></tr></tbody></table></div><div class=\"texto\"><p class=\"right-align\">No. de Folio: 0035516</p><download color=\"vm.states[\'Quintana Roo\'].color\" link=\"\'./assets/files/QuintanaRoo.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Veracruz\',view:\'narrativa-veracruz\',image:\'Veracruz\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Quintana Roo\'].color[0]+\',\'+vm.states[\'Quintana Roo\'].color[1]+\',\'+vm.states[\'Quintana Roo\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/veracruz.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Veracruz\'\" color=\"vm.states[\'Veracruz\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content gray\"><p>Derogación de dicha condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content gray\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content extra gray\" ng-class=\"{\'active\' : vm.more}\"><p>Existencia de la figura de “Promotor Intercultural Bilingüe”</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Promover, replicar y escalara esta figura de manera adecuada y suficiente para las zonas con mayor presencia indígena en la entidad, además de asegurar la existencia de este personal también en los mayores centros urbanos de la entidad, a fin de asegurar la atención para las mujeres migrantes del campo a la ciudad exista.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Veracruz.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Condicionante de “acudir reglando” para la provisión de métodos anticonceptivos hormonales.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inexistencia de Servicios Amigables en Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Existencia de la figura de “Promotor Intercultural Bilingüe”</p></div><div class=\"content\" ng-show=\"vm.index == 5\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Derogación de dicha condicionante, para ceñirse a administración de métodos anticonceptivos establecida en la NOM005-SSA2-1993, De los Servicios de Planificación Familiar.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Inclusión de Servicios Amigables en las Unidades de Salud del Primer Nivel de Atención, bajo los parámetros de la NOM-047-SSA2-2015, para la Atención a la Salud del grupo etario de 10 a 19 años de edad.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Promover, replicar y escalara esta figura de manera adecuada y suficiente para las zonas con mayor presencia indígena en la entidad, además de asegurar la existencia de este personal también en los mayores centros urbanos de la entidad, a fin de asegurar la atención para las mujeres migrantes del campo a la ciudad exista.</p></div><div class=\"content\" ng-show=\"vm.index == 5\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres. Criterios para la prevención y atención, así como en la Ley General de Víctimas, así como en la Ley de Víctimas del Estado de Veracruz.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\" ng-show=\"vm.index < 5\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Para el estado de Veracruz no se reportaron métodos anticonceptivos durante 2015 (enero 2015 a febrero de 2016) (folios con número 00212516, 00212716, 00212816, 00213016, 0213116).</p><p><strong>Este dato, negado en 5 solicitudes de información querría decir que no existe método anticonceptivo disponible alguno en el estado de Veracruz.</strong></p><p>Esta aseveración puede ponerse en duda según otra solicitud de información, la cual pregunta por “los montos de las compras consolidadas, el número de unidades adquiridas y el costo unitario de los métodos anticonceptivos en todas sus variedades, adquiridos por el sector salud del Estado de Veracruz” en el mismo periodo de tiempo. En este caso, la respuesta hace referencia a una liga en Compranet, a la que no se puede acceder desde el momento de la entrega de la información (Folio no. 00213416).</p><p>En una búsqueda propia en Compranet se identificó un presupuesto de $3’ 000,000.00 para la compra de métodos anticonceptivos en el año 2015.</p></div><video-section color=\"\'rgb(\'+vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]+\')\'\" video=\"\'4kCrV-8w7q8\'\" thumbnail=\"\'veracruz\'\" texto=\"\'“No es tan fácil como nosotros pensamos o como lo dicen las normas o como ellos, en sus informes, nos dan a conocer: que es muy fácil acceder a los métodos anticonceptivos y a la planificación familiar” \'\" autor=\"\'Iraís San Martín, Redefine Veracruz\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>Para 2015 se reportaron 46 personas dedicadas a cuestiones relativas a interculturalidad en los servicios de salud. Entres ellas 28 traductores(as) (19 mujeres, 9 hombres) y 18 promotoras(es) de salud intercultural bilingües (13 mujeres, 5 hombres).</p><p>Sobre materiales de difusión de métodos anticonceptivos elaborados en lenguas indígenas se respondió en tres ocasiones que esa información era inexistente (folios con número 00212916, 00213516 y 00213616).</p><p class=\"right-align italic\">“[Es importante] Porque el aspecto intercultural conlleva respeto a sus creencias y costumbres. En la comunidad todavía hay mitos sobre el uso de métodos.”</p><p class=\"right-align\">-Personal médico entrevistado en la unidad rural</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>De acuerdo con las respuestas de acceso a la información se capacitó a 1,050 personas en 4 talleres y dos foros, sin más detalle del proceso.</p><p>La única capacitación reportada que guarda relación directa con temas de corresponsabilidad masculina fue un taller denominado \"Taller: actualización y certificación de médicos en vasectomía sin bisturí” con una asistencia de 36 hombres y 26 mujeres (Folio no. 00214016).</p><p>Por otra parte la Secretaría de Salud del estado de Veracruz respondió que no contaba con información referente a materiales de comunicación para la corresponsabilidad masculina (Folio no. 00214116).</p><p class=\"italic\">“El bebé es de los dos, lo que se comenta es que el esposo debe ser el padrino obstétrico, se debe empoderar al varón para que acuda a las consultas médicas de la mujer. Pasó que en una consulta vino el señor y la señora y yo le preguntaba a la señora y lo que no se acordaba me contestaba él, que se acordaba de todo, fechas y cosas de su mujer; pero se mantenía callado hasta que no le preguntara.”</p><p class=\"right-align\">-Personal médico entrevistado en la unidad rural</p><download color=\"vm.states[\'Veracruz\'].color\" link=\"\'./assets/files/Veracruz.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Yucatán\',view:\'narrativa-yucatan\',image:\'Yucatan\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Veracruz\'].color[0]+\',\'+vm.states[\'Veracruz\'].color[1]+\',\'+vm.states[\'Veracruz\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/narrativas/yucatan.html","<div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h2 class=\"titleViz\">Acceso de jóvenes y mujeres indígenas a servicios de salud sexual y reproductiva</h2><dropdown-nav current=\"\'Yucatán\'\" color=\"vm.states[\'Yucatán\'].color\"></dropdown-nav><h3 class=\"subtitleViz\">Principales hallazgos y recomendaciones:</h3></div><div class=\"table-hr hidden-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\">Hallazgos</div><div class=\"head\" style=\"background:rgba({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\"><p>Inexistencia de condones femeninos en las unidades de salud.</p></div><div class=\"content gray\"><p>Asegurar una gama completa de métodos anticonceptivos en la entidad, sobre todo aquella que permite la decisión libre, informada y en autonomía de las mujeres sobre su salud sexual y reproductiva.</p></div><div class=\"content gray\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"content gray extra\" ng-class=\"{\'active\' : vm.more}\"><p>Condicionante de atención en salud sexual y reproductiva al estado civil casado(a) o la estabilidad de pareja.</p></div><div class=\"content extra\" ng-class=\"{\'active\' : vm.more}\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015) señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div><div class=\"expand\" style=\"background:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\" ng-click=\"vm.more = !vm.more\"><div class=\"icon\" ng-class=\"{\'open\' : vm.more}\"></div></div></div></div><div class=\"table-hr visible-xs\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Inexistencia de condones femeninos en las unidades de salud.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>No se ubicaron servicios de traducción, sensibilización, capacitación e infraestructura con perspectiva intercultural en las Unidades de Salud del Primer Nivel de Atención.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Desconocimiento de la provisión de la anticoncepción de emergencia, como parte del protocolo de atención a casos de violencia sexual para prevenir embarazos no deseados, así como de la aplicación de profilaxis de emergencia para prevenir ITS, por parte de profesionales de salud de las Unidades visitadas.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Condicionante de atención en salud sexual y reproductiva al estado civil casado(a) o la estabilidad de pareja.</p></div></div></div><div class=\"table-hr visible-xs recom\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgba({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}},.7)\">Recomendaciones</div></div><div class=\"row-table shadow\"><div class=\"content\" ng-show=\"vm.index == 1\"><p>Asegurar una gama completa de métodos anticonceptivos en la entidad, sobre todo aquella que permite la decisión libre, informada y en autonomía de las mujeres sobre su salud sexual y reproductiva.</p></div><div class=\"content\" ng-show=\"vm.index == 2\"><p>Dotar de servicios de traducción, tanto en los mayores centros de población, como en las zonas donde exista población hablante de lengua indígena, siguiendo la línea del Objetivo 2 de la Estrategia Nacional de Prevención del Embarazo en Adolescentes.</p></div><div class=\"content\" ng-show=\"vm.index == 3\"><p>Capacitar al personal para la provisión de estos servicios (anticoncepción de emergencia y profilaxis para prevención de ITS), que forma parte de la atención para mujeres que sufren violencia sexual, y que está contenido en la NOM-046-SSA2-2005, Violencia familiar, sexual y contra las mujeres.</p></div><div class=\"content\" ng-show=\"vm.index == 4\"><p>Eliminar dicha condicionante, con base en Norma Oficial Mexicana de Salud 047 (NOM-047-SSA2-2015) señala que el Sistema Nacional de Salud deberá proveer servicios de atención integral a la salud para el segmento de población entre los 10 y 19 años de edad, siempre en el marco del respeto a los Derechos Humanos, con perspectiva de género e interculturalidad, respetando la confidencialidad y coadyuvando en el desarrollo de la autonomía sobre la toma de decisiones.</p></div></div></div><div class=\"controles visible-xs\"><div><svg width=\"16px\" height=\"16px\" viewbox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-show=\"vm.index > 1\" ng-click=\"vm.redIndex();\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Narrativas_mobile-Copy\" transform=\"translate(-20.000000, -989.000000)\" fill=\"rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\"><path d=\"M23.8,996 L29.4,990.4 L28,989 L20,997 L28,1005 L29.4,1003.6 L23.8,998 L30.8046875,998 L36,998 L36,996 L23.8,996 Z\" id=\"Shape\"></path></g></g></svg></div><div ng-click=\"vm.addIndex();\"><label style=\"color:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\" ng-show=\"vm.index < 4\">Ver siguiente hallazgo</label></div></div><div class=\"texto\"><h3 class=\"subtitleViz\">¿Qué investigamos?</h3><p>1. A través de contraloría ciudadana que incluye herramientas de acceso a la información e investigación de campo investigamos el <strong>abasto, acceso y disponibilidad</strong> de métodos anticonceptivos para adolescentes y mujeres indígenas en el estado.</p><p>2. La <strong>calidad</strong> en la atención de estos servicios desde una perspectiva de género e interculturalidad en unidades rurales y urbanas del primer nivel de atención.</p><h3 class=\"subtitleViz\">¿Qué encontramos?</h3><h4 style=\"color:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\">Disponibilidad de métodos anticonceptivos</h4><p>Para todo el estado se reportó la siguiente distribución de métodos anticonceptivos (Folio 15564):</p><h3 class=\"subtitleViz\">Abasto de métodos anticonceptivos</h3><div><barchart data=\"[{name:\'Hormonales\',y:163505,color:\'#5EC5C8\'},{name:\'Condones\',y:84032,color:\'#009242\'},{name:\'Intrauterinos\',y:1436,color:\'#7000B0\'},{name:\'PAE\',y:520,color:\'#E00F7B\'}]\"></barchart></div><p>Esta información no desagrega el número de condones masculinos o femeninos, no específica el tipo de métodos hormonales.</p></div><video-section color=\"\'rgb(\'+vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]+\')\'\" video=\"\'egMMIbqZvI8\'\" thumbnail=\"\'yucatan\'\" texto=\"\'La atención era muy limitada, una enfermera incluso, me comentaba que había información que ellos no podrían dar, no estaban como capacitados para dar\'\" autor=\"\'-Yamili Chan Dzul, Promui\'\"></video-section><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\">Enfoque intercultural en la prestación de servicios de salud sexual y reproductiva.</h4><p>En las unidades donde se realizó investigación de campo, existen servicios de traducción para las consultas, pero no se tiene articulación con parteras tradicionales.</p><p>No cuentan con material en lengua indígena.</p></div></div><div class=\"gray-container\"><div class=\"container hallazgos-container single-narrativa\"><div class=\"texto\"><h4 style=\"color:rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}})\">Corresponsabilidad masculina en la prevención de embarazos.</h4><p>Los materiales existentes son sobre salud sexual y reproductiva en general (planificación familiar, métodos anticonceptivos). En ningún caso se encontraron materiales enfocados a la corresponsabilidad masculina.</p><p>El personal entrevistado así se refirió la importancia del tema:</p><p class=\"italic\">“[Es importante] porque un embarazo se formó por dos personas papá y mamá, no sólo la mujer tiene la responsabilidad de cuidar al bebé, el hombre tiene que apoyar viendo que se alimente correctamente, que se tome sus vitaminas, que este cuidada la mujer”</p><p class=\"right-align\">- Personal médico entrevistado en la unidad de salud urbana.</p><download color=\"vm.states[\'Yucatán\'].color\" link=\"\'./assets/files/Yucatan.pdf\'\"></download></div></div></div><continuar-leyendo opciones=\"[ {label:\'Narrativas digitales\',view:\'narrativas\',image:\'NarrativasDigitales\'}, {label:\'Aguascalientes\',view:\'narrativa-aguascalientes\',image:\'Aguascalientes\'}, {label:\'Chiapas\',view:\'narrativa-chiapas\',image:\'Chiapas\'}, {label:\'Guanajuato\',view:\'narrativa-guanajuato\',image:\'Guanajuato\'}, {label:\'Guerrero\',view:\'narrativa-guerrero\',image:\'Guerrero\'}, {label:\'Morelos\',view:\'narrativa-morelos\',image:\'Morelos\'}, {label:\'Oaxaca\',view:\'narrativa-oaxaca\',image:\'Oaxaca\'}, {label:\'Puebla\',view:\'narrativa-puebla\',image:\'Puebla\'}, ]\"></continuar-leyendo><style type=\"text/css\">\n  .table-section table th{ \n    background:rgba({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}},.7) !important;\n    position:relative;\n    z-index:9;\n  }\n  .table-section table th.impar{\n   background: rgb({{vm.states[\'Yucatán\'].color[0]+\',\'+vm.states[\'Yucatán\'].color[1]+\',\'+vm.states[\'Yucatán\'].color[2]}}) !important;\n  }\n</style>");
$templateCache.put("app/presupuesto-prevencion/presupuesto-prevencion.html","<div><mapa-presupuesto json=\"vm.json\" presupuesto=\"vm.presupuesto\"></mapa-presupuesto><div class=\"texto\"></div></div>");
$templateCache.put("app/corresponsabilidad/corresponsabilidad.html","<div class=\"container hallazgos-container\"><div class=\"texto\"><h2 class=\"titleViz\">Hallazgos de la contraloría social entorno a la corresponsabilidad masculina</h2></div><div class=\"container-viz container\"><div class=\"dropdowns\"><div class=\"drop\"><label>Entidad</label><div class=\"dropdown\"><button class=\"btn btn-primary dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">{{vm.stateSelected}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-click=\"vm.updateState(\'Aguascalientes\');\" ng-show=\"vm.states[\'Aguascalientes\'] != undefined\">Aguascalientes</li><li ng-click=\"vm.updateState(\'Baja California\');\" ng-show=\"vm.states[\'Baja California\'] != undefined\">Baja California</li><li ng-click=\"vm.updateState(\'Baja California Sur\');\" ng-show=\"vm.states[\'Baja California Sur\'] != undefined\">Baja California Sur</li><li ng-click=\"vm.updateState(\'Campeche\');\" ng-show=\"vm.states[\'Campeche\'] != undefined\">Campeche</li><li ng-click=\"vm.updateState(\'Coahuila\');\" ng-show=\"vm.states[\'Coahuila\'] != undefined\">Coahuila</li><li ng-click=\"vm.updateState(\'Colima\');\" ng-show=\"vm.states[\'Colima\'] != undefined\">Colima</li><li ng-click=\"vm.updateState(\'Chiapas\');\" ng-show=\"vm.states[\'Chiapas\'] != undefined\">Chiapas</li><li ng-click=\"vm.updateState(\'Chihuahua\');\" ng-show=\"vm.states[\'Chihuahua\'] != undefined\">Chihuahua</li><li ng-click=\"vm.updateState(\'Distrito Federal\');\" ng-show=\"vm.states[\'Distrito Federal\'] != undefined\">Distrito Federal</li><li ng-click=\"vm.updateState(\'Durango\');\" ng-show=\"vm.states[\'Durango\'] != undefined\">Durango</li><li ng-click=\"vm.updateState(\'Guanajuato\');\" ng-show=\"vm.states[\'Guanajuato\'] != undefined\">Guanajuato</li><li ng-click=\"vm.updateState(\'Guerrero\');\" ng-show=\"vm.states[\'Guerrero\'] != undefined\">Guerrero</li><li ng-click=\"vm.updateState(\'Hidalgo\');\" ng-show=\"vm.states[\'Hidalgo\'] != undefined\">Hidalgo</li><li ng-click=\"vm.updateState(\'Jalisco\');\" ng-show=\"vm.states[\'Jalisco\'] != undefined\">Jalisco</li><li ng-click=\"vm.updateState(\'Estado de México\');\" ng-show=\"vm.states[\'Estado de México\'] != undefined\">Estado de México</li><li ng-click=\"vm.updateState(\'Michoacán\');\" ng-show=\"vm.states[\'Michoacán\'] != undefined\">Michoacán</li><li ng-click=\"vm.updateState(\'Morelos\');\" ng-show=\"vm.states[\'Morelos\'] != undefined\">Morelos</li><li ng-click=\"vm.updateState(\'Nayarit\');\" ng-show=\"vm.states[\'Nayarit\'] != undefined\">Nayarit</li><li ng-click=\"vm.updateState(\'Nuevo León\');\" ng-show=\"vm.states[\'Nuevo León\'] != undefined\">Nuevo León</li><li ng-click=\"vm.updateState(\'Oaxaca\');\" ng-show=\"vm.states[\'Oaxaca\'] != undefined\">Oaxaca</li><li ng-click=\"vm.updateState(\'Puebla\');\" ng-show=\"vm.states[\'Puebla\'] != undefined\">Puebla</li><li ng-click=\"vm.updateState(\'Querétaro\');\" ng-show=\"vm.states[\'Querétaro\'] != undefined\">Querétaro</li><li ng-click=\"vm.updateState(\'Quintana Roo\');\" ng-show=\"vm.states[\'Quintana Roo\'] != undefined\">Quintana Roo</li><li ng-click=\"vm.updateState(\'San Luis Potosí\');\" ng-show=\"vm.states[\'San Luis Potosí\'] != undefined\">San Luis Potosí</li><li ng-click=\"vm.updateState(\'Sinaloa\');\" ng-show=\"vm.states[\'Sinaloa\'] != undefined\">Sinaloa</li><li ng-click=\"vm.updateState(\'Sonora\');\" ng-show=\"vm.states[\'Sonora\'] != undefined\">Sonora</li><li ng-click=\"vm.updateState(\'Tabasco\');\" ng-show=\"vm.states[\'Tabasco\'] != undefined\">Tabasco</li><li ng-click=\"vm.updateState(\'Tamaulipas\');\" ng-show=\"vm.states[\'Tamaulipas\'] != undefined\">Tamaulipas</li><li ng-click=\"vm.updateState(\'Tlaxcala\');\" ng-show=\"vm.states[\'Tlaxcala\'] != undefined\">Tlaxcala</li><li ng-click=\"vm.updateState(\'Veracruz\');\" ng-show=\"vm.states[\'Veracruz\'] != undefined\">Veracruz</li><li ng-click=\"vm.updateState(\'Yucatán\');\" ng-show=\"vm.states[\'Yucatán\'] != undefined\">Yucatán</li><li ng-click=\"vm.updateState(\'Zacatecas\');\" ng-show=\"vm.states[\'Zacatecas\'] != undefined\">Zacatecas</li></ul></div></div></div><div class=\"table-hr\"><div class=\"row-table\"><div class=\"head\" style=\"background:rgb({{vm.states[vm.stateSelected].color[0]+\',\'+vm.states[vm.stateSelected].color[1]+\',\'+vm.states[vm.stateSelected].color[2]}}); width:100% !important; border-radius: 25px 25px 0px 0px;\">Hallazgos</div></div><div class=\"row-table shadow\"><div class=\"content\"><p ng-repeat=\"h in vm.states[vm.stateSelected].hallazgos\">{{h}}</p></div><div class=\"content\"><p ng-repeat=\"r in vm.states[vm.stateSelected].recomendaciones\">{{r}}</p></div></div></div><narrativa ng-repeat=\"(ind,narrativa) in vm.states\" color=\"narrativa.color\" resumen=\"narrativa.resumen\" state=\"ind\" video=\"narrativa.video\" portada=\"narrativa.portada\" inverse=\"false\" link=\"narrativa.link\" ng-show=\"ind == vm.stateSelected\"></narrativa></div></div><div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Corresponsabilidad masculina</h2><p>En este apartado se aborda la situación de los hombres en el embarazo adolescente, específicamente en cómo se ha incorporado y comprendido su papel desde la Estrategia Nacional para la Prevención del Embarazo Adolescente (ENAPEA) y en otras políticas, así como la forma se mide o registra este fenómeno.</p><p>La Estrategia tiene como uno de sus ejes rectores la perspectiva de género, es decir que debe entender los temas de sexualidad, reproducción y crianza en las personas adolescentes con un lente que analice las situaciones, las desigualdades y las opresiones que se viven según el género.</p><p>Sin embargo, la corresponsabilidad masculina, factor clave para la reducción de los embarazos no planificados en adolescentes, no cuenta en la ENAPEA con una definición clara, aun cuando este rubro pertenece al objetivo 3 “Asegurar el acceso efectivo a una gama completa de métodos anticonceptivos, incluyendo los reversibles de acción prolongada (ARAP), para garantizar una elección libre e informada y la corresponsabilidad del varón en el ejercicio de la sexualidad” y en específico a su línea de acción 13 “Fortalecer la corresponsabilidad del varón en el ejercicio de la sexualidad y la doble protección en el uso de métodos anticonceptivos”, la cual tiene como objetivo propiciar espacios de reflexión en torno la responsabilidad mutua de hombres y mujeres adolescentes en la prevención del embarazo, además de la creación de nuevas masculinidades.</p><p>El breve desarrollo de este tema en la propia Estrategia propicia un análisis acotado sobre el papel de los hombres adolescentes en la salud reproductiva y por ende siga destinada solamente a las mujeres.</p><p>De manera parecida la corresponsabilidad masculina para el Consejo Nacional de Población se define sólo para mujeres unidas como el “…porcentaje de mujeres en edad fértil unidas (15-49 años de edad) que declaran que su pareja hace uso de métodos anticonceptivos como la vasectomía, condón masculino, o bien, los métodos tradicionales (ritmo y retiro)”.</p><p>Los resultados de esta medición arrojan un porcentaje nacional de 17.8 por ciento para el año 2009 y un 18 por ciento para el año 2014, siendo los estados de Querétaro y Aguascalientes los más altos en participación masculina en el uso de métodos anticonceptivos con un 24.4 y un 24.3 por ciento respectivamente.</p><p>Mientras que los estados de Sinaloa y Chiapas presentan el menor porcentaje de participación masculina con un 10.8 y un 10.5 por ciento. Sin embargo, está medición no permite acercarnos a la participación masculina en el uso de métodos anticonceptivos en adolescentes, ya que no hay una segmentación por grupos de edad y sólo contempla a las mujeres unidas; sin mencionar que deja fuera a la población de 10 a 14 años.</p><p>Al buscar mecanismos que contemplen la participación masculina en el uso de métodos anticonceptivos para el grupo de edad de 10 a 19 años, en mujeres no unidas, los programas de acción específicos “Salud Sexual y Reproductiva para Adolescentes” y “Planificación Familiar y Anticoncepción” presentan un vacío. El término no es abordado o no contempla a este grupo de edad en específico.</p><p>Como se ilustró, la participación masculina en salud sexual y reproductiva es poco contemplada en mediciones y políticas públicas. La falta de análisis críticos sobre estos temas desde el ámbito de gobierno propicia que exista una reproducción de roles y estereotipos de género en sus prácticas y discursos.</p><p>En la principal campaña de comunicación del gobierno federal para la prevención del embarazo adolescente, en el marco de la ENAPEA “Es tu vida, es tu futuro. ¡Hazlo Seguro!”. Dentro de esta campaña, se puede señalar el gran despliegue de spots televisivos que durante el 2015 se reprodujeron aproximadamente dos millones de veces.</p><p>A partir de un análisis discursivo sobre quién es la persona que enuncia las distintas frases contendidas en el mensaje, se concluye que perviven estereotipos y roles de masculinidad tradicional, es decir se sigue representado una sexualidad masculina relacionada con la potencia sexual “natural” y la virilidad ya que la mayoría de las expresiones de deseo sexual son hechas por hombres, tal cómo esta frase: “lo caliente, no quita lo inteligente”, más que su asociación con otras emociones o sentimientos.</p><p>Por el contrario, éste sí es atribuido a las mujeres, lo que refleja la idea estereotipada de sentimentalidad de lo femenino.</p><p>En cuanto a la idea de la reproducción masculina en el anuncio, a esta no se le dota de responsabilidad y significado, ya que está atribuido a las mujeres y, por ende, la idea de maternidad queda contendida de valoraciones positivas con frases como “Quedar embarazada debe ser lo más bonito que le puede pasar a una mujer, no a una niña”, es decir, persiste la idea de un amor materno innato en la mujer.</p><p>En consecuencia, el comercial no dice las dificultades que implica la maternidad. Bajo estas reflexiones, la idea de la reproducción masculina y la paternidad quedan vacías de significado y, como resultado no se muestra una representación equitativa de la crianza.</p><h3>¿Cómo medir esta participación en el contexto del embarazo adolescente?</h3><p>En materia de corresponsabilidad masculina dichas políticas públicas también carecen de formas efectivas de medir el impacto y evaluarlo. Al revisar los indicadores del objetivo y línea de acción sobre participación masculina no se hace explícita la forma de medir esto, y centran el impacto a:</p><ol><li>Prevalencia de uso de métodos anticonceptivos en adolescentes de 15 a 19 sexualmente activas;</li><li>Prevalencia de uso de métodos reversibles (MR) en adolescentes de 15 a 19 sexualmente activas y;</li><li>Porcentaje de mujeres de 15-19 que no han tenido hijos o hijas y usan ARAP (Anticonceptivos Reversibles de Acción Prolongada).</li></ol><p>Resulta sustantivo tener una discusión más amplia que incluya la forma en que ha sido definida en otras latitudes o en otros ejercicios locales este concepto, para poder delimitarlo y medirlo, dejando atrás la idea de que es responsabilidad de las mujeres unidas.</p></div></div><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/datos/datos.html","<div class=\"container\"><div class=\"texto\"><h2 class=\"titleViz\">Mujeres adolescentes con hijas e hijos</h2><p>En México la tasa de nacimientos en adolescentes es de 77 de cada 1000 mujeres entre 15 y 19 años. De acuerdo con Naciones Unidas, las mujeres adolescentes con hijas o hijos, tienen más dificultades para articular sus roles productivos y reproductivos, hecho que afecta su autonomía, sus oportunidades y el ejercicio de sus derechos.</p><p>Este apartado retoma los registros del Instituto Nacional de Estadística y Geografía (INEGI) para 2010 (Censo Nacional de Población y Vivienda) y 2015 (Encuesta Intercensal).</p><p>Señala el porcentaje de mujeres adolescentes entre 10 a 18 años que tuvieron hijas o hijos con respecto al total de nacimientos ocurridos por entidad y municipio.</p></div><div class=\"loading\" ng-show=\"vm.loading\"><div class=\"mask\" style=\"height:550px;\"><img src=\"./assets/images/loading.gif\"></div></div><mapa-municipios json=\"vm.json\"></mapa-municipios><div class=\"texto\"><p>Los estados de Coahuila, Chihuahua y Durango en año 2010 y en 2015 se mantienen con los porcentajes más elevados, ubicando municipios con cifras superiores al 20 por ciento. En contraste, entidades como Querétaro o la Ciudad de México, presentan los porcentajes más bajos del país.</p><p>De los cambios más relevantes que se dieron de 2010 a 2015 podemos notar que el estado de Tamaulipas pasó de un porcentaje de 8.49 a un 15 por ciento de mujeres adolescentes con hijas e hijos.</p><p>Esta información se vuelve sustantiva, si consideramos que en edad de 10 a 14 años ya se existen registro de nacimientos, dato relevante si se cruza con otras variables como el registro de incidentes de violencia sexual, que en mediciones oficiales de justicia o seguridad, esta subrepresentado por una escasa denuncia o no simplemente no se contempla.</p></div></div><download-button json=\"vm.json\" ng-show=\"vm.json.length > 0\"></download-button><continuar-leyendo opciones=\"vm.opciones\"></continuar-leyendo>");
$templateCache.put("app/components/narrativa/narrativaComponent.html","<div class=\"narrativa\" ng-class=\"{\'inverse\' : vm.inverse}\"><div class=\"resumen\" style=\"background:rgb({{vm.color[0]+\',\'+vm.color[1]+\',\'+vm.color[2]}})\"><div><h2>{{vm.state}}</h2><p>{{vm.resumen}}</p><a class=\"btn leer\" style=\"color:rgb({{vm.color[0]+\',\'+vm.color[1]+\',\'+vm.color[2]}}) !important\" ui-sref=\"narrativa-{{vm.link;}}\">LEER INVESTIGACIÓN</a></div></div><div class=\"video\" ng-show=\"vm.portada != \'\'\"><div class=\"portada\" style=\"background:url(\'./assets/images/portadas/{{vm.portada}}.png\')\"><div class=\"mask\" ng-click=\"vm.showVideo(vm.video);\" ng-if=\"vm.state != \'Aguascalientes\'\">Ver video</div><svg class=\"start-video\" width=\"40px\" height=\"40px\" viewbox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ng-if=\"vm.state != \'Aguascalientes\'\" ng-click=\"vm.showVideo(vm.video);\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Single_narrativas_Chiapas\" transform=\"translate(-949.000000, -1795.000000)\"><g id=\"Group-41\" transform=\"translate(0.000000, 1507.000000)\"><g id=\"Group-5\" transform=\"translate(949.000000, 288.000000)\"><ellipse id=\"Oval-2\" fill=\"#FFFFFF\" opacity=\"0.799999952\" cx=\"19.8543843\" cy=\"19.9087894\" rx=\"19.8543843\" ry=\"19.9087894\"></ellipse><path d=\"M17.1042091,27.8743279 C15.8398116,28.6040071 14.8148148,28.0183261 14.8148148,26.5632611 L14.8148148,13.4557394 C14.8148148,12.001978 15.8540623,11.4009285 17.1213849,12.1051152 L28.7272966,18.5539297 C30.0011801,19.2617619 30.006988,20.4281813 28.7444724,21.1567744 L17.1042091,27.8743279 Z\" id=\"Stroke-3\" fill=\"rgb({{vm.color[0]+\',\'+vm.color[1]+\',\'+vm.color[2]}})\"></path></g></g></g></g></svg></div></div></div>");
$templateCache.put("app/components/narrativa/videoTmpl.html","<iframe class=\"iframeVideo\" id=\"iframe\" ng-src=\"{{video}}\"></iframe>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);